/* eslint-disable no-shadow */
/* eslint-disable arrow-body-style */
/* eslint-disable no-await-in-loop */
/* eslint-disable consistent-return */
/* eslint-disable no-else-return */
/* eslint-disable no-nested-ternary */
/* eslint-disable prefer-promise-reject-errors */

import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { React, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

// @mui
import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Unstable_Grid2';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import { alpha } from '@mui/material/styles';
import FormControlLabel from '@mui/material/FormControlLabel';

//   utils
import { fData } from 'src/utils/format-number';
import MaskedInput from 'src/utils/MaskedInput';
import UniqueTextField from 'src/components/unique-text-field/UniqueTextField';

//  components

import Iconify from 'src/components/iconify';
import { useSnackbar } from 'src/components/snackbar';
import { UploadBox } from 'src/components/upload';
import { useRouter } from 'src/routes/hooks';
import { paths } from 'src/routes/paths';
import { _tags } from 'src/_mock';
import FormProvider, {
  RHFTextField,
  RHFAutocomplete,
  RHFRadioGroup,
  RHFUploadBox,
  RHFUploadAvatar,
} from 'src/components/hook-form';
import {
  Alert,
  Chip,
  createFilterOptions,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputAdornment,
  Step,
  StepLabel,
  CircularProgress,
  Stepper,
  Switch,
  Tooltip,
} from '@mui/material';
import { decryptData, encryptData } from 'src/utils/Crypto';
import { DatePicker } from '@mui/x-date-pickers';
import { useBoolean } from 'src/hooks/use-boolean';
import { ConfirmDialog } from 'src/components/custom-dialog';
import axiosInstance from 'src/api/axiosInstance';
import useNavigateErrorHandler from 'src/hooks/useNavigateErrorHandler';
import { fetchEncryptedToken } from 'src/utils/encryptUtils';

import { useEmpMasterData } from 'src/hooks/useEmpMasterData';
import { useEmpMasterDataPrefetch } from 'src/hooks/useEmpMasterDataPrefetch';
import { invalidateStepCache } from 'src/redux/slices/masterDataSlice';
import { isValid, parseISO } from 'date-fns';
import PassportNewEditForm from './passport-new-edit-form';
import FamilyRelationNewEditForm from './family-relation-new-edit-form';
import EmergencyContactNewEditForm from './emergency-contact-new-edit-form';
import EmpEduNewEditForm from './emp-edu-new-edit-form';
import EmpExpNewEditForm from './emp-exp-new-edit-form';
import EmpCertNewEditForm from './emp-cert-new-edit-form';
import EmpRefNewEditForm from './emp-ref-new-edit-form';
import EmpLangNewEditForm from './emp-lang-new-edit-form';
import EmpVisaNewEditForm from './emp-visa-new-edit-form';
import EmpRelwrknwithusNewEditForm from './emp-relwrknwithus-new-edit-form';
import EmpBankNewEditForm from './emp-bank-new-edit-form';
import EmpImpqueNewEditForm from './emp-impque-new-edit-form';

export default function EmployeeNewEditForm({
  currentEmpFam,
  currentEmpPass,
  currentEmpBank,
  currentEmpEdu,
  currentEmpVisa,
  currentEmpCert,
  currentEmpWrk,
  currentEmpLang,
  currentEmpEmrg,
  currentEmpRef,
  currentEmpExp,
  currentEmpImpQ,
  currentEmp,
  currentEmpView,
  disabled,
}) {
  const token = sessionStorage.getItem('token');
  const router = useRouter();
  const user = JSON.parse(localStorage.getItem('user'));
  const subscr = JSON.parse(localStorage.getItem('selectedSubscrSite'));

  const loadingSend = useBoolean();
  // eslint-disable-next-line no-restricted-globals
  const isUnderReview = window.location.pathname.includes('EmpUnderReviewEdit') || window.location.pathname.includes('under-review') || window.location.pathname.includes('underReview');
  const [duplicateFields, setDuplicateFields] = useState({});

  const handleDuplicateStatusChange = (fieldKey) => (isDuplicate) => {
    setDuplicateFields((prev) => {
      const updated = { ...prev };
      if (isDuplicate) {
        updated[fieldKey] = true;
      } else {
        delete updated[fieldKey];
      }
      return updated;
    });
  };

  const hasDuplicates = Object.values(duplicateFields).some(Boolean);

  const confirm = useBoolean();
  const { enqueueSnackbar } = useSnackbar();
  const [savedEmployeeId, setSavedEmployeeId] = useState(null);
  const [srcOfHrArr, setSrcOfHrArr] = useState([]);
  const [genderArr, setGenderArr] = useState([]);
  const [desgntnArr, setDesgntnArr] = useState([]);
  const [countryArr, setCountryArr] = useState([]);
  const [curCityArr, setCurCityArr] = useState([]);
  const [perCityArr, setPerCityArr] = useState([]);
  const [rawCityArr, setRawCityArr] = useState([]);
  const [qualArr, setQualArr] = useState([]);
  const [nmTitleArr, setNmTitleArr] = useState([]);
  const [universityArr, setUniversityArr] = useState([]);
  const [qualTypeArr, setQualTypeArr] = useState([]);
  const [streamArr, setStreamArr] = useState([]);
  const [curStateArr, setCurStateArr] = useState([]);
  const [perStateArr, setPerStateArr] = useState([]);
  const [langArr, setLangArr] = useState([]);
  const [bloodGrpArr, setBloodGrpArr] = useState([]);
  const [relshnshipArr, setRelshnshipArr] = useState([]);
  const [relgnArr, setRelgnArr] = useState([]);
  const [empTypArr, setEmpTypArr] = useState([]);
  const [empGradeArr, setEmpGradeArr] = useState([]);
  const [unitOfMsrArr, setUnitOfMsrArr] = useState([]);
  const handleApiError = useNavigateErrorHandler();
  const [maritalStArr, setMaritalStArr] = useState([]);
  const [visaTypArr, setVisaTypArr] = useState([]);
  const [visaNmArr, setVisaNmArr] = useState([]);
  const [bankNmArr, setBankNmArr] = useState([]);
  const [bankTypArr, setBankTypArr] = useState([]);
  const [impQueArr, setImpQueArr] = useState([]);
  const [impQues, setImpQues] = useState([]);
  const [certNmArr, setCertNmArr] = useState([]);
  const [certInstNmArr, setCertInstNmArr] = useState([]);
  const [isSameAsCurrent, setIsSameAsCurrent] = useState(false);
  const [offeredCand, setOfferedCand] = useState([]);
  const [lastUpdatedDateCand, setLastUpdatedDateCand] = useState(new Date());
  const isInitializedNewEmpRef = useRef(false);
  const [curEmpCode, setCurEmpCode] = useState('');
  const [curEmpPic, setCurEmpPic] = useState(false);
  const [isFileTooLarge, setIsFileTooLarge] = useState(false);
  const maxSizeOfDocs = useSelector((state) => state.tenantPreference?.maxSizeOfDocuments || 3);
  const [statesAvailable, setStatesAvailable] = useState(false);
  const [citiesAvailable, setCitiesAvailable] = useState(false);
  const [selectedEmpType, setSelectedEmpType] = useState(null);

  const [EmpExp, setEmpExp] = useState([]);
  const [EmpRef, setEmpRef] = useState([]);
  const [EmpEmrg, setEmpEmrg] = useState([]);
  const [EmpLang, setEmpLang] = useState([]);
  const [EmpWrk, setEmpWrk] = useState([]);
  const [EmpCert, setEmpCert] = useState([]);
  const [EmpVisa, setEmpVisa] = useState([]);
  const [EmpEdu, setEmpEdu] = useState([]);
  const [EmpBank, setEmpBank] = useState([]);
  const [EmpPass, setEmpPass] = useState([]);
  const [EmpFam, setEmpFam] = useState([]);
  const [EmpImpQ, setEmpImpQ] = useState([]);

  const [isSavingOnly, setIsSavingOnly] = useState(false);
  const [isSavingNext, setIsSavingNext] = useState(false);
  const [savingAction, setSavingAction] = useState(null); // null, 'saveOnly', or 'saveNext'
  const [isProfilePhotoRemoved, setIsProfilePhotoRemoved] = useState(false);

  const [profilePhotoUrl, setProfilePhotoUrl] = useState(null);
  const [candProfilePhoto, setCandProfilePhoto] = useState(null);

  const [confirmOpen, setConfirmOpen] = useState(false);

  const openConfirmDialog = () => setConfirmOpen(true);
  const closeConfirmDialog = () => setConfirmOpen(false);

  // ---------------------------------------------------------------------------------------------------------------------------------
  const steps = [
    'Basic Details',
    'Personal & Family Details',
    'Address & Contact Details',
    'Education & Certification Details',
    'Passport & Visa Details',
    'Experience & Reference Details',
    'Bank Details',
    'Other Details',
  ];

  const [switchState, setSwitchState] = useState({
    experience: false,
    passport: false,
    visa: false,
  });

  const stepsvalidator = useMemo(
    () => [
      {
        label: 'Basic Details',
        fields: {
          ...(!currentEmp ? { candidate: '' } : {}),
          empTyp: '',
          dateOfJoin: '',
          empGrade: '',
          designation: '',
        },
      },
      {
        label: 'Personal & Family Details',
        fields: {
          fname: '',
          lname: '',
          gender: '',
          email: '',
          mobno: '',
          panno: '',
          aadharno: '',
          empFamilyRel: '',
        },
      },
      {
        label: 'Address & Contact Details',
        fields: {
          curAddLn1: '',
          curAddLn2: '',
          curAddCntr: '',
          curAddState: '',
          curAddCity: '',
          curAddLandLn: '',
          curAddZip: '',
          permAddLn1: '',
          permAddLn2: '',
          permAddCntr: '',
          permAddState: '',
          permAddCity: '',
          permAddLandLn: '',
          permAddZip: '',
          empEmrgncyContact: '',
        },
      },
      {
        label: 'Education & Certification Details',
        fields: {
          empEdu: '',
          empCert: '',
          empLang: '',
        },
      },
      {
        label: 'Passport & Visa Details',
        fields: {
          ...(switchState.passport ? { empPassport: '' } : {}),
          ...(switchState.visa ? { empVisa: '' } : {}),
        },
      },
      {
        label: 'Experience & Reference Details',
        fields: {
          ...(switchState.experience ? { empExp: '' } : {}),
          empRef: '',
        },
      },
      {
        label: 'Bank Details',
        fields: {
          empBank: '',
        },
      },
      {
        label: 'Other Details',
        fields: {
          srcofhire: '',
          empRelWrkn: '',
        },
      },
    ],
    [switchState, currentEmp]
  );

  const [activeStep, setActiveStep] = useState(0);

  const dispatch = useDispatch();

  // ─── STEP-WISE MASTER DATA HOOKS ─────────────────────────────────────────────
  // Must be declared AFTER activeStep useState to avoid Temporal Dead Zone error.
  // Fetches master data ONLY for the current activeStep (lazy, per-step loading).
  const {
    data: activeMasterData,
    isLoading: isMasterDataLoading,
    refresh: refreshStepData,
  } = useEmpMasterData(activeStep);
  // Silently prefetches next step's master data in the background.
  useEmpMasterDataPrefetch(activeStep);

  useEffect(() => {
    // On mount: write current step so rhf-autocomplete can read it
    localStorage.setItem('activeStep_new', String(activeStep));
  }, [activeStep]);
  useEffect(
    () => () => {
      // On unmount: clear step cache (fresh fetch on next open) AND clean localStorage
      [0, 1, 2, 3, 4, 5, 6, 7].forEach((step) => {
        dispatch(invalidateStepCache({ formType: 'emp', step }));
      });
      localStorage.removeItem('activeStep_new');
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  // ─────────────────────────────────────────────────────────────────────────────
  const [skipped, setSkipped] = useState();
  const [stepCompletionStatus, setStepCompletionStatus] = useState(
    new Array(steps.length).fill(null)
  );
  const [progress, Setprogress] = useState(0);
  const [isFinalStep, setIsFinalStep] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);

  const [basicDetailsProcessed, setBasicDetailsProcessed] = useState(false); // Step 0

  const [personalDetailsProcessed, setPersonalDetailsProcessed] = useState(false); // Step 1
  const [familyDetailsProcessed, setFamilyDetailsProcessed] = useState(false); // Step 1

  const [curPerAddressProcessed, setCurPerAddressProcessed] = useState(false); // Step 2
  const [emergencyContactProcessed, setEmergencyContactProcessed] = useState(false); // Step 2

  const [educationDetailsProcessed, setEducationDetailsProcessed] = useState(false); // Step 3
  const [certificationDetailsProcessed, setCertificationDetailsProcessed] = useState(false); // Step 3
  const [languageDetailsProcessed, setLanguageDetailsProcessed] = useState(false); // Step 3

  const [passportDetailsProcessed, setPassportDetailsProcessed] = useState(false); // Step 4
  const [visaDetailsProcessed, setVisaDetailsProcessed] = useState(false); // Step 4

  const [experienceDetailsProcessed, setExperienceDetailsProcessed] = useState(false); // Step 5
  const [referenceDetailsProcessed, setReferenceDetailsProcessed] = useState(false); // Step 5

  const [bankDetailsProcessed, setBankDetailsProcessed] = useState(false); // Step 6

  const [otherDetailsProcessed, setOtherDetailsProcessed] = useState(false); // Step 7
  const [relativeDetailsProcessed, setRelativeDetailsProcessed] = useState(false); // Step 7

  // Example of resetting the flag when user navigates away from the section
  const handleStepChange = (newStep) => {
    if (newStep !== activeStep) {
      // Reset the flag if the user is moving to a different section
      setBasicDetailsProcessed(false);
      setPersonalDetailsProcessed(false);
      setFamilyDetailsProcessed(false);
      setCurPerAddressProcessed(false);
      setEmergencyContactProcessed(false);
      setEducationDetailsProcessed(false);
      setCertificationDetailsProcessed(false);
      setLanguageDetailsProcessed(false);
      setPassportDetailsProcessed(false);
      setVisaDetailsProcessed(false);
      setExperienceDetailsProcessed(false);
      setReferenceDetailsProcessed(false);
      setBankDetailsProcessed(false);
      setOtherDetailsProcessed(false);
      setRelativeDetailsProcessed(false);
    }
    setActiveStep(newStep);
  };

  // --------------------------------------------------------------------------------------------------------------------------------------
  const yesNoArr = [
    { value: 'true', label: 'Yes' },
    { value: 'false', label: 'No' },
  ];

  const NewEmployeeSchema = Yup.object().shape({
    ...(activeStep >= 0 && {
      candidate: currentEmp ? Yup.mixed().notRequired() : Yup.object().required('Candidate is required'),
      empTyp: Yup.object()
        .shape({
          masterId: Yup.number().required(),
          masterName: Yup.string().required(),
        })
        .nullable()
        .required('Employment type is required'),

      empGrade: Yup.lazy((value, { parent }) => {
        const empTypName = parent?.empTyp?.masterName;
        const isRequired = ['Freelance', 'Full-time Employment'].includes(empTypName);

        return isRequired
          ? Yup.object().required('Employment grade is required')
          : Yup.mixed().notRequired();
      }),
      dateOfJoin: Yup.date()
        .required('Date of joining is required')
        .typeError('Date of joining must be a valid date')
        .test('no-past-date', 'Date of joining cannot be a past date', (value, context) => {
          if (!value) return true;
          if (currentEmp) return true;
          return new Date(value).setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0);
        }),
      designation: Yup.object().required('Designation is required'),
    }),
    ...(activeStep >= 1 && {
      fname: Yup.string()
        .required('First name is required. For example: Rajesh')
        .max(100, 'First name must not exceed 100 characters. For example: Rajesh or Priya')
        .test(
          'no-spaces',
          'First name cannot be only blank spaces or start/end with blank spaces. For example: "Rajesh" is valid, but "  Rajesh  " is not.',
          (value) => value.trim() !== '' && value === value.trim()
        )
        .matches(
          /^[a-zA-Z\s]*$/,
          'First name cannot contain numbers or special characters. For example: "Rajesh" is valid, but "Rajesh123" or "Rajesh@#" is not.'
        ),
      mname: Yup.string()
        .max(100, 'Middle name must not exceed 100 characters. For example: Kumar')
        .test(
          'no-spaces-mid',
          'Middle name cannot be only blank spaces or start/end with blank spaces. For example: "Kumar" is valid, but "  Kumar  " is not.',
          (value) => {
            if (!value) return true;
            return value.trim() !== '' && value === value.trim();
          }
        )
        .matches(
          /^[a-zA-Z\s]*$/,
          'Middle name cannot contain numbers or special characters. For example: "Kumar" is valid, but "Kumar123" or "Kumar@#" is not.'
        ),
      lname: Yup.string()
        .required('Last name is required. For example: Gupta')
        .max(100, 'Last name must not exceed 100 characters. For example: Gupta or Sharma')
        .test(
          'no-spaces',
          'Last name cannot be only blank spaces or start/end with blank spaces. For example: "Gupta" is valid, but "  Gupta  " is not.',
          (value) => value.trim() !== '' && value === value.trim()
        )
        .matches(
          /^[a-zA-Z\s]*$/,
          'Last name cannot contain numbers or special characters. For example: "Gupta" is valid, but "Gupta123" or "Gupta@#" is not.'
        ),
      gender: Yup.object().required('Gender is required'),
      email: Yup.string()
        .required('Email is required')
        .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, 'Email must be a valid email address')
        .max(100, 'Email must not exceed 254 characters'),
      mobno: Yup.string()
        .required('Mobile number is required. For example: 9876543210')
        .max(12, 'Enter a valid mobile number. For example: 9876543210')
        .min(10, 'Enter a valid mobile number. For example: 9876543210')
        .test('phncode-required', 'Country Code is required', (value, context) => {
          // Arrow function
          const { phncode } = context.parent; // Extract phncode from context.parent
          if (!phncode) {
            return false;
          }
          return true; // If country code is valid
        }),
      aadharno: Yup.string()
        .required('Aadhaar number is required')
        .test('no-blank-aadhaar', 'Aadhaar number is required', (value) => Boolean(value && value.trim()))
        .matches(/^[0-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$/, 'Aadhaar number is not valid (e.g., "234512345678")'),
      panno: Yup.string()
        .required('PAN card number is required')
        .test('no-blank-pan', 'PAN card number is required', (value) => Boolean(value && value.trim()))
        .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 'PAN card number is not valid (e.g., "ABCDE1234F")'),

      pfno: Yup.string().test(
        'is-valid-pfno',
        'PF(UAN) number is not valid (e.g., "123456789012" or "ABCDE123456F")',
        (value) => {
          if (!value) return true; // Allow empty values

          const uanPattern = /^\d{12}$/; // 12-digit number
          const pfPattern = /^[A-Z]{5}\d{6}[A-Z]$/; // e.g., ABCDE123456F

          return uanPattern.test(value) || pfPattern.test(value);
        }
      ),
      pranno: Yup.string().test(
        'is-valid-pranno',
        'PRAN number must be 12 digits long (e.g., "123456789012")',
        (value) => {
          if (!value) return true; // Allow empty values
          return value.length === 12 && /^[0-9]{12}$/.test(value);
        }
      ),
      linkedinLink: Yup.string()
        .notRequired()
        .test(
          'is-valid-url',
          'Enter a valid LinkedIn profile URL (e.g., "https://www.linkedin.com/in/firstname-lastname/")',
          (value) => {
            if (!value) return true;
            const regex =
              /[-a-zA-Z0-9@:%_+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_+.~#?&//=]*)?/gi;
            return regex.test(value) && value.includes('linkedin.com');
          }
        ),
      dateOfBirth: Yup.date()
        .nullable()
        .typeError('Date of birth must be a valid date')
        .test('no-future-date', 'Date of birth cannot be a future date', (value, context) => {
          if (!value) return true;
          if (currentEmp && currentEmp.dateOfBirth) {
            if (
              new Date(currentEmp.dateOfBirth).setHours(0, 0, 0, 0) ===
              new Date(value).setHours(0, 0, 0, 0)
            )
              return true;
          }
          return new Date(value).setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0);
        }),
      placeOfBirth: Yup.string()
        .max(100, 'Place of birth must not exceed 100 characters')
        .test(
          'no-spaces',
          'Place of birth cannot be just spaces or start/end with blank spaces',
          (value) => {
            if (value === '') return true;
            return value.trim() !== '' && value === value.trim();
          }
        )
        .matches(/^[a-zA-Z\s]*$/, 'Place of birth cannot contain numbers or special characters'),
      nationality: Yup.string()
        .max(100, 'Nationality must not exceed 100 characters')
        .matches(/^[A-Za-z\s]*$/, 'Nationality must contain only letters'),
      height: Yup.number()
        .min(0, 'Height cannot be in negetive')
        .max(260, 'Height cannot be more then 260 cm'),
      weight: Yup.number()
        .min(0, 'Weight cannot be in negetive')
        .max(700, 'Weight cannot be more then 700 kg'),
    }),
    ...(activeStep >= 2 && {
      curAddLn1: Yup.string()
        .required('Current Address line 1 is required')
        .max(200, 'Current Address must not exceed 200 characters')
        .test(
          'no-spaces',
          'Current Address line 1 cannot be just spaces or start/end with blank spaces',
          (value) => value.trim() !== '' && value === value.trim()
        ),

      curAddLn2: Yup.string().max(100, 'Address Line 2 must be at most 100 characters'),

      curAddCntr: Yup.object().required('Permanent Country is required'),

      curAddState: Yup.lazy((value) =>
        curStateArr.length === 0
          ? Yup.mixed().notRequired()
          : Yup.object().required('Current State is required')
      ),

      curAddCity: Yup.lazy((value) =>
        curCityArr.length === 0
          ? Yup.mixed().notRequired()
          : Yup.object().required('Current City is required')
      ),

      curAddLandLn: Yup.string()
        .test('is-numeric', 'Land line number must be numeric (e.g., "0123456789")', (value) => {
          if (value === '') return true; // Allow empty values
          return /^\d+$/.test(value);
        })
        .test(
          'is-valid',
          'Land line number must be 10-11 digits and not all zeros (e.g., "0123456789")',
          (value) => {
            if (value === '') return true; // Allow empty values
            return !/^[0]+$/.test(value) && value.length >= 10 && value.length <= 11;
          }
        ),
      permAddLn1: Yup.string()
        .required('Permanent Address line 1 is required')
        .max(100, 'Permanent Address must not exceed 100 characters')
        .test(
          'no-spaces',
          'Permanent Address line 1 cannot be just spaces or start/end with blank spaces (e.g., "123 MG Road")',
          (value) => value.trim() !== '' && value === value.trim()
        ),

      permAddLn2: Yup.string().max(100, 'Permanent Address Line 2 must be at most 100 characters'),

      permAddCntr: Yup.object().required('Permanent Country is required'),

      permAddState: Yup.mixed().when('permAddStateAvailable', {
        is: true,
        then: (schema) => schema.required('Permanent Address State is required'),
        otherwise: (schema) => schema.notRequired(),
      }),

      permAddCity: Yup.mixed().when('permAddCityAvailable', {
        is: true,
        then: (schema) => schema.required('Permanent Address City is required'),
        otherwise: (schema) => schema.notRequired(),
      }),

      permAddLandLn: Yup.string()
        .test('is-numeric', 'Land line number must be numeric (e.g., "0123456789")', (value) => {
          if (value === '') return true;
          return /^\d+$/.test(value);
        })
        .test('is-valid', 'Land line number must be valid (e.g., "0123456789")', (value) => {
          if (value === '') return true;
          return !/^[0]+$/.test(value) && value.length >= 10 && value.length <= 11;
        }),
    }),
    ...(activeStep >= 7 && {
      srcofhire: Yup.object().required('Source of hire is required'),
    }),
    ...(activeStep >= 4 && {
      empPassport: Yup.array()
        .of(
          Yup.object().shape({
            passNo: Yup.string()
              .required('Passport number is required')
              .matches(
                /^[A-Z0-9]{6,9}$/,
                'Passport must be 6–9 characters long, using letters and digits (e.g., A1234567, AB123456)'
              ),
            issuePlace: Yup.object().required('Place of issue is required'),
            issueDt: Yup.date()
              .nullable()
              .typeError('Issue date must be a valid date')
              .test(
                'no-future-date',
                'Passport issue date cannot be a future date',
                (value, context) => {
                  if (!value) return true;
                  if (currentEmpPass && context.parent.passSrno > 0) {
                    const orig = currentEmpPass.find(
                      (x) => x.empPassportId === context.parent.passSrno
                    );
                    if (
                      orig &&
                      orig.dateOfIssue &&
                      new Date(orig.dateOfIssue).setHours(0, 0, 0, 0) ===
                      new Date(value).setHours(0, 0, 0, 0)
                    )
                      return true;
                  }
                  return new Date(value).setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0);
                }
              ),
            expiryDt: Yup.date()
              .nullable()
              .typeError('Expiry date must be a valid date')
              .min(Yup.ref('issueDt'), 'Expiry Date should be greater than issued date'),
          })
        )
        .test(
          'unique-passport',
          null, // We won't provide a default error message here
          (value, context) => {
            if (!value) return true; // If the array is empty or undefined, consider it valid
            const seen = new Set();
            const errors = [];
            value.forEach((entry, index) => {
              const passNo = entry.passNo;
              if (!passNo) return;
              if (seen.has(passNo)) {
                errors.push(index); // Track the index of the duplicate entry
              } else {
                seen.add(passNo);
              }
            });
            if (errors.length) {
              // Return false to indicate that validation failed
              return context.createError({
                path: `empPassport[${errors[0]}].passNo`, // Point to the first duplicate found
                message: 'You have already added this passport details.',
              });
            }
            return true;
          }
        ),
    }),
    ...(activeStep >= 2 && {
      empEmrgncyContact: Yup.array()
        .of(
          Yup.object().shape({
            name: Yup.string()
              .required('Full name is required (e.g., "Rakesh Mohan Gupta")')
              .max(100, 'Full name must not exceed 100 characters')
              .test(
                'no-spaces',
                'Full name cannot be just spaces or start/end with blank spaces',
                (value) => value && value.trim() !== '' && value === value.trim()
              )
              .matches(/^[a-zA-Z\s]*$/, 'Full name cannot contain numbers or special characters'),

            email: Yup.string()
              .required('Email is required')
              .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, 'Email must be a valid email address')
              .max(100, 'Email must not exceed 100 characters'),

            mobno: Yup.string()
              .required('Contact Number is required')
              .min(10, 'Enter valid Contact Number')
              .max(12, 'Enter valid Contact Number'),

            curAddCntr: Yup.object().required('Country is required'),

            ...(statesAvailable && {
              curAddState:
                countryArr.length === 0
                  ? Yup.mixed().notRequired()
                  : Yup.object().required('State is required'),
            }),
            ...(citiesAvailable && {
              curAddCity:
                countryArr.length === 0
                  ? Yup.mixed().notRequired()
                  : Yup.object().required('City is required'),
            }),
            curAddZip: Yup.string().test(
              'len',
              'Zip Code must be exactly 6 digits',
              (val) => !val || /^\d{6}$/.test(val)
            ),
          })
        )
        .test(
          'unique-emrgncy',
          null, // We won't provide a default error message here
          (value, context) => {
            if (!value) return true; // If the array is empty or undefined, consider it valid
            const seen = new Set();
            const mobnoSet = new Set();
            const errors = [];
            const mobnoErrors = [];
            value.forEach((entry, index) => {
              const passNo = entry.name?.toLowerCase();
              const mobno = entry.mobno?.toLowerCase();
              if (passNo && seen.has(passNo)) {
                errors.push(index); // Track the index of the duplicate entry
              } else {
                seen.add(passNo);
              }
              if (mobno && mobnoSet.has(mobno)) {
                mobnoErrors.push(index);
              } else if (mobno) {
                mobnoSet.add(mobno);
              }
            });
            if (errors.length) {
              // Return false to indicate that validation failed
              return context.createError({
                path: `empEmrgncyContact[${errors[0]}].name`, // Point to the first duplicate found
                message: 'You have already added this Emergency contact details.',
              });
            }
            if (mobnoErrors.length) {
              // Return false to indicate that validation failed for mobno
              return context.createError({
                path: `empEmrgncyContact[${mobnoErrors[0]}].mobno`,
                message: 'You have already added this Emergency contact mobile number.',
              });
            }
            return true;
          }
        ),
      curAddZip: Yup.string()
        .test('len', 'Zip Code must be exactly 6 digits', (val) => !val || /^\d{6}$/.test(val)),
      permAddZip: Yup.string()
        .test('len', 'Zip Code must be exactly 6 digits', (val) => !val || /^\d{6}$/.test(val)),
    }),
    ...(activeStep >= 3 && {
      empCert: Yup.array()
        .of(
          Yup.object().shape({
            certiNm: Yup.string()
              .required('Certification name is required')
              .max(100, 'Certification name must not exceed 100 characters')
              .test(
                'no-spaces',
                'Certification name cannot be just spaces or start/end with blank spaces',
                (value) => value.trim() !== '' && value === value.trim()
              ),
            certfromDate: Yup.date()
              .nullable()
              .typeError('From date must be a valid date')
              .test('no-future-date', 'From date cannot be a future date', (value, context) => {
                if (!value) return true;
                if (currentEmpCert && context.parent.cerSrno > 0) {
                  const orig = currentEmpCert.find(
                    (x) => x.employeeCertificationId === context.parent.cerSrno
                  );
                  if (
                    orig &&
                    orig.durationFrom &&
                    new Date(orig.durationFrom).setHours(0, 0, 0, 0) ===
                    new Date(value).setHours(0, 0, 0, 0)
                  )
                    return true;
                }
                return new Date(value).setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0);
              }),
            certtoDate: Yup.date()
              .nullable()
              .typeError('To date must be a valid date')
              .test('no-future-date', 'To date cannot be a future date', (value, context) => {
                if (!value) return true;
                if (currentEmpCert && context.parent.cerSrno > 0) {
                  const orig = currentEmpCert.find(
                    (x) => x.employeeCertificationId === context.parent.cerSrno
                  );
                  if (
                    orig &&
                    orig.durationTo &&
                    new Date(orig.durationTo).setHours(0, 0, 0, 0) ===
                    new Date(value).setHours(0, 0, 0, 0)
                  )
                    return true;
                }
                return new Date(value).setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0);
              })
              .min(Yup.ref('certfromDate'), 'To Date should be greater than from date'),
          })
        )
        .test(
          'unique-certification',
          null, // We won't provide a default error message here
          (value, context) => {
            if (!value) return true; // If the array is empty or undefined, consider it valid
            const seen = new Set();
            const errors = [];
            value.forEach((entry, index) => {
              const certTitle = entry.certiNm;
              const instituteTitle = entry.certiInstiNm;
              if (!certTitle || !instituteTitle) return;
              const identifier = `${certTitle}-${instituteTitle}`;
              if (seen.has(identifier)) {
                errors.push(index); // Track the index of the duplicate entry
              } else {
                seen.add(identifier);
              }
            });
            if (errors.length) {
              // Return false to indicate that validation failed
              return context.createError({
                path: `empCert[${errors[0]}].certiNm`, // Point to the first duplicate found
                message:
                  'You have already selected this certification and institute in your certification details.',
              });
            }
            return true;
          }
        ),
    }),
    ...(activeStep >= 5 &&
      switchState.experience && {
      empExp: Yup.array()
        .of(
          Yup.object().shape({
            compNm: Yup.string()
              .required('Employer Name is required (e.g., "Infosys", "Wipro")')
              .max(100, 'Employer Name must not exceed 100 characters')
              .test(
                'no-spaces',
                'Employer name cannot be just spaces or start/end with blank spaces (e.g., "Infosys", "Wipro")',
                (value) => value.trim() !== '' && value === value.trim()
              ),
            designation: Yup.object().required('Designation is required'),
            ctc: Yup.number()
              .transform((value, originalValue) =>
                originalValue === '' || originalValue === null || originalValue === undefined
                  ? null
                  : Number(originalValue)
              )
              .nullable()
              .notRequired()
              .typeError('CTC must be a valid number')
              .min(0, 'CTC cannot be negative')
              .max(2000000000, 'CTC cannot be more than 2000000000')
              .test(
                'noEOrSign', // type of the validator (should be unique)
                "Number had an 'e' or sign.", // error message
                (value) =>
                  value === null ||
                  value === undefined ||
                  (typeof value === 'number' && !/[eE+-]/.test(value.toString()))
              )
              .test('phncode-required', 'CTC currency is required', (value, context) => {
                // Arrow function
                const { ctccurncy } = context.parent; // Extract phncode from context.parent
                if (value && !ctccurncy) {
                  // If both mobile number and country code are missing
                  return false;
                }
                return true; // If country code is valid
              }),
            expfromDate: Yup.date()
              .required('From date is required')
              .typeError('From date must be a valid date')
              .test('no-future-date', 'From date cannot be a future date', (value, context) => {
                if (!value) return true;
                if (currentEmpExp && context.parent.expSrno > 0) {
                  const orig = currentEmpExp.find((x) => x.id === context.parent.expSrno);
                  if (
                    orig &&
                    orig.durationFrom &&
                    new Date(orig.durationFrom).setHours(0, 0, 0, 0) ===
                    new Date(value).setHours(0, 0, 0, 0)
                  )
                    return true;
                }
                return new Date(value).setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0);
              })
              .test(
                'less-than-to-date',
                'From date must be less than To date',
                (value, context) => {
                  if (!value) return true;
                  const isCurrentlyWorking =
                    context.parent?.currentywrkng === true ||
                    context.parent?.currentywrkng === 'true';
                  if (isCurrentlyWorking) return true;

                  const toDate = context.parent?.exptoDate;
                  if (!toDate) return true;
                  const fromDateObj = new Date(value);
                  const toDateObj = new Date(toDate);
                  if (Number.isNaN(fromDateObj.getTime()) || Number.isNaN(toDateObj.getTime())) {
                    return true;
                  }
                  return fromDateObj.setHours(0, 0, 0, 0) < toDateObj.setHours(0, 0, 0, 0);
                }
              ),
            exptoDate: Yup.date()
              .nullable()
              .when('currentywrkng', {
                is: (val) => val === true || val === 'true',
                then: (schema) => schema.nullable().notRequired(),
                otherwise: (schema) =>
                  schema
                    .required('To date is required')
                    .typeError('To date must be a valid date')
                    .test(
                      'greater-than-from-date',
                      'To date must be greater than From date',
                      (value, context) => {
                        if (!value) return true;
                        const fromDate = context.parent?.expfromDate;
                        if (!fromDate) return true;
                        const toDateObj = new Date(value);
                        const fromDateObj = new Date(fromDate);
                        if (Number.isNaN(toDateObj.getTime()) || Number.isNaN(fromDateObj.getTime())) {
                          return true;
                        }
                        return toDateObj.setHours(0, 0, 0, 0) > fromDateObj.setHours(0, 0, 0, 0);
                      }
                    )
                    .test(
                      'min-date-one-month',
                      'To Date should be at least 1 month after From Date',
                      (value, context) => {
                        if (!value) return true;
                        const fromDate = context.parent?.expfromDate;
                        if (!fromDate) return true;
                        const from = new Date(fromDate);
                        const to = new Date(value);
                        const oneMonthLater = new Date(from);
                        oneMonthLater.setMonth(oneMonthLater.getMonth() + 1);
                        return to.setHours(0, 0, 0, 0) >= oneMonthLater.setHours(0, 0, 0, 0);
                      }
                    )
                    .test('max-today', 'To date cannot be in the future', (value) => {
                      if (!value) return true;
                      return (
                        new Date(value).setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0)
                      );
                    }),
              }),
          })
        )
        // Overlapping date ranges validation on the whole array
        .test('no-overlapping-dates', function (empExpArray) {
          if (!empExpArray || empExpArray.length < 2) return true;

          const { createError } = this;

          const ranges = empExpArray
            .map((exp, idx) => {
              const from = exp.expfromDate ? new Date(exp.expfromDate).getTime() : null;
              let to = exp.exptoDate ? new Date(exp.exptoDate).getTime() : null;
              if ((exp.currentywrkng === true || exp.currentywrkng === 'true') && !to) {
                to = Infinity;
              }
              if (from === null || to === null) return null;
              return { idx, from, to };
            })
            .filter(Boolean);

          for (let i = 0; i < ranges.length; i += 1) {
            for (let j = i + 1; j < ranges.length; j += 1) {
              const r1 = ranges[i];
              const r2 = ranges[j];
              // Check if ranges overlap (including touching dates)
              if (r1.from <= r2.to && r2.from <= r1.to) {
                return createError({
                  path: `empExp[${r1.idx}].expfromDate`,
                  message: 'This experience overlaps with another experience date range.',
                });
              }
            }
          }

          return true;
        })
        .test(
          'unique-employer-designation',
          null, // We won't provide a default error message here
          (value, context) => {
            if (!value) return true; // If the array is empty or undefined, consider it valid
            const seen = new Set();
            const errors = [];
            value.forEach((entry, index) => {
              const company = entry.compNm;
              const desgn = entry.designation?.designationName;
              if (!company || !desgn) return;
              const identifier = `${company}-${desgn}`;
              if (seen.has(identifier)) {
                errors.push(index); // Track the index of the duplicate entry
              } else {
                seen.add(identifier);
              }
            });
            if (errors.length) {
              // Return false to indicate that validation failed
              return context.createError({
                path: `empExp[${errors[0]}].compNm`, // Point to the first duplicate found
                message:
                  'You have already selected this employer and designation in your experience details.',
              });
            }
            return true;
          }
        ),
    }),
    ...(activeStep >= 3 && {
      empEdu: Yup.array()
        .of(
          Yup.object().shape({
            university: Yup.object().required('Institute/University is required'),
            qualtype: Yup.object().required('Qualification type is required'),
            qualification: Yup.object().required('Qualification is required'),
            stream: Yup.object().required('Qualification Stream is required'),
            candpercnt: Yup.number()
              .min(0, 'Percentage cannot be less than 0%')
              .max(100, 'Percentage cannot be greater than 100%')
              .typeError('Percentage must be a valid number')
              .test(
                'max-2-decimals',
                'Enter percentage with a maximum of 2 decimal places (e.g., 89.75)',
                (value) => value === undefined || /^\d+(\.\d{1,2})?$/.test(value.toString())
              ),

            candcgpa: Yup.number()
              .min(0, 'CGPA cannot be less than 0')
              .max(10, 'CGPA cannot be greater than 10')
              .typeError('CGPA must be a valid number')
              .test(
                'max-2-decimals',
                'Enter CGPA with a maximum of 2 decimal places (e.g., 8.25)',
                (value) => value === undefined || /^\d+(\.\d{1,2})?$/.test(value.toString())
              ),

            edufromDate: Yup.date()
              .required('From date is required')
              .typeError('From date must be a valid date'),
            edutoDate: Yup.date()
              .nullable()
              .typeError('To date must be a valid date')
              .when('currentypurs', {
                is: (val) => val === true || val === 'true',
                then: (schema) => schema.nullable().notRequired(), // Skip validation when pursuing
                otherwise: (schema) =>
                  schema
                    .required('To date is required') // Make "To Date" required when not pursuing
                    .min(Yup.ref('edufromDate'), '"To Date" should be after "From Date"') // Ensure "To Date" is after "From Date"
                    .test(
                      'min-date-one-year',
                      '"To Date" should be at least 1 year greater than "From Date"',
                      function (value) {
                        if (!value) return true;
                        // eslint-disable-next-line react/no-this-in-sfc
                        const fromDate = this.parent.edufromDate; // Get "edufromDate" from parent context

                        // If either From Date or To Date is missing, return true (skip validation)
                        if (!fromDate || !value) return true;

                        // Convert to Date objects
                        const from = new Date(fromDate);
                        const to = new Date(value);

                        // Validate that To Date is at least 1 year after From Date
                        const oneYearLater = new Date(from.setFullYear(from.getFullYear() + 1));

                        return to >= oneYearLater; // Ensure To Date is at least 1 year greater than From Date
                      }
                    ),
              }),
          })
        )
        .test('unique-qualification-details', null, (value, context) => {
          if (!value || value.length === 0) return true;

          const seen = new Set();

          for (let index = 0; index < value.length; index += 1) {
            const entry = value[index];

            const qualificationTypeId = entry.qualtype?.masterId;
            const qualificationId = entry.qualification?.masterId;
            const streamId = entry.stream?.masterId;

            // Skip validation until all three values are selected
            if (!qualificationTypeId || !qualificationId || !streamId) {
              // eslint-disable-next-line no-continue
              continue;
            }

            // University is intentionally ignored
            const uniqueKey = `${qualificationTypeId}-${qualificationId}-${streamId}`;

            if (seen.has(uniqueKey)) {
              return context.createError({
                path: `empEdu[${index}].qualification`,
                message:
                  'Same Qualification Type, Qualification and Qualification Stream cannot be added multiple times.',
              });
            }

            seen.add(uniqueKey);
          }

          return true;
        })
        .test('max-currently-pursuing', null, (value, context) => {
          if (!value || value.length === 0) return true;

          const pursuingIndexes = value
            .map((education, index) => (education.currentypurs === true ? index : null))
            .filter((index) => index !== null);

          if (pursuingIndexes.length > 2) {
            return context.createError({
              path: `empEdu[${pursuingIndexes[2]}].currentypurs`,
              message: 'Maximum 2 employee education details can be marked as Currently Pursuing.',
            });
          }

          return true;
        }),
    }),
    ...(activeStep >= 5 && {
      empRef: Yup.array()
        .of(
          Yup.object().shape({
            refNm: Yup.string()
              .required('Reference name is required (e.g., "Rajesh Sahani")')
              .max(100, 'Reference must not exceed 100 characters')
              .test(
                'no-spaces',
                'Reference name cannot be just spaces or start/end with blank spaces (e.g., "Rajesh Sahani")',
                (value) => value.trim() !== '' && value === value.trim()
              )
              .matches(
                /^[a-zA-Z\s]*$/,
                'Reference name cannot contain numbers or special characters'
              ),
            refOrgNm: Yup.string()
              .required('Reference organization is required')
              .max(
                100,
                'Reference organization must not exceed 100 characters (e.g., "TCS", "Infosys")'
              )
              .test(
                'no-spaces',
                'Reference organization cannot be just spaces or start/end with blank spaces',
                (value) => value.trim() !== '' && value === value.trim()
              ),
            refdesig: Yup.object().required('Reference designation is required'),
            refEmail: Yup.string()
              .required('Reference email is required (e.g., "example@gmail.com")')
              .max(100, 'Email must not exceed 100 characters')
              .matches(
                /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
                'Email must be a valid email address (e.g., "john.doe@gmail.com")'
              ),

            refContact: Yup.string()
              .nullable()
              .test('is-valid-length', 'Enter valid mobile number', (value) => {
                if (!value) return true; // If the field is empty, don't validate
                return value.length >= 10 && value.length <= 12;
              }),
          })
        )
        .test(
          'unique-reference',
          null, // We won't provide a default error message here
          (value, context) => {
            if (!value) return true; // If the array is empty or undefined, consider it valid
            const seen = new Set();
            const errors = [];
            value.forEach((entry, index) => {
              const refNm = entry.refNm;
              const refOrg = entry.refOrgNm;
              if (!refNm || !refOrg) return;
              const identifier = `${refNm}-${refOrg}`;
              if (seen.has(identifier)) {
                errors.push(index); // Track the index of the duplicate entry
              } else {
                seen.add(identifier);
              }
            });
            if (errors.length) {
              // Return false to indicate that validation failed
              return context.createError({
                path: `empRef[${errors[0]}].refNm`, // Point to the first duplicate found
                message: 'You have already added this reference in your reference details.',
              });
            }
            return true;
          }
        ),
    }),
    ...(activeStep >= 3 && {
      empLang: Yup.array()
        .of(
          Yup.object().shape({
            lang: Yup.object().required('Language is required'),
            read: Yup.string().required('Answer is required'),
            speak: Yup.string().required('Answer is required'),
            write: Yup.string().required('Answer is required'),
          })
        )
        .test('unique-lang', null, function (value) {
          if (!value) return true;

          const seen = new Set();
          const errors = [];

          value.forEach((entry, index) => {
            const langName = entry.lang?.languagesName; // <-- FIXED this line
            if (!langName) return;

            if (seen.has(langName)) {
              errors.push(index);
            } else {
              seen.add(langName);
            }
          });

          if (errors.length > 0) {
            // eslint-disable-next-line react/no-this-in-sfc
            return this.createError({
              path: `empLang[${errors[0]}].lang`, // <-- First duplicate field
              message: 'You have already added this language details.',
            });
          }

          return true;
        }),
    }),
    ...(activeStep >= 1 && {
      empFamilyRel: Yup.array()
        .of(
          Yup.object().shape({
            relationship: Yup.object().required('Relationship is required'),
            name: Yup.string()
              .required('Full Name is required (e.g., "Rajech Soma Sahani")')
              .max(100, 'Full Name must not exceed 100 characters')
              .test(
                'no-spaces',
                'Full name cannot be just spaces or start/end with blank spaces',
                (value) => value.trim() !== '' && value === value.trim()
              )
              .matches(/^[a-zA-Z\s]*$/, 'Full name cannot contain numbers or special characters'),
            passNo: Yup.string().matches(
              /^[A-Z0-9]{6,9}$/,
              'Passport must be 6–9 characters long, using letters and digits (e.g., A1234567, AB123456)'
            ),
          })
        )
        .test(
          'unique-famRel',
          null, // We won't provide a default error message here
          (value, context) => {
            if (!value) return true; // If the array is empty or undefined, consider it valid
            const seen = new Set();
            const errors = [];
            value.forEach((entry, index) => {
              const passNo = entry.name?.toLowerCase();
              if (!passNo) return;
              if (seen.has(passNo)) {
                errors.push(index); // Track the index of the duplicate entry
              } else {
                seen.add(passNo);
              }
            });
            if (errors.length) {
              // Return false to indicate that validation failed
              return context.createError({
                path: `empFamilyRel[${errors[0]}].name`, // Point to the first duplicate found
                message: 'You have already added this family member details.',
              });
            }
            return true;
          }
        ),
    }),
    ...(activeStep >= 4 && {
      empVisa: Yup.array()
        .of(
          Yup.object().shape({
            // visaNo: Yup.string()
            //   .required('Visa number is required (e.g., "A1234567 ")')
            //   // eslint-disable-next-line prefer-arrow-callback
            //   .test('len-check', 'Visa number is not valid.', function (value) {
            //     if (!value) return true;
            //     return value.length >= 8 && value.length <= 10;
            //   }),

            visaNo: Yup.string()
              .required('Visa number is required (e.g., A1234567)')
              .matches(/^[A-Z0-9]{8,10}$/, 'Visa number must be 8–10 alphanumeric characters'),
            visaTyp: Yup.object().required('Visa type is required'),
            forCntry: Yup.object().required('Country is required'),
            issueDt: Yup.date()
              .nullable()
              .typeError('Issue date must be a valid date')
              .test(
                'no-future-date',
                'Visa issue date cannot be a future date',
                (value, context) => {
                  if (!value) return true;
                  if (currentEmpVisa && context.parent.visaSrno > 0) {
                    const orig = currentEmpVisa.find(
                      (x) => x.visaDetailsId === context.parent.visaSrno
                    );
                    if (
                      orig &&
                      orig.dateOfIssue &&
                      new Date(orig.dateOfIssue).setHours(0, 0, 0, 0) ===
                      new Date(value).setHours(0, 0, 0, 0)
                    )
                      return true;
                  }
                  return new Date(value).setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0);
                }
              ),
            expiryDt: Yup.date()
              .nullable()
              .typeError('Expiry date must be a valid date')
              .min(Yup.ref('issueDt'), 'Expiry Date should be greater than issued date')
              .test(
                'min-duration',
                'Expiry Date must be at least 15 days after the Issue Date',
                (value, context) => {
                  const issueDt = context.parent.issueDt;
                  if (!issueDt || !value) return true; // Skip validation if dates are not set
                  const issueDate = new Date(issueDt);
                  const expiryDate = new Date(value);
                  const minDuration = 15 * 24 * 60 * 60 * 1000; // 15 days in milliseconds
                  return expiryDate.getTime() - issueDate.getTime() >= minDuration;
                }
              ),
          })
        )
        .test(
          'unique-visa',
          null, // We won't provide a default error message here
          (value, context) => {
            if (!value) return true; // If the array is empty or undefined, consider it valid
            const seen = new Set();
            const errors = [];
            value.forEach((entry, index) => {
              const passNo = entry.visaNo;
              if (!passNo) return;
              if (seen.has(passNo)) {
                errors.push(index); // Track the index of the duplicate entry
              } else {
                seen.add(passNo);
              }
            });
            if (errors.length) {
              // Return false to indicate that validation failed
              return context.createError({
                path: `empVisa[${errors[0]}].visaNo`, // Point to the first duplicate found
                message: 'You have already added this visa details.',
              });
            }
            return true;
          }
        ),
    }),
    ...(activeStep >= 6 && {
      empBank: Yup.array()
        .of(
          Yup.object().shape({
            bankNm: Yup.object().required('Bank name is required. Example: "State Bank of India"'),
            branch: Yup.string()
              .required('Bank branch is required. Example: "MG Road Branch"')
              .max(100, 'Bank branch must not exceed 100 characters. Example: "MG Road Branch"')
              .matches(
                /^[a-zA-Z\s]*$/,
                'Bank branch name cannot contain numbers or special characters. Example: "MG Road Branch"'
              )
              .test(
                'no-spaces',
                'Bank branch cannot be just spaces or start/end with blank spaces. Example: "MG Road Branch"',
                (value) => value.trim() !== '' && value === value.trim()
              ),
            accNm: Yup.string()
              .required('Account holder name is required. Example: "Rajesh Sahani"')
              .max(
                100,
                'Account holder name must not exceed 100 characters. Example: "Rajesh Sahani"'
              )
              .test(
                'no-spaces',
                'Account holder name cannot be just spaces or start/end with blank spaces. Example: "Rajesh Sahani"',
                (value) => value.trim() !== '' && value === value.trim()
              )
              .matches(
                /^[a-zA-Z\s]*$/,
                'Account holder name cannot contain numbers or special characters. Example: "Rajesh Sahani"'
              ),
            accNo: Yup.string()
              .required('Account number is required. Example: "123456789"')
              .test(
                'no-spaces',
                'Account number cannot be just spaces or start/end with blank spaces. Example: "123456789"',
                (value) => value.trim() !== '' && value === value.trim()
              )
              .matches(/^[0-9]{9,18}$/, 'Account number is not valid. Example: "123456789"'),
            accTyp: Yup.object().required(
              'Account type is required. Example: "Savings" or "Current"'
            ),
            ifsc: Yup.string()
              .required('IFSC code is required. Example: "SBIN0000001"')
              .test(
                'no-spaces',
                'IFSC code cannot be just spaces or start/end with blank spaces. Example: "SBIN0000001"',
                (value) => value.trim() !== '' && value === value.trim()
              )
              .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, 'IFSC code is not valid. Example: "SBIN0000001"'),
            swiftCd: Yup.string()
              .nullable()
              .test('is-valid-swiftno', 'SWIFT code is not valid. Example: "SBININBB"', (value) => {
                if (!value) return true;
                return /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/.test(value);
              }),
            startDate: Yup.date()
              .required('Start date is required')
              .typeError('Start date must be a valid date')
              .test('no-future-date', 'Start date cannot be a future date', (value, context) => {
                if (!value) return true;
                if (currentEmpBank && context.parent.bankSrno > 0) {
                  const orig = currentEmpBank.find(
                    (x) => x.bankDetailsId === context.parent.bankSrno
                  );
                  if (
                    orig &&
                    orig.startDate &&
                    new Date(orig.startDate).setHours(0, 0, 0, 0) ===
                    new Date(value).setHours(0, 0, 0, 0)
                  )
                    return true;
                }
                return new Date(value).setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0);
              })
              .test(
                'less-than-end-date',
                'Start Date cannot be the same as or after End Date',
                (value, context) => {
                  const { endDate } = context.parent;
                  if (!value || !endDate) return true;
                  return (
                    new Date(value).setHours(0, 0, 0, 0) <
                    new Date(endDate).setHours(0, 0, 0, 0)
                  );
                }
              ),
            endDate: Yup.date()
              .nullable()
              .typeError('End date must be a valid date')
              .test('no-past-date', 'End date cannot be a past date', (value, context) => {
                if (!value) return true;
                if (currentEmpBank && context.parent.bankSrno > 0) {
                  const orig = currentEmpBank.find(
                    (x) => x.bankDetailsId === context.parent.bankSrno
                  );
                  if (
                    orig &&
                    orig.endDate &&
                    new Date(orig.endDate).setHours(0, 0, 0, 0) ===
                    new Date(value).setHours(0, 0, 0, 0)
                  )
                    return true;
                }
                return new Date(value).setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0);
              })
              .min(Yup.ref('startDate'), 'End Date should be greater than Start date')
              .test(
                'is-greater-than-start',
                'End Date cannot be the same as or before Start Date',
                (value, context) => {
                  const { startDate } = context.parent;
                  if (!value || !startDate) return true;
                  return (
                    new Date(value).setHours(0, 0, 0, 0) >
                    new Date(startDate).setHours(0, 0, 0, 0)
                  );
                }
              ),
          })
        )
        .test(
          'unique-bank',
          null, // We won't provide a default error message here
          (value, context) => {
            if (!value) return true; // If the array is empty or undefined, consider it valid
            const seen = new Set();
            const errors = [];
            value.forEach((entry, index) => {
              const passNo = entry.accNo;
              if (!passNo) return;
              if (seen.has(passNo)) {
                errors.push(index); // Track the index of the duplicate entry
              } else {
                seen.add(passNo);
              }
            });
            if (errors.length) {
              // Return false to indicate that validation failed
              return context.createError({
                path: `empBank[${errors[0]}].accNo`, // Point to the first duplicate found
                message: 'You have already added this bank details.',
              });
            }
            return true;
          }
        ),
    }),
    ...(activeStep >= 7 && {
      empRelWrkn: Yup.array()
        .of(
          Yup.object().shape({
            name: Yup.string()
              .required('Full name is required')
              .max(100, 'Full name must not exceed 100 characters')
              .test(
                'no-spaces',
                'Full name cannot be just spaces or start/end with blank spaces',
                (value) => value.trim() !== '' && value === value.trim()
              )
              .matches(/^[a-zA-Z\s]*$/, 'Full name cannot contain numbers or special characters'),
            relationship: Yup.object().required('Relationship is required'),
            curAddCntr: Yup.object().required('Country is required'),
            curAddState: Yup.mixed().when('curAddStateAvailable', {
              is: true,
              then: (schema) => schema.required('State is required'),
              otherwise: (schema) => schema.notRequired(),
            }),
            curAddCity: Yup.mixed().when('curAddCityAvailable', {
              is: true,
              then: (schema) => schema.required('City is required'),
              otherwise: (schema) => schema.notRequired(),
            }),
            refdesig: Yup.object().required('Designation is required'),
          })
        )
        .test(
          'unique-relerkn',
          null, // We won't provide a default error message here
          (value, context) => {
            if (!value) return true; // If the array is empty or undefined, consider it valid
            const seen = new Set();
            const errors = [];
            value.forEach((entry, index) => {
              const passNo = entry.name?.toLowerCase();
              if (!passNo) return;
              if (seen.has(passNo)) {
                errors.push(index); // Track the index of the duplicate entry
              } else {
                seen.add(passNo);
              }
            });
            if (errors.length) {
              // Return false to indicate that validation failed
              return context.createError({
                path: `empRelWrkn[${errors[0]}].name`, // Point to the first duplicate found
                message: 'You have already added this relation details.',
              });
            }
            return true;
          }
        ),
    }),
  });
  const [openDialog, setOpenDialog] = useState(false);

  const getEduDtl = useCallback(() => {
    if (currentEmpEdu) {
      const e = currentEmpEdu.map((cEdu) => ({
        eduSrno: cEdu.id,
        university: cEdu.university,
        othrUni: cEdu.universityName,
        qualtype: cEdu.qualificationTypeId,
        qualification: cEdu.qualification,
        currentypurs: cEdu.currentlyPursuing,
        stream: cEdu.stream,
        candpercnt: cEdu.percentage,
        candcgpa: cEdu.cgpa,
        edufromDate: cEdu.durationFrom ? new Date(cEdu.durationFrom) : null,
        edutoDate: cEdu.durationTo ? new Date(cEdu.durationTo) : null,
      }));
      setEmpEdu(e);
    }
  }, [currentEmpEdu]);
  const getExpDtl = useCallback(() => {
    if (currentEmpExp) {
      const e = currentEmpExp.map((eExp) => {
        const isCurrent = Boolean(eExp.currentlyWorking ?? eExp.currentywrkng ?? false);
        return {
          expSrno: eExp.id,
          compNm: eExp.company,
          designation: eExp.designation,
          currentywrkng: isCurrent,
          ctc: decryptData(eExp.ctc),
          ctccurncy: eExp.ctcCurrency?.currencySymbol,
          country: eExp.country || null,
          expfromDate: eExp.durationFrom ? new Date(eExp.durationFrom) : null,
          exptoDate: isCurrent ? null : (eExp.durationTo ? new Date(eExp.durationTo) : null),
        };
      });
      setEmpExp(e);
    }

    // added the condition for experience switch
    if (currentEmpExp) {
      if (currentEmpExp.length > 0) {
        setSwitchState((prevState) => ({
          ...prevState,
          experience: true, // Set experience to true if length > 0
        }));
      } else {
        setSwitchState((prevState) => ({
          ...prevState,
          experience: false, // Set experience to false if length is 0
        }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentEmpExp]);
  const getRefDtl = useCallback(() => {
    if (currentEmpRef) {
      const e = currentEmpRef.map((eRef) => ({
        refSrno: eRef.employeeReferenceId,
        refNm: eRef.empReferenceName,
        refOrgNm: eRef.empReferenceOrganization,
        refdesig: eRef.designationId,
        refEmail: decryptData(eRef.empReferenceEmail),
        refContact: decryptData(eRef.empReferenceContactNumber),
      }));
      setEmpRef(e);
    }
  }, [currentEmpRef]);
  const getEmrgDtl = useCallback(() => {
    if (currentEmpEmrg) {
      const e = currentEmpEmrg.map((eEmer) => ({
        cntctSrno: eEmer.emergencyContactId,
        name: eEmer.fullName,
        relationship: eEmer.relationId,
        email: decryptData(eEmer.email),
        mobno: decryptData(eEmer.mobileNumber),
        curAddLn1: eEmer.address1,
        curAddLn2: eEmer.address2,
        curAddCntr: eEmer.countriesId,
        curAddState: eEmer.stateId,
        curAddCity: eEmer.citiesId,
        curAddLandMrk: eEmer.landmark,
        curAddZip: eEmer.zipcode,
      }));
      setEmpEmrg(e);
    }
  }, [currentEmpEmrg]);
  const getLangDtl = useCallback(() => {
    if (currentEmpLang) {
      const e = currentEmpLang.map((eExp) => ({
        langSrno: eExp.id,
        lang: eExp.language,
        read: eExp.read,
        speak: eExp.speak,
        write: eExp.write,
      }));
      setEmpLang(e);
    }
  }, [currentEmpLang]);
  const getWrkDtl = useCallback(() => {
    if (currentEmpWrk) {
      const e = currentEmpWrk.map((eExp) => ({
        cntctSrno: eExp.id,
        name: eExp.relEmpName,
        relationship: eExp.relationshipId,
        curAddCntr: eExp.curAddCntr,
        curAddState: eExp.curAddState,
        curAddCity: eExp.curAddCity,
        refdesig: eExp.designationId,
      }));
      setEmpWrk(e);
    }
  }, [currentEmpWrk]);
  const getCertDtl = useCallback(() => {
    if (currentEmpCert) {
      const e = currentEmpCert.map((eExp) => ({
        cerSrno: eExp.employeeCertificationId,
        certiNm: eExp.certificationName,
        certiInstiNm: eExp.instituteName,
        certfromDate: eExp.durationFrom ? new Date(eExp.durationFrom) : null,
        certtoDate: eExp.durationTo ? new Date(eExp.durationTo) : null,
      }));
      setEmpCert(e);
    }
  }, [currentEmpCert]);
  const getVisaDtl = useCallback(() => {
    if (currentEmpVisa) {
      const e = currentEmpVisa.map((eExp) => ({
        visaSrno: eExp.visaDetailsId,
        visaNo: decryptData(eExp.visaNumber),
        visaTyp: eExp.visaTypeId,
        visaNm: eExp.visaNameId,
        placeOfissue: eExp.placeOfIssue,
        forCntry: eExp.visaForCountry,
        issueDt: eExp.dateOfIssue ? new Date(eExp.dateOfIssue) : null,
        expiryDt: eExp.dateOfExpiry ? new Date(eExp.dateOfExpiry) : null,
      }));
      setEmpVisa(e);
    }

    // added the condition for experience switch
    if (currentEmpVisa) {
      if (currentEmpVisa.length > 0) {
        setSwitchState((prevState) => ({
          ...prevState,
          visa: true, // Set experience to true if length > 0
        }));
      } else {
        setSwitchState((prevState) => ({
          ...prevState,
          visa: false, // Set experience to false if length is 0
        }));
      }
    }
  }, [currentEmpVisa]);
  const getBankDtl = useCallback(() => {
    if (currentEmpBank) {
      const e = currentEmpBank.map((eExp) => ({
        bankSrno: eExp.bankDetailsId,
        bankNm: eExp.bankName,
        branch: eExp.branch,
        accNm: eExp.accountName,
        accNo: decryptData(eExp.accountNumber),
        accTyp: eExp.accountType,
        ifsc: decryptData(eExp.ifsc),
        swiftCd: decryptData(eExp.swiftCode),
        startDate: eExp.startDate ? new Date(eExp.startDate) : null,
        endDate: eExp.endDate ? new Date(eExp.endDate) : null,
      }));
      setEmpBank(e);
    }
  }, [currentEmpBank]);
  const getPassDtl = useCallback(() => {
    if (currentEmpPass) {
      const e = currentEmpPass.map((eExp) => ({
        passSrno: eExp.empPassportId,
        passNo: decryptData(eExp.passportNumber),
        issuePlace: eExp.placeOfIssue,
        issueDt: eExp.dateOfIssue ? new Date(eExp.dateOfIssue) : null,
        expiryDt: eExp.dateOfExpiry ? new Date(eExp.dateOfExpiry) : null,
        ecnrStamp: eExp.ecnrstampedName,
      }));
      setEmpPass(e);
    }

    // added the condition for experience switch
    if (currentEmpPass) {
      if (currentEmpPass.length > 0) {
        setSwitchState((prevState) => ({
          ...prevState,
          passport: true, // Set experience to true if length > 0
        }));
      } else {
        setSwitchState((prevState) => ({
          ...prevState,
          passport: false, // Set experience to false if length is 0
        }));
      }
    }
  }, [currentEmpPass]);
  const getFamDtl = useCallback(() => {
    if (currentEmpFam) {
      const e = currentEmpFam.map((eFam) => ({
        relSrno: eFam.familyRelationId,
        name: eFam.relativeName,
        relationship: eFam.relationship,
        dob: eFam.dateOfBirth ? new Date(eFam.dateOfBirth) : null,
        isAlive: eFam.isAlive,
        passNo: decryptData(eFam.passportNumber),
      }));
      setEmpFam(e);
    }
  }, [currentEmpFam]);
  const getImpQDtl = useCallback(() => {
    if (currentEmpImpQ && currentEmpImpQ.length > 0) {
      if (impQueArr && impQueArr.length > 0) {
        const merged = impQueArr.map((masterQ) => {
          const mId = masterQ.id || masterQ.masterId;
          const found = currentEmpImpQ.find((item) => {
            const itemQId =
              typeof item.questionId === 'object'
                ? item.questionId?.id || item.questionId?.masterId
                : item.questionId;
            return itemQId === mId;
          });
          if (found) {
            return {
              iqSrno: found.empImpQueid,
              impQue: found.questionId || masterQ,
              ans: found.answer || 'No',
              ansComment: found.ansDetails || '',
            };
          }
          return {
            iqSrno: 0,
            impQue: masterQ,
            ans: masterQ.ansType && masterQ.ansType.toLowerCase() === 'yes' ? 'Yes' : 'No',
            ansComment: '',
          };
        });
        setEmpImpQ(merged);
      } else {
        const e = currentEmpImpQ.map((eExp) => ({
          iqSrno: eExp.empImpQueid,
          impQue: eExp.questionId,
          ans: eExp.answer || 'No',
          ansComment: eExp.ansDetails || '',
        }));
        setEmpImpQ(e);
      }
    }
  }, [currentEmpImpQ, impQueArr]);
  useEffect(() => {
    let isMounted = true;
    const loadProfilePhoto = async () => {
      // Check if backend already sent pre-signed URL in profilePhotoUrl or profilePhoto
      const directUrl =
        currentEmp?.profilePhotoUrl ||
        (typeof currentEmp?.profilePhoto === 'string' &&
          (currentEmp.profilePhoto.startsWith('http://') ||
            currentEmp.profilePhoto.startsWith('https://') ||
            currentEmp.profilePhoto.startsWith('data:'))
          ? currentEmp.profilePhoto
          : null);

      if (directUrl) {
        if (isMounted) {
          setProfilePhotoUrl(directUrl);
          setValue('avatarUrl', directUrl);
        }
        return;
      }

      if (!currentEmp?.profilePhoto) {
        if (isMounted) setProfilePhotoUrl(null);
        return;
      }

      const photoKey = currentEmp.profilePhoto;

      if (typeof photoKey === 'string' && photoKey.startsWith('/assets/profile/')) {
        const base = axiosInstance.defaults.baseURL?.replace(/\/$/, '').replace(/\/api.*$/, '');
        const fullUrl = `${base}${photoKey}`;
        if (isMounted) {
          setProfilePhotoUrl(fullUrl);
          setValue('avatarUrl', fullUrl);
        }
        return;
      }

      // S3 key — fetch presigned URL from backend if not already appended
      try {
        const { data } = await axiosInstance.get('/rest/employee/profile-photo-url', {
          params: { key: photoKey },
          headers: { Authorization: `Bearer ${token}` },
        });
        const photoUrl = data?.url || data?.photoUrl || (typeof data === 'string' ? data : null);
        if (isMounted) {
          setProfilePhotoUrl(photoUrl);
          if (photoUrl) {
            setValue('avatarUrl', photoUrl);
          }
        }
      } catch (err) {
        console.error('Failed to load profile photo URL', err);
        if (isMounted) setProfilePhotoUrl(null);
      }
    };

    loadProfilePhoto();
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentEmp?.profilePhoto, currentEmp?.profilePhotoUrl]);

  useEffect(() => {
    if (profilePhotoUrl) {
      setValue('avatarUrl', profilePhotoUrl);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profilePhotoUrl]);

  useEffect(() => {
    getEmrgDtl();
    getEduDtl();
    getLangDtl();
    getExpDtl();
    getCertDtl();
    getRefDtl();
    getWrkDtl();
    getVisaDtl();
    getBankDtl();
    getPassDtl();
    getFamDtl();
    getImpQDtl();
  }, [
    getEmrgDtl,
    getLangDtl,
    getWrkDtl,
    getEduDtl,
    getVisaDtl,
    getBankDtl,
    getPassDtl,
    getExpDtl,
    getFamDtl,
    getCertDtl,
    getRefDtl,
    getImpQDtl,
    currentEmpFam,
    currentEmpPass,
    currentEmpBank,
    currentEmpEdu,
    currentEmpVisa,
    currentEmpCert,
    currentEmpWrk,
    currentEmpLang,
    currentEmpEmrg,
    currentEmpRef,
    currentEmpExp,
    currentEmp,
    currentEmpImpQ,
  ]);

  const defaultValues = useMemo(
    () => ({
      avatarUrl:
        currentEmp?.profilePhotoUrl ||
        profilePhotoUrl ||
        (typeof currentEmp?.profilePhoto === 'string' &&
          (currentEmp.profilePhoto.startsWith('http://') ||
            currentEmp.profilePhoto.startsWith('https://') ||
            currentEmp.profilePhoto.startsWith('data:'))
          ? currentEmp.profilePhoto
          : null),
      empTyp: currentEmp?.employeeTypeId || null,
      empGrade: currentEmp?.empGradeId || null,
      empCode: decryptData(currentEmp?.employeeCode) || '',
      dateOfJoin: currentEmp?.dateOfJoining ? new Date(currentEmp.dateOfJoining) : new Date(),
      designation: currentEmp?.designationId || null,
      fname: currentEmp?.firstName || '',
      nameTitle: currentEmp?.titleId || null,
      mname: currentEmp?.middleName || '',
      lname: currentEmp?.lastName || '',
      dateOfBirth: currentEmp?.dateOfBirth ? new Date(currentEmp.dateOfBirth) : new Date(),
      placeOfBirth: currentEmp?.placeOfBirth || '',
      gender: currentEmp?.genderId || null,
      religion: currentEmp?.religionId || null,
      maritalStatus: currentEmp?.maritalStatusId || null,
      nationality: currentEmp?.nationality || '',
      bloodGrp: currentEmp?.bloodGroupId || null,
      height: currentEmp?.height || 0.0,
      unitOfHeight: currentEmp?.unitOfMeasureHeightId || null,
      weight: currentEmp?.weight || 0.0,
      unitOfWeight: currentEmp?.unitOfMeasureWeightId || null,
      email: decryptData(currentEmp?.email) || '',
      phncode: currentEmp?.mobPhoneCode || null,
      mobno: decryptData(currentEmp?.mobileNumber) || '',
      panno: decryptData(currentEmp?.pan) || '',
      aadharno: decryptData(currentEmp?.aadharNumber) || '',
      pfno: decryptData(currentEmp?.uan) || currentEmp?.uan || '',
      pranno: decryptData(currentEmp?.pran) || currentEmp?.pran || '',
      linkedinLink: currentEmp?.linkedinLink || '',
      isInternationalWrkr: currentEmp?.internationalWorker || false,
      ofclEmail: decryptData(currentEmp?.ofclEmail) || '',
      isdirector: currentEmp?.director || false,
      curAddLn1: currentEmp?.presentAddress1 || '',
      curAddLn2: currentEmp?.presentAddress2 || '',
      curAddCntr: currentEmp?.presentCountrIdy || null,
      curAddState: currentEmp?.presentStateId || null,
      curAddCity: currentEmp?.presentCityId || null,
      curAddStateAvailable: false,
      curAddCityAvailable: false,
      curAddLandMrk: currentEmp?.presentLandmark || '',
      curAddZip: currentEmp?.presentZipcode || '',
      curAddLandLn: currentEmp?.presentLandline || '',
      permAddLn1: currentEmp?.permanentAddress1 || '',
      permAddLn2: currentEmp?.permanentAddress2 || '',
      permAddCntr: currentEmp?.permAddCntr || null,
      permAddState: currentEmp?.permAddState || null,
      permAddCity: currentEmp?.permAddCity || null,
      permAddStateAvailable: false,
      permAddCityAvailable: false,
      permAddLandMrk: currentEmp?.permanentLandmark || '',
      permAddZip: currentEmp?.permanentZipcode || '',
      permAddLandLn: currentEmp?.permanentLandline || '',
      srcofhireNm: currentEmp?.srcofhireNm || '',
      srcofhire: currentEmp?.sourceOfHireId || null,
      empPassport:
        currentEmpPass && currentEmpPass.length > 0
          ? currentEmpPass.map((eExp) => ({
            passSrno: eExp.empPassportId || eExp.passSrno || 0,
            passNo: decryptData(eExp.passportNumber || eExp.passNo),
            issuePlace: eExp.placeOfIssue || eExp.issuePlace,
            issueDt: eExp.dateOfIssue ? new Date(eExp.dateOfIssue) : eExp.issueDt || null,
            expiryDt: eExp.dateOfExpiry ? new Date(eExp.dateOfExpiry) : eExp.expiryDt || null,
            ecnrStamp: eExp.ecnrstampedName || eExp.ecnrStamp,
          }))
          : EmpPass,
      empEmrgncyContact:
        currentEmpEmrg && currentEmpEmrg.length > 0
          ? currentEmpEmrg.map((eEmer) => ({
            cntctSrno: eEmer.emergencyContactId || eEmer.cntctSrno || 0,
            name: eEmer.fullName || eEmer.name,
            relationship: eEmer.relationId || eEmer.relationship,
            email: decryptData(eEmer.email),
            mobno: decryptData(eEmer.mobileNumber),
            curAddLn1: eEmer.address1 || eEmer.curAddLn1,
            curAddLn2: eEmer.address2 || eEmer.curAddLn2,
            curAddCntr: eEmer.countriesId || eEmer.curAddCntr,
            curAddState: eEmer.stateId || eEmer.curAddState,
            curAddCity: eEmer.citiesId || eEmer.curAddCity,
            curAddLandMrk: eEmer.landmark || eEmer.curAddLandMrk,
            curAddZip: eEmer.zipcode || eEmer.curAddZip,
          }))
          : EmpEmrg,
      empCert:
        currentEmpCert && currentEmpCert.length > 0
          ? currentEmpCert.map((eExp) => ({
            cerSrno: eExp.employeeCertificationId || eExp.cerSrno || 0,
            certiNm: eExp.certificationName || eExp.certiNm,
            certiInstiNm: eExp.instituteName || eExp.certiInstiNm,
            certfromDate: eExp.durationFrom
              ? new Date(eExp.durationFrom)
              : eExp.certfromDate || null,
            certtoDate: eExp.durationTo ? new Date(eExp.durationTo) : eExp.certtoDate || null,
          }))
          : EmpCert,
      empEdu:
        currentEmpEdu && currentEmpEdu.length > 0
          ? currentEmpEdu.map((cEdu) => ({
            eduSrno: cEdu.id || cEdu.eduSrno || 0,
            university: cEdu.university,
            othrUni: cEdu.universityName || cEdu.othrUni,
            qualtype: cEdu.qualificationTypeId || cEdu.qualtype,
            qualification: cEdu.qualification,
            currentypurs: cEdu.currentlyPursuing || cEdu.currentypurs,
            stream: cEdu.stream,
            candpercnt: cEdu.percentage || cEdu.candpercnt,
            candcgpa: cEdu.cgpa || cEdu.candcgpa,
            edufromDate: cEdu.durationFrom
              ? new Date(cEdu.durationFrom)
              : cEdu.edufromDate || null,
            edutoDate: cEdu.durationTo ? new Date(cEdu.durationTo) : cEdu.edutoDate || null,
          }))
          : EmpEdu,
      empExp:
        currentEmpExp && currentEmpExp.length > 0
          ? currentEmpExp.map((eExp) => {
            const isCurrent = Boolean(eExp.currentlyWorking ?? eExp.currentywrkng ?? false);
            return {
              expSrno: eExp.id || eExp.expSrno || 0,
              compNm: eExp.company || eExp.compNm,
              designation: eExp.designation,
              currentywrkng: isCurrent,
              ctc: decryptData(eExp.ctc),
              ctccurncy: eExp.ctcCurrency?.currencySymbol || eExp.ctccurncy,
              country: eExp.country || null,
              expfromDate: eExp.durationFrom
                ? new Date(eExp.durationFrom)
                : eExp.expfromDate || null,
              exptoDate: isCurrent
                ? null
                : (eExp.durationTo ? new Date(eExp.durationTo) : eExp.exptoDate || null),
            };
          })
          : EmpExp,
      empLang:
        currentEmpLang && currentEmpLang.length > 0
          ? currentEmpLang.map((eExp) => ({
            langSrno: eExp.id || eExp.langSrno || 0,
            lang: eExp.language || eExp.lang,
            read: eExp.read,
            speak: eExp.speak,
            write: eExp.write,
          }))
          : EmpLang,
      empRef:
        currentEmpRef && currentEmpRef.length > 0
          ? currentEmpRef.map((eRef) => ({
            refSrno: eRef.employeeReferenceId || eRef.refSrno || 0,
            refNm: eRef.empReferenceName || eRef.refNm,
            refOrgNm: eRef.empReferenceOrganization || eRef.refOrgNm,
            refdesig: eRef.designationId || eRef.refdesig,
            refEmail: decryptData(eRef.empReferenceEmail || eRef.refEmail),
            refContact: decryptData(eRef.empReferenceContactNumber || eRef.refContact),
          }))
          : EmpRef,
      empFamilyRel:
        currentEmpFam && currentEmpFam.length > 0
          ? currentEmpFam.map((eFam) => ({
            relSrno: eFam.familyRelationId || eFam.relSrno || 0,
            name: eFam.relativeName || eFam.name,
            relationship: eFam.relationship,
            dob: eFam.dateOfBirth ? new Date(eFam.dateOfBirth) : eFam.dob || null,
            isAlive: eFam.isAlive,
            passNo: decryptData(eFam.passportNumber || eFam.passNo),
          }))
          : EmpFam,
      empVisa:
        currentEmpVisa && currentEmpVisa.length > 0
          ? currentEmpVisa.map((eExp) => ({
            visaSrno: eExp.visaDetailsId || eExp.visaSrno || 0,
            visaNo: decryptData(eExp.visaNumber || eExp.visaNo),
            visaTyp: eExp.visaTypeId || eExp.visaTyp,
            visaNm: eExp.visaNameId || eExp.visaNm,
            placeOfissue: eExp.placeOfIssue || eExp.placeOfissue,
            forCntry: eExp.visaForCountry || eExp.forCntry,
            issueDt: eExp.dateOfIssue ? new Date(eExp.dateOfIssue) : eExp.issueDt || null,
            expiryDt: eExp.dateOfExpiry ? new Date(eExp.dateOfExpiry) : eExp.expiryDt || null,
          }))
          : EmpVisa,
      empBank:
        currentEmpBank && currentEmpBank.length > 0
          ? currentEmpBank.map((eExp) => ({
            bankSrno: eExp.bankDetailsId || eExp.bankSrno || 0,
            bankNm: eExp.bankName || eExp.bankNm,
            branch: eExp.branch,
            accNm: eExp.accountName || eExp.accNm,
            accNo: decryptData(eExp.accountNumber || eExp.accNo),
            accTyp: eExp.accountType || eExp.accTyp,
            ifsc: decryptData(eExp.ifsc),
            swiftCd: decryptData(eExp.swiftCode || eExp.swiftCd),
            startDate: eExp.startDate ? new Date(eExp.startDate) : null,
            endDate: eExp.endDate ? new Date(eExp.endDate) : null,
          }))
          : EmpBank,
      empRelWrkn:
        currentEmpWrk && currentEmpWrk.length > 0
          ? currentEmpWrk.map((eExp) => ({
            cntctSrno: eExp.id || eExp.cntctSrno || 0,
            name: eExp.relEmpName || eExp.name,
            relationship: eExp.relationshipId || eExp.relationship,
            curAddCntr: eExp.curAddCntr,
            curAddState: eExp.curAddState,
            curAddCity: eExp.curAddCity,
            refdesig: eExp.designationId || eExp.refdesig,
          }))
          : EmpWrk,
      impQuesC: currentEmpImpQ ? EmpImpQ : impQues,
      startDate: new Date(),
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      currentEmpFam,
      currentEmpPass,
      currentEmpBank,
      currentEmpEdu,
      currentEmpVisa,
      currentEmpCert,
      currentEmpWrk,
      currentEmpLang,
      currentEmpEmrg,
      currentEmpRef,
      currentEmpExp,
      currentEmp,
      currentEmpImpQ,
      EmpFam,
      EmpPass,
      EmpBank,
      EmpEdu,
      EmpVisa,
      EmpCert,
      EmpWrk,
      EmpLang,
      EmpEmrg,
      EmpRef,
      EmpExp,
      impQues,
      EmpImpQ,
      profilePhotoUrl,
    ]
  );

  const methods = useForm({
    resolver: yupResolver(NewEmployeeSchema),
    mode: 'onChange',
    shouldUnregister: false,
    defaultValues,
  });

  const {
    control,
    handleSubmit,
    watch,
    resetField,
    getValues,
    setValue,
    reset,
    clearErrors,
    formState: { errors },
    trigger,
  } = methods;

  const stepHasDuplicate = (stepIndex) => {
    if (stepIndex === 1) {
      return Boolean(
        duplicateFields.panno ||
        duplicateFields.aadharno ||
        duplicateFields.pfno ||
        duplicateFields.pranno
      );
    }
    if (stepIndex === 4) {
      return Object.keys(duplicateFields).some(
        (k) => (k.startsWith('passport-') || k.startsWith('visa-')) && duplicateFields[k]
      );
    }
    if (stepIndex === 6) {
      return Object.keys(duplicateFields).some(
        (k) => k.startsWith('bank-') && duplicateFields[k]
      );
    }
    return false;
  };

  const stepHasError = (stepIndex) => {
    if (stepHasDuplicate(stepIndex)) {
      return true;
    }
    if (stepCompletionStatus[stepIndex] === false) {
      return true;
    }
    const validator = stepsvalidator[stepIndex];
    if (validator?.fields && errors) {
      const fieldKeys = Object.keys(validator.fields);
      const hasRHFError = fieldKeys.some((key) => Boolean(errors[key]));
      if (hasRHFError) {
        return true;
      }
    }
    if (stepCompletionStatus[stepIndex] !== null) {
      if (stepIndex === 0) {
        const isCandidateMissing = !currentEmp && !getValues('candidate');
        const empTyp = getValues('empTyp');
        const isGradeRequired = ['Freelance', 'Full-time Employment'].includes(empTyp?.masterName);
        const isGradeMissing = isGradeRequired && !getValues('empGrade');
        if (
          isCandidateMissing ||
          !empTyp ||
          !getValues('dateOfJoin') ||
          !getValues('designation') ||
          isGradeMissing
        ) {
          return true;
        }
      } else if (stepIndex === 1) {
        if (
          !getValues('fname')?.trim() ||
          !getValues('lname')?.trim() ||
          !getValues('gender') ||
          !getValues('email')?.trim() ||
          !getValues('mobno')?.trim() ||
          !getValues('panno')?.trim() ||
          !getValues('aadharno')?.trim()
        ) {
          return true;
        }
      }
    }
    return false;
  };

  const impQuesData = useCallback(() => {
    if (impQueArr && impQueArr.length > 0) {
      if (!currentEmp) {
        const e = impQueArr.map((impQ) => ({
          iqSrno: 0,
          impQue: impQ,
          ans: impQ.ansType && impQ.ansType.toLowerCase() === 'yes' ? 'Yes' : 'No',
          ansComment: '',
        }));
        setImpQues(e);
        setValue('impQuesC', e);
      } else if (currentEmpImpQ && currentEmpImpQ.length > 0) {
        getImpQDtl();
      }
    }
  }, [currentEmp, currentEmpImpQ, getImpQDtl, impQueArr, setValue]);

  useEffect(
    () => {
      // If impQueArr is not empty, call impQuesData to set the initial state
      impQuesData();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [impQuesData, impQueArr]
  );

  useEffect(() => {
    if (EmpImpQ && EmpImpQ.length > 0) {
      setValue('impQuesC', EmpImpQ);
    }
  }, [EmpImpQ, setValue]);

  useEffect(
    () => {
      if (currentEmp) {
        reset(defaultValues);
        setDuplicateFields({});
        if (currentEmp.presentCountrIdy) {
          handleCountryChange(currentEmp.presentCountrIdy.countriesId);
        }
        if (currentEmp.presentStateId) {
          handleStateChange(currentEmp.presentStateId.statesId);
        }
        if (currentEmp.permanentCountry) {
          handlePerCountryChange(currentEmp.permanentCountry.countriesId);
        }
        if (currentEmp.permanentStateId) {
          handlePerStateChange(currentEmp.permanentStateId.statesId);
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      currentEmp,
      currentEmpEdu,
      currentEmpEmrg,
      currentEmpWrk,
      currentEmpBank,
      currentEmpCert,
      currentEmpExp,
      currentEmpFam,
      currentEmpLang,
      currentEmpPass,
      currentEmpRef,
      currentEmpVisa,
      currentEmpImpQ,
      reset,
    ]
  );

  // Watch for changes in the employment type (empTyp)
  const watchedEmpTyp = watch('empTyp'); // Watch the `empTyp` field

  // Effect to handle visibility of empGrade when currentEmp is populated
  useEffect(() => {
    if (
      watchedEmpTyp &&
      ['Freelance', 'Full-time Employment'].includes(watchedEmpTyp.employmentTypeName)
    ) {
      // Ensure empGrade field is visible if empTyp is 'Freelance' or 'Full Time'
      setValue('empGrade', currentEmp?.empGradeId || null, { shouldValidate: true });
    }
  }, [watchedEmpTyp, currentEmp, setValue]);

  const copyCurrentAddressToPermanent = (shouldCopy) => {
    if (shouldCopy) {
      const curLn1 = getValues('curAddLn1') || '';
      const curLn2 = getValues('curAddLn2') || '';
      const curCntr = getValues('curAddCntr');
      const curState = getValues('curAddState');
      const curCity = getValues('curAddCity');
      const curLandMrk = getValues('curAddLandMrk') || '';
      const curZip = getValues('curAddZip') || '';
      const curLandLn = getValues('curAddLandLn') || '';

      setValue('permAddLn1', curLn1, { shouldValidate: true, shouldDirty: true });
      setValue('permAddLn2', curLn2, { shouldValidate: true, shouldDirty: true });
      setValue('permAddCntr', curCntr, { shouldValidate: true, shouldDirty: true });
      setValue('permAddState', curState, { shouldValidate: true, shouldDirty: true });
      setValue('permAddCity', curCity, { shouldValidate: true, shouldDirty: true });
      setValue('permAddLandMrk', curLandMrk, { shouldValidate: true, shouldDirty: true });
      setValue('permAddZip', curZip, { shouldValidate: true, shouldDirty: true });
      setValue('permAddLandLn', curLandLn, { shouldValidate: true, shouldDirty: true });

      if (curLn1.trim()) clearErrors('permAddLn1');
      if (curCntr) clearErrors('permAddCntr');
      if (curState) clearErrors('permAddState');
      if (curCity) clearErrors('permAddCity');

      if (curCntr?.countriesId) handlePerCountryChange(curCntr.countriesId);
      if (curState?.statesId) handlePerStateChange(curState.statesId);

      trigger(['permAddLn1', 'permAddCntr', 'permAddState', 'permAddCity']);
    } else {
      setValue('permAddLn1', '', { shouldValidate: true, shouldDirty: true });
      setValue('permAddLn2', '', { shouldValidate: true, shouldDirty: true });
      setValue('permAddCntr', null, { shouldValidate: true, shouldDirty: true });
      setValue('permAddState', null, { shouldValidate: true, shouldDirty: true });
      setValue('permAddCity', null, { shouldValidate: true, shouldDirty: true });
      setValue('permAddLandMrk', '', { shouldValidate: true, shouldDirty: true });
      setValue('permAddZip', '', { shouldValidate: true, shouldDirty: true });
      setValue('permAddLandLn', '', { shouldValidate: true, shouldDirty: true });
    }
  };
  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    setIsSameAsCurrent(isChecked);
    copyCurrentAddressToPermanent(isChecked);
  };

  const isCurrentAndPermanentAddressSame = () => {
    const curAddLn1 = watch('curAddLn1');
    const permAddLn1 = watch('permAddLn1');

    // Check if all fields are equal
    const isEqual =
      curAddLn1 === permAddLn1 &&
      watch('curAddLn2') === watch('permAddLn2') &&
      watch('curAddCntr')?.countriesId === watch('permAddCntr')?.countriesId &&
      watch('curAddState')?.statesId === watch('permAddState')?.statesId &&
      watch('curAddCity')?.cityId === watch('permAddCity')?.cityId &&
      watch('curAddLandMrk') === watch('permAddLandMrk') &&
      watch('curAddZip') === watch('permAddZip') &&
      watch('curAddLandLn') === watch('permAddLandLn');

    // Only return true if addresses are equal AND at least one key field is filled
    return isEqual && !!curAddLn1?.trim();
  };

  // ─── APPLY STEP MASTER DATA TO DROPDOWN STATES ──────────────────────────────
  // Triggered whenever activeMasterData or activeStep updates
  useEffect(() => {
    if (!activeMasterData) return;

    switch (activeStep) {
      case 0:
        // Basic Details — Employee Type, Employee Grade, Designation
        if (activeMasterData.empTypData) setEmpTypArr(activeMasterData.empTypData);
        if (activeMasterData.empGradeData) setEmpGradeArr(activeMasterData.empGradeData);
        if (activeMasterData.desginationData) setDesgntnArr(activeMasterData.desginationData);
        break;

      case 1:
        // Personal & Family Details — Title, Unit of Msr, Religion, Blood Group, Marital Status, Countries, Relationship, Gender
        if (activeMasterData.nmTitleData) setNmTitleArr(activeMasterData.nmTitleData);
        if (activeMasterData.unitOfMsrData) setUnitOfMsrArr(activeMasterData.unitOfMsrData);
        if (activeMasterData.relgnData) setRelgnArr(activeMasterData.relgnData);
        if (activeMasterData.bloodGrpData) setBloodGrpArr(activeMasterData.bloodGrpData);
        if (activeMasterData.maritalStData) setMaritalStArr(activeMasterData.maritalStData);
        if (activeMasterData.countriesData) setCountryArr(activeMasterData.countriesData);
        if (activeMasterData.relshnshipData)
          setRelshnshipArr(activeMasterData.relshnshipData || []);
        if (activeMasterData.genderData) setGenderArr(activeMasterData.genderData);
        break;

      case 2:
        // Address & Contact Details — Relationship, Countries, Cities
        if (activeMasterData.relshnshipData)
          setRelshnshipArr(activeMasterData.relshnshipData || []);
        if (activeMasterData.countriesData) setCountryArr(activeMasterData.countriesData);
        if (activeMasterData.citiesData) setRawCityArr(activeMasterData.citiesData);
        break;

      case 3:
        // Education & Certification Details — University, Qual Type, Stream, Qual, Cert Inst, Cert Name, Language
        if (activeMasterData.universityData) setUniversityArr(activeMasterData.universityData);
        if (activeMasterData.qualTypData) setQualTypeArr(activeMasterData.qualTypData);
        if (activeMasterData.streamData) setStreamArr(activeMasterData.streamData);
        if (activeMasterData.qualData) setQualArr(activeMasterData.qualData);
        if (activeMasterData.certInst) setCertInstNmArr(activeMasterData.certInst);
        if (activeMasterData.certNm) setCertNmArr(activeMasterData.certNm);
        if (activeMasterData.langData) setLangArr(activeMasterData.langData);
        break;

      case 4:
        // Passport & Visa Details — Countries, Visa Name, Visa Type
        if (activeMasterData.placeOfIssueData) setRawCityArr(activeMasterData.placeOfIssueData);
        if (activeMasterData.countriesData) setCountryArr(activeMasterData.countriesData);
        if (activeMasterData.visaNmData) setVisaNmArr(activeMasterData.visaNmData);
        if (activeMasterData.visaTypData) setVisaTypArr(activeMasterData.visaTypData);
        break;

      case 5:
        // Experience & Reference Details — Designation, Countries, Relationship
        if (activeMasterData.desginationData) setDesgntnArr(activeMasterData.desginationData);
        if (activeMasterData.countriesData) setCountryArr(activeMasterData.countriesData);
        if (activeMasterData.relshnshipData)
          setRelshnshipArr(activeMasterData.relshnshipData || []);
        break;

      case 6:
        // Bank Details — Bank Name, Bank Type
        if (activeMasterData.bankNmData) setBankNmArr(activeMasterData.bankNmData);
        if (activeMasterData.bankTypData) setBankTypArr(activeMasterData.bankTypData);
        break;

      case 7:
        // Other Details — Source of Hire, Important Questions, Relationship, Designation
        if (activeMasterData.scrOfhireData) setSrcOfHrArr(activeMasterData.scrOfhireData);
        if (activeMasterData.impQueData) setImpQueArr(activeMasterData.impQueData);
        if (activeMasterData.relshnshipData)
          setRelshnshipArr(activeMasterData.relshnshipData || []);
        if (activeMasterData.desginationData) setDesgntnArr(activeMasterData.desginationData);
        break;

      default:
        break;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeMasterData, activeStep]);
  // ─────────────────────────────────────────────────────────────────────────────

  useEffect(() => {
    const fetchOfferedCand = async () => {
      try {
        const res1 = await axiosInstance.get(`/rest/employee/getOfferedCand`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setOfferedCand(res1.data);
      } catch (err) {
        console.error('Failed to fetch offered candidates', err);
      }
    };
    fetchOfferedCand();
  }, [token]);

  const filterPhoneCode = createFilterOptions({
    stringify: (option) => option.countryName + option.phoneCode,
  });
  const filterCandidate = createFilterOptions({
    stringify: (option) => option.firstName + option.lastName + option.email,
  });
  const filterCurrency = createFilterOptions({
    stringify: (option) => option.countryName + option.currencySymbol,
  });

  useEffect(() => {
    if (countryArr.length > 0) {
      // Example: set India as default
      const defaultCountry = countryArr.find((c) => c.phoneCode === '91');

      if (defaultCountry) {
        setValue('phncode', defaultCountry, { shouldValidate: true });
        if (switchState.experience && getValues('empExp')?.length > 0) {
          setValue('empExp[0].ctccurncy', defaultCountry, { shouldValidate: true });
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countryArr]);

  const handleDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0];

      if (file) {
        const isTooLarge = file.size / (1024 * 1024) > maxSizeOfDocs; // Convert to MB
        setIsFileTooLarge(isTooLarge);

        if (!isTooLarge) {
          const newFile = Object.assign(file, {
            preview: URL.createObjectURL(file),
          });

          setValue('avatarUrl', newFile, { shouldValidate: true });
          setCurEmpPic(true);
        } else {
          // Clear image if oversized
          setValue('avatarUrl', null, { shouldValidate: true });
          setCurEmpPic(false);
        }
      }
    },
    [setValue, maxSizeOfDocs]
  );

  const handleRemovePhoto = useCallback(() => {
    setIsProfilePhotoRemoved(true); // marks for deletion
    setCurEmpPic(null); // removes preview
    setValue('avatarUrl', null); // clears input value
    setIsFileTooLarge(false); // reset validation
  }, [setValue]);

  const handleCandidateChange = async (selectedCand) => {
    const encryptedId = await fetchEncryptedToken(selectedCand, token);

    axiosInstance
      .get(`/rest/candidate/singleCandDetails/${encryptedId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setLastUpdatedDateCand(new Date(res.data.candidate.lastUpdatedDate));
        setValue('nameTitle', res.data.candidate.nameTitle);
        setValue('fname', res.data.candidate.firstName);
        setValue('mname', res.data.candidate.middleName);
        setValue('lname', res.data.candidate.lastName);
        setValue('gender', res.data.candidate.gender);
        setValue('email', decryptData(res.data.candidate.email));
        setValue('phncode', res.data.candidate.mobPhoneCode);
        setValue('mobno', decryptData(res.data.candidate.mobileNumber));
        setValue('srcofhire', res.data.candidate.sourceOfHire);
        setValue('srcofhireNm', res.data.candidate.sourceOfHireName);
        setValue('linkedinLink', res.data.candidate.linkedinUrl);

        if (res.data.candidate?.profilePhoto) {
          const candPhoto = res.data.candidate.profilePhoto;
          setCandProfilePhoto(candPhoto);
          setIsProfilePhotoRemoved(false);
          setCurEmpPic(true);
          if (res.data.candidate?.profilePhotoUrl) {
            setProfilePhotoUrl(res.data.candidate.profilePhotoUrl);
            setValue('avatarUrl', res.data.candidate.profilePhotoUrl);
          } else if (
            candPhoto.startsWith('http://') ||
            candPhoto.startsWith('https://') ||
            candPhoto.startsWith('data:')
          ) {
            setProfilePhotoUrl(candPhoto);
            setValue('avatarUrl', candPhoto);
          } else if (candPhoto.startsWith('/assets/')) {
            const base = axiosInstance.defaults.baseURL?.replace(/\/$/, '').replace(/\/api.*$/, '');
            const url = `${base}${candPhoto}`;
            setProfilePhotoUrl(url);
            setValue('avatarUrl', url);
          } else {
            axiosInstance
              .get('/rest/employee/profile-photo-url', {
                params: { key: candPhoto },
                headers: { Authorization: `Bearer ${token}` },
              })
              .then(({ data }) => {
                const photoUrl =
                  data?.url || data?.photoUrl || (typeof data === 'string' ? data : null);
                if (photoUrl) {
                  setProfilePhotoUrl(photoUrl);
                  setValue('avatarUrl', photoUrl);
                }
              })
              .catch((err) => console.error('Failed to fetch candidate profile photo URL:', err));
          }
        }

        if (res.data.candidate.uniqueNoType === 'AADHAR') {
          setValue('aadharno', decryptData(res.data.candidate.panNo));
        } else {
          setValue('panno', decryptData(res.data.candidate.panNo));
        }
        if (res.data.educationDetails) {
          const e = res.data.educationDetails.map((cEdu) => ({
            eduSrno: 0,
            university: cEdu.university,
            qualtype: cEdu.qualification,
            qualification: cEdu.qualification,
            stream: cEdu.stream,
            candpercnt: cEdu.candidateQualPercentage,
            currentypurs: cEdu.currentlyPursuing,
            candcgpa: cEdu.candidateQualCgpa,
            edufromDate: cEdu.candidateQualFromDate ? new Date(cEdu.candidateQualFromDate) : null,
            edutoDate: cEdu.candidateQualToDate ? new Date(cEdu.candidateQualToDate) : null,
            fromCandidate: true, //  Add this line
          }));
          setValue('empEdu', e);
        }
        if (res.data.certifications) {
          const e = res.data.certifications.map((eExp) => ({
            cerSrno: 0,
            certiNm: eExp.certificationName,
            certiInstiNm: eExp.instituteName,
            certfromDate: eExp.durationFrom ? new Date(eExp.durationFrom) : null,
            certtoDate: eExp.durationTo ? new Date(eExp.durationTo) : null,
            fromCandidate: true, // <-- add this property here
          }));
          setValue('empCert', e);
        }
        if (res.data.expDetails) {
          const e = res.data.expDetails.map((eExp) => {
            const isCurrent = Boolean(eExp.candidateCurrentlyWorking ?? eExp.isCandidateCurrentlyWorking ?? false);
            return {
              expSrno: 0,
              compNm: eExp.candidateExperienceCompanyName,
              designation: eExp.candidateDesignation,
              ctc: decryptData(eExp.candidateCtc),
              ctccurncy: eExp.candidateCtcCurrency,
              country: eExp.candidateExperienceCountryid || null,
              currentywrkng: isCurrent,
              expfromDate: eExp.candidateExperienceFromDate
                ? new Date(eExp.candidateExperienceFromDate)
                : null,
              exptoDate: isCurrent
                ? null
                : (eExp.candidateExperienceToDate ? new Date(eExp.candidateExperienceToDate) : null),
              fromCandidate: true, // <-- add this property here
            };
          });
          setValue('empExp', e);
          // for Switch component
          if (res.data.expDetails.length > 0) {
            setSwitchState((prevState) => ({
              ...prevState,
              experience: true, // Set experience to true if length > 0
            }));
          } else {
            setSwitchState((prevState) => ({
              ...prevState,
              experience: false, // Set experience to false if length is 0
            }));
          }
        }
        if (res.data.refDetails) {
          const e = res.data.refDetails.map((eExp) => ({
            refSrno: 0,
            refNm: decryptData(eExp.candidateReferenceName),
            refOrgNm: decryptData(eExp.candidateReferenceOrganizationName),
            refdesig: eExp.candidateReferenceDesignation,
            refEmail: decryptData(eExp.candidateReferenceEmail),
            refContact: decryptData(eExp.candidateReferenceContactNumber),
            fromCandidate: true, // <-- add this property here
          }));
          setValue('empRef', e);
        }
      })
      .catch((error) => {
        handleApiError(error);
      });
  };

  const handleCountryChange = (selectedCountryId) => {
    axiosInstance
      .get(`/rest/state/findStates?countryId=${selectedCountryId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setCurStateArr(res.data);
      })
      .catch((error) => {
        setCurStateArr([]);
        handleApiError(error);
      });
  };
  const handlePerCountryChange = (selectedCountryId) => {
    axiosInstance
      .get(`/rest/state/findStates?countryId=${selectedCountryId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setPerStateArr(res.data);
      })
      .catch((error) => {
        setPerStateArr([]);
        handleApiError(error);
      });
  };
  const handleStateChange = (selectedStateId) => {
    axiosInstance
      .get(`/rest/cities/findCities?stateId=${selectedStateId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setCurCityArr(res.data);
      })
      .catch((error) => {
        setCurCityArr([]);
        handleApiError(error);
      });
  };
  const handlePerStateChange = (selectedStateId) => {
    axiosInstance
      .get(`/rest/cities/findCities?stateId=${selectedStateId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setPerCityArr(res.data);
      })
      .catch((error) => {
        setPerCityArr([]);
        handleApiError(error);
      });
  };

  const options = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  };

  const handleSendEmail = useCallback(
    async (empdata, candReq) => {
      try {
        const tableContent = `
      <html>
    <br>
    <h4>Dear ${candReq.createdBy.userName}</h4>
    <p>New employee has joined for the requisition you had raised (Requisition Id - ${candReq.candidateRequirementLineId
          }):</p>
    <table style="border-collapse: collapse; width: 100%;">
    <tr style="background-color: #f2f2f2;">
      ${empdata.employeeCode
            ? `<th style="border: 1px solid #dddddd; text-align: left; padding: 8px;">Employee Code</th>`
            : ''
          }
      <th style="border: 1px solid #dddddd; text-align: left; padding: 8px;">Employee Name</th>
      <th style="border: 1px solid #dddddd; text-align: left; padding: 8px;">Employment Type</th>
      <th style="border: 1px solid #dddddd; text-align: left; padding: 8px;">Project</th>
      <th style="border: 1px solid #dddddd; text-align: left; padding: 8px;">Position</th>
      <th style="border: 1px solid #dddddd; text-align: left; padding: 8px;">Joining Date</th>
    </tr>
    <tr>
        ${empdata.employeeCode
            ? `<td style="border: 1px solid #dddddd; text-align: left; padding: 8px;">${empdata.employeeCode}</td>`
            : ''
          }
      <td style="border: 1px solid #dddddd; text-align: left; padding: 8px;">${empdata.firstName} ${empdata.lastName
          }</td>
      <td style="border: 1px solid #dddddd; text-align: left; padding: 8px;">${empdata.employeeTypeId.employmentTypeName
          }</td>
      <td style="border: 1px solid #dddddd; text-align: left; padding: 8px;">${candReq.project.projectId
          } - ${candReq.project.projectName}</td>
      <td style="border: 1px solid #dddddd; text-align: left; padding: 8px;">${candReq.positionName
          }</td>
      <td style="border: 1px solid #dddddd; text-align: left; padding: 8px;">${new Date(
            empdata.dateOfJoining
          ).toLocaleDateString('en-GB', options)}</td>
    </tr>
    </table>
    <br>
    <p>This is a system-generated email, please do not reply.</p>
    <h4>Thank You!</h4></html>`;

        const newEmpMail = new FormData();
        newEmpMail.append('to', candReq.createdBy.email);
        newEmpMail.append('cc', empdata.createdBy.email);
        newEmpMail.append(
          'subject',
          `New Employee has joined: ${empdata.firstName} ${empdata.lastName}`
        );
        newEmpMail.append('body', tableContent);

        axiosInstance.post(`/rest/emails/send`, newEmpMail, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
      } catch (error) {
        handleApiError(error);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const onSubmit = handleSubmit(async (data) => {
    loadingSend.onTrue();

    try {
      await new Promise((resolve) => setTimeout(resolve, 500));
      loadingSend.onFalse();

      const empData = {
        employeeTypeId: data.empTyp,
        empGradeId: data.empGrade,
        isFinalStep: data.isFinalStep || isFinalStep,
        employeeCode: data.empCode,
        dateOfJoining: data.dateOfJoin,
        designationId: data.designation,
        titleId: data.nameTitle,
        firstName: data.fname,
        middleName: data.mname,
        lastName: data.lname,
        email: encryptData(data.email),
        mobPhoneCode: data.phncode,
        mobileNumber: encryptData(data.mobno),
        dateOfBirth: data.dateOfBirth,
        placeOfBirth: data.placeOfBirth,
        genderId: data.gender,
        weight: data.weight,
        linkedinLink: data.linkedinLink,
        unitOfMeasureWeightId: data.unitOfWeight,
        unitOfMeasureHeightId: data.unitOfHeight,
        ofclEmail: encryptData(data.ofclEmail),
        height: data.height,
        bloodGroupId: data.bloodGrp,
        maritalStatusId: data.maritalStatus,
        internationalWorker: data.isInternationalWrkr,
        director: data.isdirector,
        nationality: data.nationality,
        religionId: data.religion,
        presentAddress1: data.curAddLn1,
        presentAddress2: data.curAddLn2,
        presentLandmark: data.curAddLandMrk,
        presentCityId: data.curAddCity,
        presentStateId: data.curAddState,
        presentCountrIdy: data.curAddCntr,
        presentZipcode: data.curAddZip,
        presentLandline: data.curAddLandLn,
        permanentLandline: data.permAddLandLn,
        permanentZipcode: data.permAddZip,
        permanentCountry: data.permAddCntr,
        permanentStateId: data.permAddState,
        permanentCityId: data.permAddCity,
        permanentLandmark: data.permAddLandMrk,
        permanentAddress2: data.permAddLn2,
        permanentAddress1: data.permAddLn1,
        pan: encryptData(data.panno),
        aadharNumber: encryptData(data.aadharno),
        pran: encryptData(data.pranno),
        uan: encryptData(data.pfno),
        sourceOfHireId: data.srcofhire,
        sourceOfHireDetails: data.srcofhireNm,
        startDate: data.startDate,
        profilePhoto: isProfilePhotoRemoved
          ? null
          : (currentEmp?.profilePhoto || candProfilePhoto || null),
      };
      const formData = new FormData();
      formData.append('empD', JSON.stringify(empData));
      // formData.append('profileP', data.avatarUrl);

      if (data.avatarUrl instanceof File) {
        formData.append('profileP', data.avatarUrl);
      }

      if (currentEmp) {
        formData.append('empId', currentEmp.employeeId);
        const updtEmpUrl = `/rest/employee/updtEmp`;
        axiosInstance
          .put(updtEmpUrl, formData, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((res) => {
            const empCode = res.data.employeeCode;
            if (empCode) {
              enqueueSnackbar('Employee Updated successfully!', { variant: 'success' });
            } else {
              enqueueSnackbar('Draft Saved successfully!', { variant: 'success' });
            }
          })
          .catch((error) => {
            if (error._handled) return null;

            if (error.response?.data?.message) {
              enqueueSnackbar(error.response.data.message, { variant: 'warning' });
            } else {
              enqueueSnackbar('Something went wrong', { variant: 'error' });
            }
            // prevent further throwing
            return null;
          });

        if (isProfilePhotoRemoved && !curEmpPic) {
          const encryptedId = await fetchEncryptedToken(currentEmp.employeeId, token);

          await axiosInstance.delete(`/rest/employee/deleteProfile/${encryptedId}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
        }

        if (activeStep === 3 || activeStep <= 7) {
          if (currentEmpEdu || data.empEdu) {
            const addedEdus = data.empEdu.filter((edu) => edu.eduSrno === 0);
            const updtEdus = data.empEdu.filter((edu) => edu.eduSrno !== 0);
            const removeEdus = EmpEdu.filter(
              (currEdu) =>
                currEdu.eduSrno && !data.empEdu.some((edu) => edu.eduSrno === currEdu.eduSrno)
            );
            if (addedEdus.length > 0) {
              addedEdus.forEach((cEdu) => {
                const cEduData = {
                  empId: {
                    employeeId: currentEmp.employeeId,
                  },
                  university: cEdu.university,
                  universityName: cEdu.othrUni,
                  qualification: cEdu.qualification,
                  qualificationTypeId: cEdu.qualtype,
                  stream: cEdu.stream,
                  percentage: cEdu.candpercnt,
                  cgpa: cEdu.candcgpa,
                  currentlyPursuing: cEdu.currentypurs,
                  durationFrom: cEdu.edufromDate,
                  durationTo: cEdu.edutoDate,
                  createdDate: new Date(),
                  lastUpdatedDate: new Date(),
                };
                const addCandEduUrl = `/rest/empDetails/addEmpEdu`;
                axiosInstance
                  .post(addCandEduUrl, cEduData, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res4) => { });
              });
            }
            if (updtEdus.length > 0) {
              updtEdus.forEach(async (cEdu) => {
                const cEduData = {
                  university: cEdu.university,
                  universityName: cEdu.othrUni,
                  qualification: cEdu.qualification,
                  qualificationTypeId: cEdu.qualtype,
                  stream: cEdu.stream,
                  percentage: cEdu.candpercnt,
                  cgpa: cEdu.candcgpa,
                  currentlyPursuing: cEdu.currentypurs,
                  durationFrom: cEdu.edufromDate,
                  durationTo: cEdu.edutoDate,
                };
                if (!cEdu?.eduSrno) return;
                const encryptedId = await fetchEncryptedToken(cEdu.eduSrno, token);
                if (!encryptedId || encryptedId === 'null') return;

                const addCandEduUrl = `rest/empDetails/updateEduData/${encryptedId}`;
                axiosInstance
                  .put(addCandEduUrl, cEduData, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res4) => { })
                  .catch((err) => console.error('Error updating education:', err));
              });
            }
            if (removeEdus.length > 0) {
              removeEdus.forEach(async (remove) => {
                if (remove?.eduSrno && remove.eduSrno !== 0) {
                  const encryptedId = await fetchEncryptedToken(remove.eduSrno, token);
                  if (!encryptedId || encryptedId === 'null') return;

                  axiosInstance
                    .delete(`/rest/empDetails/deleteEduData/${encryptedId}`, {
                      headers: {
                        Authorization: `Bearer ${token}`,
                      },
                    })
                    .catch((err) => console.error('Error deleting education:', err));
                }
              });
            }
          }
        }
        if (activeStep === 5 || activeStep <= 7) {
          if (currentEmpExp || data.empExp) {
            const rawExpList = Array.isArray(data.empExp) ? data.empExp : [];
            const validExpList = rawExpList.filter(
              (item) => item && (item.compNm || item.designation || item.expSrno)
            );
            const addedExp = validExpList.filter((edu) => !edu.expSrno || edu.expSrno === 0);
            const updtExp = validExpList.filter((edu) => edu.expSrno && edu.expSrno !== 0);
            const removeExp = Array.isArray(EmpExp)
              ? EmpExp.filter(
                (currExp) =>
                  currExp?.expSrno && !validExpList.some((edu) => edu.expSrno === currExp.expSrno)
              )
              : [];

            if (addedExp.length > 0) {
              addedExp.forEach((cExp) => {
                if (!cExp.compNm && !cExp.designation) return;
                const cExpData = {
                  employeeId: {
                    employeeId: currentEmp?.employeeId,
                  },
                  company: cExp.compNm || '',
                  designation: cExp.designation || '',
                  ctcCurrency: cExp.ctccurncy || cExp.currencySymbol || '',
                  ctc: cExp.ctc ? encryptData(cExp.ctc) : null,
                  durationFrom: cExp.expfromDate || null,
                  durationTo: cExp.currentywrkng ? null : (cExp.exptoDate || null),
                  currentlyWorking: Boolean(cExp.currentywrkng),
                  country:
                    cExp.country && (typeof cExp.country !== 'string' || cExp.country.trim() !== '')
                      ? cExp.country
                      : null,
                  createdDate: new Date(),
                  lastUpdatedDate: new Date(),
                };
                const candExpUrl = `/rest/empDetails/addEmpExp`;
                axiosInstance
                  .post(candExpUrl, cExpData, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res5) => { })
                  .catch((err) => console.error('Error adding experience:', err));
              });
            }

            if (updtExp.length > 0) {
              updtExp.forEach(async (cExp) => {
                if (!cExp?.expSrno) return;
                const encryptedId = await fetchEncryptedToken(cExp.expSrno, token);
                if (!encryptedId || encryptedId === 'null') return;

                const cExpData = {
                  company: cExp.compNm || '',
                  designation: cExp.designation || '',
                  ctcCurrency: cExp.currencySymbol || cExp.ctccurncy || '',
                  empCountry:
                    cExp.country && (typeof cExp.country !== 'string' || cExp.country.trim() !== '')
                      ? cExp.country
                      : null,
                  country:
                    cExp.country && (typeof cExp.country !== 'string' || cExp.country.trim() !== '')
                      ? cExp.country
                      : null,
                  ctc: cExp.ctc ? encryptData(cExp.ctc) : null,
                  durationFrom: cExp.expfromDate || null,
                  durationTo: cExp.currentywrkng ? null : (cExp.exptoDate || null),
                  currentlyWorking: Boolean(cExp.currentywrkng),
                  lastUpdatedDate: new Date(),
                };

                const addCandExpUrl = `rest/empDetails/updateExpData/${encryptedId}`;
                axiosInstance
                  .put(addCandExpUrl, cExpData, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res6) => { })
                  .catch((err) => console.error('Error updating experience:', err));
              });
            }

            if (removeExp.length > 0) {
              removeExp.forEach(async (remove) => {
                if (remove?.expSrno && remove.expSrno !== 0) {
                  const encryptedId = await fetchEncryptedToken(remove.expSrno, token);
                  if (!encryptedId || encryptedId === 'null') return;
                  axiosInstance
                    .delete(`/rest/empDetails/deleteExpData/${encryptedId}`, {
                      headers: {
                        Authorization: `Bearer ${token}`,
                      },
                    })
                    .catch((err) => console.error('Error deleting experience:', err));
                }
              });
            }
          }
        }
        if (activeStep === 3 || activeStep <= 7) {
          if (currentEmpCert || data.empCert) {
            const addedCert = data.empCert.filter((edu) => edu.cerSrno === 0);
            const updtCert = data.empCert.filter((edu) => edu.cerSrno !== 0);
            const removeCert = EmpCert.filter(
              (currEdu) => !updtCert.some((edu) => edu.cerSrno === currEdu.cerSrno)
            );
            if (addedCert.length > 0) {
              addedCert.forEach((cCert) => {
                const cCertData = {
                  employeeId: {
                    employeeId: currentEmp?.employeeId,
                  },
                  certificationName: cCert.certiNm,
                  instituteName: cCert.certiInstiNm,
                  durationFrom: cCert.certfromDate,
                  durationTo: cCert.certtoDate,
                  createdDate: new Date(),
                  lastUpdatedDate: new Date(),
                };
                const candCertUrl = `/rest/empDetails/addEmpCert`;
                axiosInstance
                  .post(candCertUrl, cCertData, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res7) => { });
              });
            }
            if (updtCert.length > 0) {
              updtCert.forEach(async (cCert) => {
                const cCertData = {
                  certificationName: cCert.certiNm,
                  instituteName: cCert.certiInstiNm,
                  durationFrom: cCert.certfromDate,
                  durationTo: cCert.certtoDate,

                  lastUpdatedDate: new Date(),
                };
                if (!cCert?.cerSrno) return;
                const encryptedId = await fetchEncryptedToken(cCert.cerSrno, token);
                if (!encryptedId || encryptedId === 'null') return;

                const updtCandCertUrl = `rest/empDetails/updateCertData/${encryptedId}`;
                axiosInstance
                  .put(updtCandCertUrl, cCertData, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res9) => { })
                  .catch((err) => console.error('Error updating cert:', err));
              });
            }
            if (removeCert.length > 0) {
              removeCert.forEach(async (remove) => {
                if (remove?.cerSrno && remove.cerSrno !== 0) {
                  const encryptedId = await fetchEncryptedToken(remove.cerSrno, token);
                  if (!encryptedId || encryptedId === 'null') return;
                  axiosInstance
                    .delete(`/rest/empDetails/deleteCertData/${encryptedId}`, {
                      headers: {
                        Authorization: `Bearer ${token}`,
                      },
                    })
                    .catch((err) => console.error('Error deleting cert:', err));
                }
              });
            }
          }
        }
        if (activeStep === 5 || activeStep <= 7) {
          if (currentEmpRef || data.empRef) {
            const addedRef = data.empRef.filter((edu) => edu.refSrno === 0);
            const updtRef = data.empRef.filter((edu) => edu.refSrno !== 0);
            const removeRef = EmpRef.filter(
              (currEdu) => !updtRef.some((edu) => edu.refSrno === currEdu.refSrno)
            );
            if (addedRef.length > 0) {
              addedRef.forEach((cRef) => {
                const cRefData = {
                  employeeId: {
                    employeeId: currentEmp.employeeId,
                  },
                  empReferenceName: cRef.refNm,
                  empReferenceOrganization: cRef.refOrgNm,
                  designationId: cRef.refdesig,
                  empReferenceEmail: encryptData(cRef.refEmail),
                  empReferenceContactNumber: encryptData(cRef.refContact),
                  createdDate: new Date(),
                  lastUpdatedDate: new Date(),
                };
                const candRefUrl = `/rest/empDetails/addEmpRef`;
                axiosInstance
                  .post(candRefUrl, cRefData, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res7) => { });
              });
            }
            if (updtRef.length > 0) {
              updtRef.forEach(async (cRef) => {
                const cRefData = {
                  empReferenceName: cRef.refNm,
                  empReferenceOrganization: cRef.refOrgNm,
                  designationId: cRef.refdesig,
                  empReferenceEmail: encryptData(cRef.refEmail),
                  empReferenceContactNumber: encryptData(cRef.refContact),

                  lastUpdatedDate: new Date(),
                };
                if (!cRef?.refSrno) return;
                const encryptedId = await fetchEncryptedToken(cRef.refSrno, token);
                if (!encryptedId || encryptedId === 'null') return;

                const updtCandRefUrl = `rest/empDetails/updateRefData/${encryptedId}`;
                axiosInstance
                  .put(updtCandRefUrl, cRefData, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res9) => { })
                  .catch((err) => console.error('Error updating reference:', err));
              });
            }
            if (removeRef.length > 0) {
              removeRef.forEach(async (remove) => {
                if (remove?.refSrno && remove.refSrno !== 0) {
                  const encryptedId = await fetchEncryptedToken(remove.refSrno, token);
                  if (!encryptedId || encryptedId === 'null') return;

                  axiosInstance
                    .delete(`/rest/empDetails/deleteRefData/${encryptedId}`, {
                      headers: {
                        Authorization: `Bearer ${token}`,
                      },
                    })
                    .catch((err) => console.error('Error deleting reference:', err));
                }
              });
            }
          }
        }
        if (activeStep === 3 || activeStep <= 7) {
          if (currentEmpLang || data.empLang) {
            const addedLang = data.empLang.filter((edu) => edu.langSrno === 0);
            const updtLang = data.empLang.filter((edu) => edu.langSrno !== 0);
            const removeLang = EmpLang.filter(
              (currEdu) => !updtLang.some((edu) => edu.langSrno === currEdu.langSrno)
            );
            if (addedLang.length > 0) {
              addedLang.forEach((eLang) => {
                const eLangKnwn = {
                  employee: {
                    employeeId: currentEmp.employeeId,
                  },
                  language: eLang.lang,
                  read: eLang.read,
                  write: eLang.write,
                  speak: eLang.speak,
                  createdDate: new Date(),
                  lastUpdatedDate: new Date(),
                };
                const eLangUrl = `/rest/empDetails/addEmpLang`;
                axiosInstance
                  .post(eLangUrl, eLangKnwn, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res7) => { });
              });
            }
            if (updtLang.length > 0) {
              updtLang.forEach(async (eLang) => {
                const eLangKnwn = {
                  language: eLang.lang,
                  read: eLang.read,
                  write: eLang.write,
                  speak: eLang.speak,

                  lastUpdatedDate: new Date(),
                };
                const encryptedId = await fetchEncryptedToken(eLang.langSrno, token);

                const updtLangKnwnUrl = `/rest/empDetails/updateLangData/${encryptedId}`;
                axiosInstance
                  .put(updtLangKnwnUrl, eLangKnwn, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res9) => { });
              });
            }
            if (removeLang.length > 0) {
              removeLang.forEach(async (remove) => {
                if (remove?.srno !== 0) {
                  const encryptedId = await fetchEncryptedToken(remove?.langSrno, token);

                  axiosInstance.delete(`/rest/empDetails/deleteLangData/${encryptedId}`, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  });
                }
              });
            }
          }
        }
        if (activeStep === 6 || activeStep <= 7) {
          if (currentEmpBank || data.empBank) {
            const addedBank = data.empBank.filter((edu) => edu.bankSrno === 0);
            const updtBank = data.empBank.filter((edu) => edu.bankSrno !== 0);
            const removeBank = EmpBank.filter(
              (currEdu) => !updtBank.some((edu) => edu.bankSrno === currEdu.bankSrno)
            );
            if (addedBank.length > 0) {
              addedBank.forEach((eBank) => {
                const empBankD = {
                  employee: {
                    employeeId: currentEmp.employeeId,
                  },
                  bankName: eBank.bankNm,
                  branch: eBank.branch,
                  accountName: eBank.accNm,
                  accountType: eBank.accTyp,
                  accountNumber: encryptData(eBank.accNo),
                  ifsc: encryptData(eBank.ifsc),
                  swiftCode: encryptData(eBank.swiftCd),
                  startDate: eBank.startDate,
                  endDate: eBank.endDate,
                  createdDate: new Date(),
                  lastUpdatedDate: new Date(),
                };
                const eBankUrl = `/rest/empDetails/addEmpBank`;
                axiosInstance
                  .post(eBankUrl, empBankD, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res7) => { });
              });
            }
            if (updtBank.length > 0) {
              updtBank.forEach(async (eBank) => {
                const empBankD = {
                  bankName: eBank.bankNm,
                  branch: eBank.branch,
                  accountName: eBank.accNm,
                  accountType: eBank.accTyp,
                  accountNumber: encryptData(eBank.accNo),
                  ifsc: encryptData(eBank.ifsc),
                  swiftCode: encryptData(eBank.swiftCd),
                  startDate: eBank.startDate,
                  endDate: eBank.endDate,

                  lastUpdatedDate: new Date(),
                };
                const encryptedId = await fetchEncryptedToken(eBank.bankSrno, token);

                const updtBankUrl = `/rest/empDetails/updateBankData/${encryptedId}`;

                axiosInstance
                  .put(updtBankUrl, empBankD, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res9) => { });
              });
            }
            if (removeBank.length > 0) {
              removeBank.forEach(async (remove) => {
                const encryptedId = await fetchEncryptedToken(remove?.bankSrno, token);

                axiosInstance.delete(`/rest/empDetails/deleteBankData/${encryptedId}`, {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                });
              });
            }
          }
        }
        if (activeStep === 4 || activeStep <= 7) {
          if (currentEmpVisa || data.empVisa) {
            const addedVisa = data.empVisa.filter((edu) => edu.visaSrno === 0);
            const updtVisa = data.empVisa.filter((edu) => edu.visaSrno !== 0);
            const removeVisa = EmpVisa.filter(
              (currEdu) => !updtVisa.some((edu) => edu.visaSrno === currEdu.visaSrno)
            );
            if (addedVisa.length > 0) {
              addedVisa.forEach((eVisa) => {
                const empVisaD = {
                  employee: {
                    employeeId: currentEmp.employeeId,
                  },
                  visaNumber: encryptData(eVisa.visaNo),
                  visaNameId: eVisa.visaNm,
                  visaTypeId: eVisa.visaTyp,
                  placeOfIssue: eVisa.placeOfissue,
                  dateOfIssue: eVisa.issueDt,
                  dateOfExpiry: eVisa.expiryDt,
                  visaForCountry: eVisa.forCntry,
                  createdDate: new Date(),
                  lastUpdatedDate: new Date(),
                };
                const eVisaUrl = `/rest/empDetails/addEmpVisa`;
                axiosInstance
                  .post(eVisaUrl, empVisaD, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res7) => { });
              });
            }
            if (updtVisa.length > 0) {
              updtVisa.forEach(async (eVisa) => {
                const empVisaD = {
                  visaNumber: encryptData(eVisa.visaNo),
                  visaNameId: eVisa.visaNm,
                  visaTypeId: eVisa.visaTyp,
                  placeOfIssue: eVisa.placeOfissue,
                  dateOfIssue: eVisa.issueDt,
                  dateOfExpiry: eVisa.expiryDt,
                  visaForCountry: eVisa.forCntry,

                  lastUpdatedDate: new Date(),
                };

                const encryptedId = await fetchEncryptedToken(eVisa.visaSrno, token);

                const updtVisaUrl = `/rest/empDetails/updateVisaData/${encryptedId}`;

                axiosInstance
                  .put(updtVisaUrl, empVisaD, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res9) => { });
              });
            }
            if (removeVisa.length > 0) {
              removeVisa.forEach(async (remove) => {
                if (remove?.visaSrno) {
                  const encryptedId = await fetchEncryptedToken(remove?.visaSrno, token);

                  axiosInstance.delete(`/rest/empDetails/deleteVisaData/${encryptedId}`, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  });
                }
              });
            }
          }
        }
        if (activeStep === 7) {
          if (currentEmpWrk || data.empRelWrkn) {
            const addedWrk = data.empRelWrkn.filter((edu) => edu.cntctSrno === 0);
            const updtWrk = data.empRelWrkn.filter((edu) => edu.cntctSrno !== 0);
            const removeWrk = EmpWrk.filter(
              (currEdu) => !updtWrk.some((edu) => edu.cntctSrno === currEdu.cntctSrno)
            );
            if (addedWrk.length > 0) {
              addedWrk.forEach((eRelwrk) => {
                const empRelWrkD = {
                  employeeId: {
                    employeeId,
                  },
                  relEmpName: eRelwrk.name,
                  citiesId: eRelwrk.curAddCity,
                  countryId: eRelwrk.curAddCntr,
                  stateId: eRelwrk.curAddState,
                  designationId: eRelwrk.refdesig,
                  relationshipId: eRelwrk.relationship,
                  createdDate: new Date(),
                  lastUpdatedDate: new Date(),
                };
                const eWrkRelUrl = `/rest/empDetails/addEmpRelWrk`;
                axiosInstance
                  .post(eWrkRelUrl, empRelWrkD, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res7) => { });
              });
            }
            if (updtWrk.length > 0) {
              updtWrk.forEach(async (eRelwrk) => {
                const empRelWrkD = {
                  relEmpName: eRelwrk.name,
                  citiesId: eRelwrk.curAddCity,
                  countryId: eRelwrk.curAddCntr,
                  stateId: eRelwrk.curAddState,
                  designationId: eRelwrk.refdesig,
                  relationshipId: eRelwrk.relationship,

                  lastUpdatedDate: new Date(),
                };
                const encryptedId = await fetchEncryptedToken(eRelwrk.cntctSrno, token);

                const updtRelWrkUrl = `rest/empDetails/updateWrkData/${encryptedId}`;
                axiosInstance
                  .put(updtRelWrkUrl, empRelWrkD, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res9) => { });
              });
            }
            if (removeWrk.length > 0) {
              removeWrk.forEach(async (remove) => {
                if (remove?.srno) {
                  const encryptedId = await fetchEncryptedToken(remove?.cntctSrno, token);

                  axiosInstance.delete(`/rest/empDetails/deleteWrkData/${encryptedId}`, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  });
                }
              });
            }
          }
        }
        if (activeStep === 1 || activeStep <= 7) {
          if (currentEmpFam || data.empFamilyRel) {
            const addedFam = data.empFamilyRel.filter((edu) => edu.relSrno === 0);
            const updtFam = data.empFamilyRel.filter((edu) => edu.relSrno !== 0);
            const removeFam = EmpFam.filter(
              (currEdu) => !updtFam.some((edu) => edu.relSrno === currEdu.relSrno)
            );
            if (addedFam.length > 0) {
              addedFam.forEach((eFam) => {
                const eFamRel = {
                  employee: {
                    employeeId: currentEmp.employeeId,
                  },
                  relativeName: eFam.name,
                  relationship: eFam.relationship,
                  dateOfBirth: eFam.dob,
                  alive: eFam.isAlive,
                  passportNumber: encryptData(eFam.passNo),
                  createdDate: new Date(),
                  lastUpdatedDate: new Date(),
                };
                const eFamUrl = `/rest/empDetails/addEmpFam`;
                axiosInstance
                  .post(eFamUrl, eFamRel, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res7) => { });
              });
            }
            if (updtFam.length > 0) {
              updtFam.forEach(async (eFam) => {
                const eFamRel = {
                  relativeName: eFam.name,
                  relationship: eFam.relationship,
                  dateOfBirth: eFam.dob,
                  alive: eFam.isAlive,
                  passportNumber: encryptData(eFam.passNo),

                  lastUpdatedDate: new Date(),
                };
                const encryptedId = await fetchEncryptedToken(eFam.relSrno, token);

                const updtFamUrl = `rest/empDetails/updateFamData/${encryptedId}`;
                axiosInstance
                  .put(updtFamUrl, eFamRel, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res9) => { });
              });
            }
            if (removeFam.length > 0) {
              removeFam.forEach(async (remove) => {
                if (remove?.srno) {
                  const encryptedId = await fetchEncryptedToken(remove?.relSrno, token);

                  axiosInstance.delete(`/rest/empDetails/deleteFamData/${encryptedId}`, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  });
                }
              });
            }
          }
        }
        if (activeStep === 4 || activeStep <= 7) {
          if (currentEmpPass || data.empPassport) {
            const addedPass = data.empPassport.filter((edu) => edu.passSrno === 0);
            const updtPass = data.empPassport.filter((edu) => edu.passSrno !== 0);
            const removePass = EmpPass.filter(
              (currEdu) => !updtPass.some((edu) => edu.passSrno === currEdu.passSrno)
            );
            if (addedPass.length > 0) {
              addedPass.forEach((passPrt) => {
                const passPrtD = {
                  employee: {
                    employeeId: currentEmp.employeeId,
                  },
                  passportNumber: encryptData(passPrt.passNo),
                  ecnrstampedName: passPrt.ecnrStamp,
                  placeOfIssue: passPrt.issuePlace,
                  dateOfIssue: passPrt.issueDt,
                  dateOfExpiry: passPrt.expiryDt,
                  startDate: data.startDate,
                  createdDate: data.createdDate,
                  lastUpdatedDate: data.lastUpdatedDate,
                };
                const addPassprtUrl = `/rest/empDetails/addPassport`;
                axiosInstance
                  .post(addPassprtUrl, passPrtD, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res1) => { });
              });
            }
            if (updtPass.length > 0) {
              updtPass.forEach(async (passPrt) => {
                const passPrtD = {
                  passportNumber: encryptData(passPrt.passNo),
                  ecnrstampedName: passPrt.ecnrStamp,
                  placeOfIssue: passPrt.issuePlace,
                  dateOfIssue: passPrt.issueDt,
                  dateOfExpiry: passPrt.expiryDt,

                  startDate: data.startDate,
                  lastUpdatedDate: data.lastUpdatedDate,
                };
                const encryptedId = await fetchEncryptedToken(passPrt.passSrno, token);

                const updtPassUrl = `rest/empDetails/updatePassData/${encryptedId}`;
                axiosInstance
                  .put(updtPassUrl, passPrtD, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res9) => { });
              });
            }
            if (removePass.length > 0) {
              removePass.forEach(async (remove) => {
                const encryptedId = await fetchEncryptedToken(remove?.passSrno, token);

                axiosInstance.delete(`/rest/empDetails/deletePassData/${encryptedId}`, {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                });
              });
            }
          }
        }
        if (activeStep === 2 || activeStep <= 7) {
          if (currentEmpEmrg || data.empEmrgncyContact) {
            const addedEmrgs = data.empEmrgncyContact.filter((edu) => edu.cntctSrno === 0);
            const updtEmrgs = data.empEmrgncyContact.filter((edu) => edu.cntctSrno !== 0);
            const removeEmrgs = EmpEmrg.filter(
              (currEmrg) => !updtEmrgs.some((edu) => edu.cntctSrno === currEmrg.cntctSrno)
            );
            if (addedEmrgs.length > 0) {
              addedEmrgs.forEach((emrgContct) => {
                const emrgContctD = {
                  employee: {
                    employeeId: currentEmp.employeeId,
                  },
                  fullName: emrgContct.name,
                  email: encryptData(emrgContct.email),
                  mobileNumber: encryptData(emrgContct.mobno),
                  relationId: emrgContct.relationship,
                  address1: emrgContct.curAddLn1,
                  address2: emrgContct.curAddLn2,
                  landmark: emrgContct.curAddLandMrk,
                  citiesId: emrgContct.curAddCity,
                  stateId: emrgContct.curAddState,
                  countriesId: emrgContct.curAddCntr,
                  zipcode: emrgContct.curAddZip,
                  startDate: data.startDate,
                  createdDate: data.createdDate,
                  lastUpdatedDate: data.lastUpdatedDate,
                };
                const addPassprtUrl = `/rest/empDetails/addEmrgncy`;
                axiosInstance
                  .post(addPassprtUrl, emrgContctD, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res1) => { });
              });
            }
            if (updtEmrgs.length > 0) {
              updtEmrgs.forEach(async (emrgContct) => {
                const emrgContctD = {
                  fullName: emrgContct.name,
                  email: encryptData(emrgContct.email),
                  mobileNumber: encryptData(emrgContct.mobno),
                  relationId: emrgContct.relationship,
                  address1: emrgContct.curAddLn1,
                  address2: emrgContct.curAddLn2,
                  landmark: emrgContct.curAddLandMrk,
                  citiesId: emrgContct.curAddCity,
                  stateId: emrgContct.curAddState,
                  countriesId: emrgContct.curAddCntr,
                  zipcode: emrgContct.curAddZip,

                  startDate: data.startDate,
                  lastUpdatedDate: data.lastUpdatedDate,
                };

                const encryptedId = await fetchEncryptedToken(emrgContct.cntctSrno, token);

                const updtContUrl = `rest/empDetails/updateEmrgData/${encryptedId}`;
                axiosInstance
                  .put(updtContUrl, emrgContctD, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  })
                  .then((res9) => { });
              });
            }
            if (removeEmrgs.length > 0) {
              removeEmrgs.forEach(async (remove) => {
                if (remove?.srno) {
                  const encryptedId = await fetchEncryptedToken(remove?.cntctSrno, token);

                  axiosInstance.delete(`/rest/empDetails/deleteEmrgData/${encryptedId}`, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  });
                }
              });
            }
          }
        }
        if (currentEmpImpQ || data.impQuesC) {
          data.impQuesC.forEach(async (eImpQ) => {
            const qId =
              typeof eImpQ.impQue === 'object'
                ? eImpQ.impQue?.id ||
                eImpQ.impQue?.masterId ||
                eImpQ.impQue?.impQueId ||
                (eImpQ.impQue?.questionId &&
                  (eImpQ.impQue.questionId.id || eImpQ.impQue.questionId.masterId))
                : eImpQ.impQue;

            const answerVal =
              typeof eImpQ.ans === 'object'
                ? eImpQ.ans?.value || eImpQ.ans?.label || ''
                : eImpQ.ans || '';

            if (eImpQ?.iqSrno && eImpQ.iqSrno !== 0) {
              const empImpQD = {
                questionId: {
                  id: Number(qId),
                },
                answer: answerVal,
                ansDetails: eImpQ.ansComment,
              };

              const encryptedId = await fetchEncryptedToken(eImpQ.iqSrno, token);

              const eImpQUrl = `/rest/empDetails/updateImpQData/${encryptedId}`;
              axiosInstance
                .put(eImpQUrl, empImpQD, {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                })
                .then((res9) => { });
            } else {
              const empImpQD = {
                employeeId: {
                  employeeId: currentEmp.employeeId,
                },
                questionId: {
                  id: Number(qId),
                },
                answer: answerVal,
                ansDetails: eImpQ.ansComment,
              };
              const eImpQUrl = `/rest/empDetails/addEmpImpQue`;
              axiosInstance
                .post(eImpQUrl, empImpQD, {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                })
                .then((res9) => { });
            }
          });
        }
        setSavedEmployeeId(currentEmp.employeeId);
        if (activeStep === steps.length - 1) {
          setOpenDialog(true); // Only open if it's really final step
        }
      } else {
        formData.append('candidateId', data.candidate.candidateId);
        const addEmpUrl = `/rest/employee/addEmp`;

        await axiosInstance
          .post(addEmpUrl, formData, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then(async (res) => {
            const promises = [];

            const generatedEmployeeID = await fetchEncryptedToken(
              res.data.employee.employeeId,
              token
            );

            setCurEmpCode(res.data.employee.employeeCode);
            handleSendEmail(res.data.employee, res.data.candReq);

            const waitForEmployeeId = async (getIdFn, timeout = 5000, interval = 100) => {
              const start = Date.now();
              return new Promise((resolve, reject) => {
                const check = () => {
                  const id = getIdFn();
                  if (id) return resolve(id);
                  // eslint-disable-next-line prefer-promise-reject-errors
                  if (Date.now() - start > timeout)
                    return reject('Employee ID not available in time');
                  setTimeout(check, interval);
                };
                check();
              });
            };

            data.empPassport.forEach(async (passPrt) => {
              try {
                // Wait until employeeId is available
                const employeeId = await waitForEmployeeId(() => res.data.employee?.employeeId);
                const passPrtD = {
                  employee: {
                    employeeId,
                  },
                  passportNumber: encryptData(passPrt.passNo),
                  ecnrstampedName: passPrt.ecnrStamp,
                  placeOfIssue: passPrt.issuePlace,
                  dateOfIssue: passPrt.issueDt,
                  dateOfExpiry: passPrt.expiryDt,
                  startDate: data.startDate,
                  createdDate: data.createdDate,
                  lastUpdatedDate: data.lastUpdatedDate,
                };
                const addPassprtUrl = `/rest/empDetails/addPassport`;
                axiosInstance.post(addPassprtUrl, passPrtD, {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                });
              } catch (err) {
                console.error('Skipping passport API, employeeId not available', err);
              }
            });

            data.empEmrgncyContact.forEach(async (emrgContct) => {
              try {
                // Wait until employeeId is available
                const employeeId = await waitForEmployeeId(() => res.data.employee?.employeeId);
                const emrgContctD = {
                  employee: {
                    employeeId,
                  },
                  fullName: emrgContct.name,
                  email: encryptData(emrgContct.email),
                  mobileNumber: encryptData(emrgContct.mobno),
                  relationId: emrgContct.relationship,
                  address1: emrgContct.curAddLn1,
                  address2: emrgContct.curAddLn2,
                  landmark: emrgContct.curAddLandMrk,
                  citiesId: emrgContct.curAddCity,
                  stateId: emrgContct.curAddState,
                  countriesId: emrgContct.curAddCntr,
                  zipcode: emrgContct.curAddZip,
                  startDate: data.startDate,
                  createdDate: data.createdDate,
                  lastUpdatedDate: data.lastUpdatedDate,
                };
                const addPassprtUrl = `/rest/empDetails/addEmrgncy`;
                axiosInstance.post(addPassprtUrl, emrgContctD, {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                });
              } catch (err) {
                console.error('Skipping emergency contact API, employeeId not available', err);
              }
            });

            data.empEdu.forEach(async (cEdu) => {
              try {
                // Wait until employeeId is available
                const employeeId = await waitForEmployeeId(() => res.data.employee?.employeeId);

                const cEduData = {
                  empId: {
                    employeeId,
                  },
                  university: cEdu.university,
                  qualification: cEdu.qualification,
                  qualificationTypeId: cEdu.qualtype,
                  stream: cEdu.stream,
                  percentage: cEdu.candpercnt,
                  cgpa: cEdu.candcgpa,
                  durationFrom: cEdu.edufromDate,
                  durationTo: cEdu.edutoDate,
                  createdDate: new Date(),
                  lastUpdatedDate: new Date(),
                };
                const addCandEduUrl = `/rest/empDetails/addEmpEdu`;
                axiosInstance.post(addCandEduUrl, cEduData, {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                });
              } catch (err) {
                console.error('Skipping education API, employeeId not available', err);
              }
            });

            if (switchState.experience && Array.isArray(data.empExp) && data.empExp.length > 0) {
              const validExpList = data.empExp.filter(
                (item) => item && (item.compNm || item.designation)
              );
              validExpList.forEach(async (cExp) => {
                try {
                  // Wait until employeeId is available
                  const employeeId = await waitForEmployeeId(() => res.data.employee?.employeeId);

                  const cExpData = {
                    employeeId: {
                      employeeId,
                    },
                    company: cExp.compNm,
                    designation: cExp.designation,
                    ctcCurrency: cExp.ctccurncy,
                    ctc: cExp.ctc ? encryptData(cExp.ctc) : null,
                    durationFrom: cExp.expfromDate,
                    durationTo: cExp.currentywrkng ? null : (cExp.exptoDate || null),
                    currentlyWorking: Boolean(cExp.currentywrkng),
                    country:
                      cExp.country && (typeof cExp.country !== 'string' || cExp.country.trim() !== '')
                        ? cExp.country
                        : null,
                    createdDate: new Date(),
                    lastUpdatedDate: new Date(),
                  };
                  const candExpUrl = `/rest/empDetails/addEmpExp`;
                  axiosInstance.post(candExpUrl, cExpData, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  });
                } catch (err) {
                  console.error('Skipping experience API, employeeId not available', err);
                }
              });
            }

            data.empCert.forEach(async (cCert) => {
              try {
                // Wait until employeeId is available
                const employeeId = await waitForEmployeeId(() => res.data.employee?.employeeId);

                const cCertData = {
                  employeeId: {
                    employeeId,
                  },
                  certificationName: cCert.certiNm,
                  instituteName: cCert.certiInstiNm,
                  durationFrom: cCert.certfromDate,
                  durationTo: cCert.certtoDate,
                  createdDate: new Date(),
                  lastUpdatedDate: new Date(),
                };
                const candCertUrl = `/rest/empDetails/addEmpCert`;
                axiosInstance.post(candCertUrl, cCertData, {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                });
              } catch (err) {
                console.error('Skipping certification API, employeeId not available', err);
              }
            });

            data.empRef.forEach(async (cRef) => {
              try {
                // Wait until employeeId is available
                const employeeId = await waitForEmployeeId(() => res.data.employee?.employeeId);

                const cRefData = {
                  employeeId: {
                    employeeId,
                  },
                  empReferenceName: cRef.refNm,
                  empReferenceOrganization: cRef.refOrgNm,
                  designationId: cRef.refdesig,
                  empReferenceEmail: encryptData(cRef.refEmail),
                  empReferenceContactNumber: encryptData(cRef.refContact),
                  createdDate: new Date(),
                  lastUpdatedDate: new Date(),
                };
                const candRefUrl = `/rest/empDetails/addEmpRef`;
                axiosInstance.post(candRefUrl, cRefData, {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                });
              } catch (err) {
                console.error('Skipping reference API, employeeId not available', err);
              }
            });

            data.empFamilyRel.forEach(async (eFam) => {
              try {
                // Wait until employeeId is available
                const employeeId = await waitForEmployeeId(() => res.data.employee?.employeeId);
                const eFamRel = {
                  employee: {
                    employeeId,
                  },
                  relativeName: eFam.name,
                  relationship: eFam.relationship,
                  dateOfBirth: eFam.dob,
                  alive: eFam.isAlive,
                  passportNumber: encryptData(eFam.passNo),
                  createdDate: new Date(),
                  lastUpdatedDate: new Date(),
                };
                const eFamUrl = `/rest/empDetails/addEmpFam`;
                axiosInstance.post(eFamUrl, eFamRel, {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                });
              } catch (err) {
                console.error('Skipping family relative API, employeeId not available', err);
              }
            });

            data.empLang.forEach(async (eLang) => {
              try {
                // Wait until employeeId is available
                const employeeId = await waitForEmployeeId(() => res.data.employee?.employeeId);

                const eLangKnwn = {
                  employee: {
                    employeeId,
                  },
                  language: eLang.lang,
                  read: eLang.read,
                  write: eLang.write,
                  speak: eLang.speak,
                  createdDate: new Date(),
                  lastUpdatedDate: new Date(),
                };
                const eLangUrl = `/rest/empDetails/addEmpLang`;
                axiosInstance.post(eLangUrl, eLangKnwn, {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                });
              } catch (err) {
                console.error('Skipping language API, employeeId not available', err);
              }
            });

            data.empVisa.forEach(async (eVisa) => {
              try {
                // Wait until employeeId is available
                const employeeId = await waitForEmployeeId(() => res.data.employee?.employeeId);
                const empVisaD = {
                  employee: {
                    employeeId,
                  },
                  visaNumber: encryptData(eVisa.visaNo),
                  visaNameId: eVisa.visaNm,
                  visaTypeId: eVisa.visaTyp,
                  placeOfIssue: eVisa.placeOfissue,
                  dateOfIssue: eVisa.issueDt,
                  dateOfExpiry: eVisa.expiryDt,
                  visaForCountry: eVisa.forCntry,
                  createdDate: new Date(),
                  lastUpdatedDate: new Date(),
                };
                const eVisaUrl = `/rest/empDetails/addEmpVisa`;
                axiosInstance.post(eVisaUrl, empVisaD, {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                });
              } catch (err) {
                console.error('Skipping Visa API, employeeId not available', err);
              }
            });

            data.empBank.forEach(async (eBank) => {
              try {
                // Wait until employeeId is available
                const employeeId = await waitForEmployeeId(() => res.data.employee?.employeeId);

                const empBankD = {
                  employee: {
                    employeeId,
                  },
                  bankName: eBank.bankNm,
                  branch: eBank.branch,
                  accountName: eBank.accNm,
                  accountType: eBank.accTyp,
                  accountNumber: encryptData(eBank.accNo),
                  ifsc: encryptData(eBank.ifsc),
                  swiftCode: encryptData(eBank.swiftCd),
                  startDate: eBank.startDate,
                  endDate: eBank.endDate,
                  createdDate: new Date(),
                  lastUpdatedDate: new Date(),
                };
                const eBankUrl = `/rest/empDetails/addEmpBank`;
                axiosInstance.post(eBankUrl, empBankD, {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                });
              } catch (err) {
                console.error('Skipping Bank API, employeeId not available', err);
              }
            });

            data.empRelWrkn.forEach(async (eRelwrk) => {
              try {
                // Wait until employeeId is available
                const employeeId = await waitForEmployeeId(() => res.data.employee?.employeeId);

                const empRelWrkD = {
                  employeeId: {
                    employeeId,
                  },
                  relEmpName: eRelwrk.name,
                  citiesId: eRelwrk.curAddCity,
                  countryId: eRelwrk.curAddCntr,
                  stateId: eRelwrk.curAddState,
                  designationId: eRelwrk.refdesig,
                  relationshipId: eRelwrk.relationship,
                  createdDate: new Date(),
                  lastUpdatedDate: new Date(),
                };
                const eWrkRelUrl = `/rest/empDetails/addEmpRelWrk`;
                axiosInstance.post(eWrkRelUrl, empRelWrkD, {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                });
              } catch (err) {
                console.error('Skipping Work Relationship API, employeeId not available', err);
              }
            });

            data.impQuesC.forEach(async (eImpQ) => {
              try {
                // Wait until employeeId is available
                const employeeId = await waitForEmployeeId(() => res.data.employee?.employeeId);

                const qId =
                  typeof eImpQ.impQue === 'object'
                    ? eImpQ.impQue?.id ||
                    eImpQ.impQue?.masterId ||
                    eImpQ.impQue?.impQueId ||
                    (eImpQ.impQue?.questionId &&
                      (eImpQ.impQue.questionId.id || eImpQ.impQue.questionId.masterId))
                    : eImpQ.impQue;

                const answerVal =
                  typeof eImpQ.ans === 'object'
                    ? eImpQ.ans?.value || eImpQ.ans?.label || ''
                    : eImpQ.ans || '';

                const empImpQD = {
                  employeeId: {
                    employeeId,
                  },
                  questionId: {
                    id: Number(qId),
                  },
                  answer: answerVal,
                  ansDetails: eImpQ.ansComment,
                };
                const eImpQUrl = `/rest/empDetails/addEmpImpQue`;
                axiosInstance.post(eImpQUrl, empImpQD, {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                });
              } catch (err) {
                console.error('Skipping Important Questions API, employeeId not available', err);
              }
            });

            setValue('empCode', res.data.employee.employeeCode);
            // Wait for all operations to complete
            await Promise.all(promises);
            router.push(paths.dashboard.humanResources.EditEmployee(generatedEmployeeID));
          });
      }
      if (activeStep === steps.length - 1 && !currentEmp) {
        enqueueSnackbar('Employee Created Successfully!', { variant: 'success' });
        enqueueSnackbar(
          currentEmp ? 'Employee Updated Successfully!' : 'Employee Created Successfully!',
          { variant: 'success' }
        );
        handleSave(); // Save activeStep before API call
        setOpenDialog(true); // Only open if it's really final step
      }
    } catch (error) {
      console.error(error);
      handleApiError(error);
    }
  });
  const handleViewUploadedDocuments = async () => {
    const encryptedId = await fetchEncryptedToken(currentEmp.employeeId, token);

    router.push(paths.dashboard.humanResources.EmployeeDocumentUploadView(encryptedId));
  };

  const handleUploadDocuments = async () => {
    setOpenDialog(false);
    const encryptedId = await fetchEncryptedToken(savedEmployeeId, token);

    router.push(paths.dashboard.humanResources.EmployeeDocumentUpload(encryptedId));
  };

  const handleUploadDocumentsEdit = async (id) => {
    setOpenDialog(false);
    const encryptedId = await fetchEncryptedToken(id, token);

    router.push(paths.dashboard.humanResources.EmployeeDocumentUpload(encryptedId));
  };

  const handleSkipUpload = () => {
    setOpenDialog(false);
    if (!currentEmp) {
      router.push(paths.dashboard.humanResources.EditEmployee(savedEmployeeId));
    }
  };
  // -----------------------------------------------------------------------------------------------------------------------

  const isStepOptional = (step) => step === 1;

  const isStepSkipped = (step) => skipped?.has(step);

  const DynamicData = methods.getValues();

  const employeeId = currentEmp?.employeeId;

  const handleSave = async () => {
    const fieldKeys = Object.keys(stepsvalidator[activeStep]?.fields || {});

    if (fieldKeys.length > 0) {
      const isValid = await trigger(fieldKeys);
      if (!isValid) {
        enqueueSnackbar('Please complete all required fields before saving.', {
          variant: 'warning',
        });
        return; // prevent save if invalid
      }
    }

    if (currentEmp) {
      localStorage.setItem(`activeStep_${employeeId}`, activeStep.toString());
    } else {
      localStorage.setItem('activeStepKey', activeStep.toString());
    }
  };

  const handleNext = async () => {
    let isValid = true;

    if (stepsvalidator[activeStep]) {
      const fieldKeys = Object.keys(stepsvalidator[activeStep].fields || {});

      if (activeStep === 0) {
        if (fieldKeys.length > 0) {
          // Exclude 'candidate' from blocking validation
          const filteredFields = fieldKeys.filter((key) => key !== 'candidate');
          isValid = await trigger(filteredFields);
        }

        // Check candidate manually and show warning if not filled
        const candidateValue = getValues('candidate');

        if (typeof candidateValue === 'undefined' && !currentEmp) {
          enqueueSnackbar('Candidate selection is recommended before proceeding.', {
            variant: 'warning',
            autoHideDuration: 3000,
          });

          return isValid;
        }
      } else {
        // eslint-disable-next-line no-lonely-if
        if (fieldKeys.length > 0) {
          isValid = await trigger(fieldKeys);
        }
      }
    }

    if (activeStep === steps.length - 1) {
      enqueueSnackbar('Don’t forget to save your changes before proceeding to the next step!', {
        variant: 'warning',
        autoHideDuration: 3000,
      });
    }

    setActiveStep((prev) => {
      const newStep = prev + 1;
      localStorage.setItem(`activeStep_${employeeId || 'new'}`, newStep.toString());
      return newStep;
    });

    handleStepChange(activeStep + 1);

    setStepCompletionStatus((prev) => {
      const newStatus = [...prev];
      newStatus[activeStep] = isValid && !stepHasDuplicate(activeStep);
      return newStatus;
    });
  };

  const handleBack = async () => {
    const fieldKeys = Object.keys(stepsvalidator[activeStep]?.fields || {});

    setActiveStep((prev) => {
      const newStep = Math.max(prev - 1, 0);
      localStorage.setItem(`activeStep_${employeeId || 'new'}`, newStep.toString());
      return newStep;
    });
    handleStepChange(Math.max(activeStep - 1, 0));
  };

  const handleSaveNext = async () => {
    const currentStepFields = Object.keys(stepsvalidator[activeStep].fields);
    const isValid = await trigger(currentStepFields);

    if (!isValid) {
      console.warn(' Validation failed for step', activeStep);
      enqueueSnackbar('Please complete all required fields before proceeding.', {
        variant: 'warning',
      });
      return;
    }

    // Give the form state a moment to sync
    await new Promise((res) => setTimeout(res, 0));

    const formData = methods.getValues();

    try {
      await handleFormSubmission(formData, true);

      // Save the active step
      if (employeeId) {
        localStorage.setItem(`activeStep_${employeeId}`, (activeStep + 1).toString());
      } else {
        localStorage.setItem('activeStep_new', (activeStep + 1).toString());
      }

      setActiveStep((prev) => prev + 1);
      handleStepChange(activeStep + 1);

      setStepCompletionStatus((prev) => {
        const newStatus = [...prev];
        newStatus[activeStep] = !stepHasDuplicate(activeStep);
        return newStatus;
      });
    } catch (err) {
      console.error('Error during Save & Next:', err);
      const msg =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        'Something went wrong while saving. Please try again.';
      enqueueSnackbar(msg, {
        variant: 'error',
      });
    }
  };

  const [changedSections, setChangedSections] = useState({
    basicDetails: false,
    personalDetails: false,
    contactDetails: false,
    eduCertification: false,
    passVisa: false,
    expRef: false,
    bankDetails: false,
    otherDetails: false,
  });

  // Keys for saving and retrieving form data
  const activeStepKey = `activeStep_${employeeId || 'new'}`; // Key for activeStep, 'new' for new candidates

  const validateAllSteps = async () => {
    const newStepStatus = [...stepCompletionStatus]; // Copy previous status

    const validationResults = await Promise.all(
      stepsvalidator.map(async (step, index) => {
        const fieldKeys = Object.keys(step.fields || {});
        if (fieldKeys.length > 0) {
          const isValid = await trigger(fieldKeys);
          const stepValid = isValid && !stepHasDuplicate(index);
          newStepStatus[index] = stepValid;
          return stepValid;
        }
        const stepValid = !stepHasDuplicate(index);
        newStepStatus[index] = stepValid;
        return stepValid;
      })
    );

    // Update the step status based on validation results
    setStepCompletionStatus(newStepStatus);

    // Return final status (true if all steps are valid)
    const allValid = validationResults.every((result) => result === true);
    return allValid;
  };

  const handleFormSubmission = async (data) => {
    loadingSend.onTrue();
    try {
      const isValid = await validateAllSteps();
      if (isValid) {
        await onSubmit(data);
      } else {
        enqueueSnackbar('Please complete all required steps before submitting.', {
          variant: 'warning',
        });
      }
    } catch (error) {
      console.error('Error in form submission:', error);
    } finally {
      loadingSend.onFalse();
    }
  };

  const memoizedMethods = useCallback(methods, [methods]);

  const empCode = watch('empCode');

  const validateCompletedSteps = async (parsedStep, stepperKey) => {
    const newStatus = [...stepCompletionStatus];

    for (let i = 0; i <= parsedStep; i += 1) {
      const validator = stepsvalidator[i];
      if (validator) {
        const fieldKeys = Object.keys(validator.fields || {});
        if (fieldKeys.length > 0) {
          const isValid = await methods.trigger(fieldKeys);
          newStatus[i] = isValid && !stepHasDuplicate(i);
        } else {
          newStatus[i] = !stepHasDuplicate(i);
        }
      } else {
        newStatus[i] = !stepHasDuplicate(i);
      }
    }

    setStepCompletionStatus(newStatus);
  };

  useEffect(() => {
    const empId = currentEmp?.employeeId;

    // Case 0: If disabled, force activeStep = 0
    if (disabled) {
      setActiveStep(0);
      return;
    }

    const restoreAndValidate = async (parsedStep, stepperKey) => {
      const savedFormData = JSON.parse(localStorage.getItem(`stepperFormData_${stepperKey}`));

      if (savedFormData) {
        await Promise.all(
          Object.entries(savedFormData).map(([key, value]) =>
            methods.setValue(key, value, {
              shouldTouch: false,
              shouldDirty: false,
              shouldValidate: false,
            })
          )
        );
      }

      // ✅ Let RHF fully mount
      await new Promise((resolve) => setTimeout(resolve, 100));

      // ✅ Trigger validation on each step and mark status
      const newStatus = [...stepCompletionStatus];
      for (let i = 0; i <= parsedStep; i += 1) {
        const fieldKeys = Object.keys(stepsvalidator[i]?.fields || {});
        if (fieldKeys.length > 0) {
          const isValid = await methods.trigger(fieldKeys);
          newStatus[i] = isValid && !stepHasDuplicate(i);
        } else {
          newStatus[i] = !stepHasDuplicate(i);
        }
      }

      setStepCompletionStatus(newStatus);
    };

    // Case 1: New candidate (no ID yet)
    if (!empId) {
      if (!isInitializedNewEmpRef.current) {
        isInitializedNewEmpRef.current = true;
        methods.reset(); // clean state on initial mount
        localStorage.removeItem('stepperFormData_new');
        setActiveStep(0);

        // Set step completion status to null by default (unvisited steps show normal number, not green checkmark)
        const initialStatus = steps.map(() => null);
        setStepCompletionStatus(initialStatus);
      }

      return;
      // eslint-disable-next-line no-else-return
    } else {
      // existing candidate — restore saved step and validate
      const savedStep = localStorage.getItem('activeStep_new');
      const parsedStep = savedStep ? parseInt(savedStep, 10) : 0;
      setActiveStep(Number.isNaN(parsedStep) ? 0 : parsedStep);
      restoreAndValidate(parsedStep, empId);
    }

    // Case 2: Candidate ID just assigned (new → current candidate migration)
    const candidateStepKey = `activeStep_${empId}`;
    const newStep = localStorage.getItem('activeStep_new');
    const existingStep = localStorage.getItem(candidateStepKey);

    if (newStep && !existingStep) {
      const parsedStep = parseInt(newStep, 10);
      const nextStep = Number.isNaN(parsedStep) ? 0 : parsedStep;

      localStorage.setItem(candidateStepKey, nextStep.toString());
      localStorage.setItem('activeStepKey', nextStep.toString());
      localStorage.removeItem('activeStep_new');

      setActiveStep(nextStep); // ✅ Go to next step
      restoreAndValidate(nextStep, empId);
      return;
    }

    // Case 3: Load from existing candidate
    const savedStep =
      localStorage.getItem(candidateStepKey) || localStorage.getItem('activeStepKey');
    const parsedStep = savedStep ? parseInt(savedStep, 10) : 0;
    setActiveStep(Number.isNaN(parsedStep) ? 0 : parsedStep);

    restoreAndValidate(parsedStep, empId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentEmp, disabled, methods]);

  // Common handler for both switches
  const handleSwitchChange = (event, section) => {
    const subscr = JSON.parse(localStorage.getItem('selectedSubscrSite'));

    // Set default currency
    const cur = subscr.country;

    const isChecked = event.target.checked;

    setSwitchState((prevState) => ({
      ...prevState,
      [section]: isChecked,
    }));

    // Reset form fields if switch is turned off
    if (section === 'experience' && isChecked) {
      const defaultCountry = countryArr.find((c) => c.phoneCode === '91');
      // Add default experience item when switch turns ON
      setValue('empExp', [
        {
          expSrno: 0,
          compNm: '',
          designation: null,
          ctc: '',
          ctccurncy: cur || defaultCountry || null,
          country: null,
          currentywrkng: false,
          expfromDate: null,
          exptoDate: null,
        },
      ]);
    }

    if (section === 'passport' && isChecked) {
      // Add default experience item when switch turns ON
      setValue('empPassport', [
        {
          passSrno: 0,
          passNo: '',
          issuePlace: null,
          issueDt: null,
          expiryDt: null,
          ecnrStamp: false,
        },
      ]);
    }

    if (section === 'visa' && isChecked) {
      // Add default experience item when switch turns ON
      setValue('empVisa', [
        {
          visaSrno: 0,
          visaNo: '',
          visaTyp: null,
          visaNm: null,
          expiryDt: null,
          issueDt: null,
          placeOfissue: null,
          forCntry: null,
        },
      ]);
    }

    if (section === 'passport' && !isChecked) {
      setValue('empPassport', []);
    }

    if (section === 'experience' && !isChecked) {
      setValue('empExp', []);
      clearErrors('empExp');
    }

    if (section === 'visa' && !isChecked) {
      setValue('empVisa', []);
    }
  };

  const parseValidDate = (val) => {
    const date = typeof val === 'string' ? parseISO(val) : new Date(val);
    return isValid(date) ? date : new Date(); // fallback to today
  };

  const handleNoPassport = () => {
    setSwitchState((prev) => ({ ...prev, passport: false }));
    setValue('empPassport', []);
    setDuplicateFields((prev) => {
      const next = { ...prev };
      Object.keys(next).forEach((key) => {
        if (key.startsWith('passport-') || key.startsWith('empPassport')) {
          delete next[key];
        }
      });
      return next;
    });
  };
  const handleNoVisa = () => {
    setSwitchState((prev) => ({ ...prev, visa: false }));
    setValue('empVisa', []);
    setDuplicateFields((prev) => {
      const next = { ...prev };
      Object.keys(next).forEach((key) => {
        if (key.startsWith('visa-') || key.startsWith('empVisa')) {
          delete next[key];
        }
      });
      return next;
    });
  };
  const handleNoExperience = () => {
    setSwitchState((prev) => ({ ...prev, experience: false }));
    setValue('empExp', []);
    clearErrors('empExp');
  };

  const basicFirstName = watch('fname');
  const basicLastName = watch('lname');
  const basicEmail = watch('email');

  const isBasicDetailsFilled =
    Boolean(basicFirstName) && Boolean(basicLastName) && Boolean(basicEmail);

  useEffect(() => {
    setValue('curAddStateAvailable', curStateArr.length > 0, { shouldValidate: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [curStateArr]);

  useEffect(() => {
    setValue('curAddCityAvailable', curCityArr.length > 0, { shouldValidate: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [curCityArr]);

  useEffect(() => {
    setValue('permAddStateAvailable', perStateArr.length > 0, { shouldValidate: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [perStateArr]);

  useEffect(() => {
    setValue('permAddCityAvailable', perCityArr.length > 0, { shouldValidate: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [perCityArr]);

  return (
    <Grid container spacing={3}>
      <Grid xs={12} md={12}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            position: 'sticky', // Makes the stepper sticky
            top: 0, // Position it at the top of the viewport
            zIndex: 1000, // Ensures it stays above other content
          }}
          mb={1}
        >
          <Button
            color="secondary"
            variant="soft"
            startIcon={<Iconify icon="carbon:view" />}
            onClick={() =>
              router.push(
                isUnderReview
                  ? paths.dashboard.humanResources.ListOfUnderReviewedEmp
                  : paths.dashboard.humanResources.ListEmployee
              )
            }
          >
            {isUnderReview ? 'Employee Under Review List' : 'Employee List'}
          </Button>
        </Box>

        <Stepper
          activeStep={activeStep}
          sx={{ mb: 1, padding: '0px !important', marginTop: '8px' }}
        >
          {steps.map((label, index) => {
            const hasError = stepHasError(index);
            const isCompleted = !hasError && stepCompletionStatus[index] === true && index < activeStep;

            return (
              <Step
                key={index}
                completed={isCompleted}
                sx={{
                  '&:hover': { cursor: 'pointer', backgroundColor: '#f2f3f4', borderRadius: '8px' },
                }}
              >
                <StepLabel
                  StepIconProps={{
                    completed: isCompleted,
                    icon: hasError ? (
                      <span
                        style={{
                          backgroundColor: '#f2f3f4',
                          borderRadius: '50%',
                          width: '24px',
                          height: '24px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontWeight: 'bold',
                        }}
                      >
                        <img
                          src="/assets/icons/menu-items/material-symbols--exclamation.png"
                          alt="❗"
                          style={{ height: '25px', width: '25px' }}
                        />
                      </span>
                    ) : index === activeStep ? (
                      activeStep + 1
                    ) : isCompleted ? (
                      index + 1
                    ) : (
                      index + 1
                    ),
                  }}
                  sx={{
                    fontWeight: 200,
                    cursor: 'pointer',
                    borderRadius: '8px',
                    position: 'sticky',
                    padding: '0px !important',
                    transition: 'background-color 0.3s ease',
                    '&:hover': {
                      color: 'primary.dark',
                      cursor: 'pointer',
                      backgroundColor: '#f2f3f4',
                    },
                  }}
                  onClick={async () => {
                    if (index === activeStep) return;

                    const newStatus = [...stepCompletionStatus];

                    const currentFields = Object.keys(stepsvalidator[activeStep]?.fields || {});
                    if (currentFields.length > 0) {
                      const isValid = await trigger(currentFields);
                      let hasMissingRequired = false;
                      if (activeStep === 0) {
                        const isCandidateMissing = !currentEmp && !getValues('candidate');
                        const empTyp = getValues('empTyp');
                        const isGradeRequired = ['Freelance', 'Full-time Employment'].includes(empTyp?.masterName);
                        const isGradeMissing = isGradeRequired && !getValues('empGrade');
                        hasMissingRequired =
                          isCandidateMissing ||
                          !empTyp ||
                          !getValues('dateOfJoin') ||
                          !getValues('designation') ||
                          isGradeMissing;
                      } else if (activeStep === 1) {
                        hasMissingRequired =
                          !getValues('fname')?.trim() ||
                          !getValues('lname')?.trim() ||
                          !getValues('gender') ||
                          !getValues('email')?.trim() ||
                          !getValues('mobno')?.trim() ||
                          !getValues('panno')?.trim() ||
                          !getValues('aadharno')?.trim();
                      }
                      newStatus[activeStep] = isValid && !hasMissingRequired && !stepHasDuplicate(activeStep);
                    }

                    setStepCompletionStatus(newStatus);

                    setActiveStep(index);
                    localStorage.setItem(
                      employeeId ? `activeStep_${employeeId}` : 'activeStepKey',
                      index.toString()
                    );

                    handleStepChange(index);

                    if (stepHasError(index) || !newStatus[index]) {
                      enqueueSnackbar('Please complete required fields before proceeding.', {
                        variant: 'warning',
                      });
                    }
                  }}
                >
                  {label}
                </StepLabel>
              </Step>
            );
          })}
        </Stepper>

        <Card
          sx={{
            p: 3,
            width: '100%', // Scale the form to 75% of the container width
            margin: 'auto', // Center the form horizontally
            transform: 'scale(0.98)', // Scale down the entire form
            transformOrigin: 'top center', // Maintain scale position
          }}
        >
          <FormProvider methods={methods} disabled={disabled}>
            <>
              {/* --------------------------------------------------- Basic Details ------------------------------------------------------------- */}
              {activeStep === 0 && (
                <>
                  <Box>
                    <Typography variant="h6" sx={{ color: 'text.disabled', mb: 3 }}>
                      Basic Details:
                    </Typography>
                  </Box>
                  <Box
                    rowGap={3}
                    columnGap={2}
                    display="grid"
                    gridTemplateColumns={{
                      xs: 'repeat(1, 1fr)',
                      sm: 'repeat(2, 1fr)',
                    }}
                  >
                    <Grid xs={12} md={12} sx={{ pr: 0 }}>
                      <Box sx={{ mb: 1 }}>
                        <RHFUploadAvatar
                          name="avatarUrl"
                          maxSize={maxSizeOfDocs}
                          onDrop={handleDrop}
                          disabled={disabled}
                          sx={{
                            borderRadius: '50%',
                            overflow: 'hidden',

                            '& img': {
                              borderRadius: '50%',
                              objectFit: 'cover',
                            },

                            '& > div': {
                              borderRadius: '50%',
                            },
                          }}
                          helperText={
                            !disabled && (
                              <Typography
                                variant="caption"
                                sx={{
                                  mt: 2,
                                  mx: 'auto',
                                  display: 'block',
                                  textAlign: 'center',
                                  color: 'text.secondary',
                                }}
                              >
                                Supported file formats: JPG, JPEG, PNG,
                                <Tooltip
                                  title="Additional formats: GIF, SVG, HEIC, HEIF, TIFF, WebP, JFIF"
                                  arrow
                                  placement="top"
                                >
                                  <Typography
                                    variant="caption"
                                    component="span"
                                    sx={{
                                      cursor: 'pointer',
                                      ml: 0.5,
                                      textDecoration: 'underline',
                                      color: 'primary.main',
                                    }}
                                  >
                                    (more)
                                  </Typography>
                                </Tooltip>
                                <br />
                                Max upload file size: {maxSizeOfDocs} MB
                                <br />
                                <br />
                              </Typography>
                            )
                          }
                        />
                        {!disabled &&
                          !isFileTooLarge &&
                          (curEmpPic || (profilePhotoUrl && !isProfilePhotoRemoved)) && (
                            <>
                              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                                <Button
                                  variant="soft"
                                  color="error"
                                  onClick={openConfirmDialog}
                                  disabled={!curEmpPic && !profilePhotoUrl}
                                >
                                  Remove Photo
                                </Button>
                              </Box>

                              <ConfirmDialog
                                open={confirmOpen}
                                onClose={closeConfirmDialog}
                                title="Remove Photo?"
                                content="Are you sure you want to remove the photo?"
                                action={
                                  <Button
                                    variant="contained"
                                    color="error"
                                    onClick={() => {
                                      handleRemovePhoto();
                                      closeConfirmDialog();
                                    }}
                                  >
                                    Confirm Remove
                                  </Button>
                                }
                              />
                            </>
                          )}
                        {currentEmp ? (
                          <>
                            {empCode && (
                              <Box sx={{ mt: 2 }}>
                                <RHFTextField name="empCode" label="Employee Code" disabled />
                              </Box>
                            )}
                          </>
                        ) : (
                          <></>
                        )}
                      </Box>
                    </Grid>
                    <Grid xs={12} md={12}>
                      <Box>
                        {currentEmp ? (
                          <></>
                        ) : (
                          <Stack spacing={1.5} mb={1}>
                            <RHFAutocomplete
                              name="candidate"
                              placeholder="Select Candidate"
                              disableClearable
                              label={
                                <div>
                                  Candidate-Email
                                  <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                                </div>
                              }
                              filterOptions={filterCandidate}
                              options={offeredCand}
                              getOptionLabel={(option) => `${option.firstName} ${option.lastName}`}
                              onChange={(event, value) => {
                                setValue('candidate', value, { shouldValidate: true });
                                handleCandidateChange(value.candidateId);
                              }}
                              renderOption={(props, option) => (
                                <li {...props} key={option.candidateId}>
                                  {option.firstName} {option.lastName}/{option.email}
                                </li>
                              )}
                            />
                          </Stack>
                        )}
                        <Stack spacing={1.5} mb={1}>
                          <Controller
                            name="empTyp"
                            control={control}
                            render={({ field }) => (
                              <RHFAutocomplete
                                {...field} // Pass RHF field props to the autocomplete
                                placeholder="Employment Type"
                                label={
                                  <div>
                                    Employment Type
                                    <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                                  </div>
                                }
                                options={empTypArr}
                                getOptionLabel={(option) => option.masterName}
                                showPlusIcon
                                onChange={(event, newValue) => {
                                  setSelectedEmpType(newValue);
                                  setValue('empTyp', newValue, { shouldValidate: true });
                                }}
                                renderOption={(props, option) => (
                                  <li {...props} key={option.masterId}>
                                    {option.masterName}
                                  </li>
                                )}
                              />
                            )}
                          />
                        </Stack>
                        {/* ---------------------------------------------------------------------------- */}
                        {watchedEmpTyp &&
                          ['Freelance', 'Full-time Employment', 'Full-time Employment'].includes(
                            watchedEmpTyp.masterName
                          ) && (
                            <Stack spacing={1.5} mt={1} mb={1}>
                              <Controller
                                name="empGrade"
                                control={control}
                                render={({ field }) => (
                                  <RHFAutocomplete
                                    {...field} // Pass RHF field props to the autocomplete
                                    placeholder="Employee Grade"
                                    label={
                                      <div>
                                        Employee Grade
                                        <span style={{ color: 'red', fontWeight: 'bolder' }}>
                                          {' '}
                                          *
                                        </span>
                                      </div>
                                    }
                                    options={empGradeArr}
                                    getOptionLabel={(option) => option.masterName}
                                    showPlusIcon
                                    onChange={(event, newValue) => {
                                      setValue('empGrade', newValue, { shouldValidate: true });
                                    }}
                                    renderOption={(props, option) => (
                                      <li {...props} key={option.masterId}>
                                        {option.masterName}
                                      </li>
                                    )}
                                  />
                                )}
                              />
                            </Stack>
                          )}
                        {/* --------------------------------------------------------------------------------- */}
                        {empCode && (
                          <Box sx={{ display: { xs: 'none', sm: 'none' } }}>
                            <RHFTextField name="empCode" label="Employee Code" disabled />
                          </Box>
                        )}
                        <Controller
                          name="dateOfJoin"
                          control={control}
                          render={({ field, fieldState: { error } }) => {
                            const today = new Date();
                            today.setHours(0, 0, 0, 0);
                            return (
                              <DatePicker
                                label={
                                  <div>
                                    Date of Joining
                                    <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                                  </div>
                                }
                                value={parseValidDate(field.value)}
                                onChange={(newValue) => {
                                  field.onChange(newValue);
                                  trigger('dateOfJoin');
                                }}
                                slotProps={{
                                  textField: {
                                    fullWidth: true,
                                    error: !!error,
                                    helperText: error?.message,
                                  },
                                }}
                                sx={{ mb: 2 }}
                                minDate={today}
                              />
                            );
                          }}
                        />

                        <Stack spacing={1.5} mb={2}>
                          <RHFAutocomplete
                            name="designation"
                            placeholder="Post/Designation"
                            label={
                              <div>
                                Designation
                                <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                              </div>
                            }
                            options={desgntnArr}
                            showPlusIcon
                            getOptionLabel={(option) => option.masterName}
                            renderOption={(props, option) => (
                              <li {...props} key={option.masterId}>
                                {option.masterName}
                              </li>
                            )}
                          />
                        </Stack>
                      </Box>
                    </Grid>
                  </Box>
                </>
              )}
            </>
            {/* -------------------------------------- personal Details --------------------------------------------------------------------- */}
            <Grid xs={12} md={12}>
              <>
                {activeStep === 1 && (
                  <>
                    <Box>
                      <Typography variant="h6" sx={{ color: 'text.disabled', mb: 3 }}>
                        Personal Details:
                      </Typography>
                    </Box>
                    <Box
                      rowGap={3}
                      columnGap={2}
                      display="grid"
                      gridTemplateColumns={{
                        xs: 'repeat(1, 1fr)',
                        sm: 'repeat(2, 1fr)',
                      }}
                      sx={{ mb: 3 }}
                    >
                      <Tooltip
                        title={!isBasicDetailsFilled ? 'Please fill Basic Details first.' : ''}
                        arrow
                        placement="top"
                      >
                        {' '}
                        <span>
                          <RHFTextField
                            name="fname"
                            label={
                              <div>
                                First Name
                                <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                              </div>
                            }
                            disabled={!currentEmp && Boolean(watch('fname'))}
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <Box component="span" sx={{ color: 'text.disabled' }}>
                                    <RHFAutocomplete
                                      name="nameTitle"
                                      disableClearable
                                      sx={{
                                        '& fieldset': { border: 'none' },
                                      }}
                                      disabled={!currentEmp && Boolean(watch('nameTitle'))}
                                      // disabled
                                      options={nmTitleArr}
                                      getOptionLabel={(option) => option.masterName}
                                      componentsProps={{
                                        popper: { style: { width: 'fit-content' } },
                                      }}
                                      renderOption={(props, option) => (
                                        <li {...props} key={option.masterId}>
                                          {option.masterName}
                                        </li>
                                      )}
                                    />
                                  </Box>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </span>
                      </Tooltip>
                      <RHFTextField name="mname" label="Middle Name" />
                      <Tooltip
                        title={!isBasicDetailsFilled ? 'Please fill Basic Details first.' : ''}
                        arrow
                      >
                        <span>
                          <RHFTextField
                            name="lname"
                            label={
                              <div>
                                Last Name
                                <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                              </div>
                            }
                            disabled={!currentEmp && Boolean(watch('lname'))}
                          />
                        </span>
                      </Tooltip>
                      <Controller
                        name="dateOfBirth"
                        control={control}
                        render={({ field, fieldState: { error } }) => (
                          <DatePicker
                            label="Date of Birth"
                            value={parseValidDate(field.value) ?? new Date()}
                            onChange={(newValue) => {
                              field.onChange(newValue);
                              trigger('dateOfBirth');
                            }}
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                error: !!error,
                                helperText: error?.message,
                              },
                            }}
                            maxDate={new Date()}
                          />
                        )}
                      />
                      <RHFTextField name="placeOfBirth" label="Place of Birth" />
                      <Stack spacing={1.5}>
                        <RHFAutocomplete
                          name="gender"
                          placeholder="Gender"
                          label={
                            <div>
                              Gender<span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                            </div>
                          }
                          disabled={!currentEmp && Boolean(watch('gender'))}
                          showPlusIcon
                          options={genderArr}
                          getOptionLabel={(option) => option.masterName}
                          renderOption={(props, option) => (
                            <li {...props} key={option.masterId}>
                              {option.masterName}
                            </li>
                          )}
                        />
                      </Stack>
                      <Stack spacing={1.5}>
                        <RHFAutocomplete
                          name="religion"
                          placeholder="Religion"
                          label="Religion"
                          options={relgnArr}
                          showPlusIcon
                          getOptionLabel={(option) => option.masterName}
                          renderOption={(props, option) => (
                            <li {...props} key={option.masterId}>
                              {option.masterName}
                            </li>
                          )}
                        />
                      </Stack>
                      <Stack spacing={1.5}>
                        <RHFAutocomplete
                          name="maritalStatus"
                          placeholder="Marital Status"
                          label="Marital Status"
                          options={maritalStArr}
                          showPlusIcon
                          getOptionLabel={(option) => option.masterName}
                          renderOption={(props, option) => (
                            <li {...props} key={option.masterId}>
                              {option.masterName}
                            </li>
                          )}
                        />
                      </Stack>
                      <RHFTextField name="nationality" label="Nationality" />
                      <Stack spacing={1.5}>
                        <RHFAutocomplete
                          name="bloodGrp"
                          placeholder="Blood Group"
                          label="Blood Group"
                          options={bloodGrpArr}
                          showPlusIcon
                          getOptionLabel={(option) => option.masterName}
                          renderOption={(props, option) => (
                            <li {...props} key={option.masterId}>
                              {option.masterName}
                            </li>
                          )}
                        />
                      </Stack>
                      <RHFTextField
                        name="height"
                        type="number"
                        label="Height"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <Box component="span" sx={{ color: 'text.disabled' }}>
                                <RHFAutocomplete
                                  name="unitOfHeight"
                                  disableClearable
                                  placeholder="cm."
                                  sx={{
                                    '& fieldset': { border: 'none' },
                                  }}
                                  options={unitOfMsrArr}
                                  getOptionLabel={(option) => option.masterName}
                                  componentsProps={{ popper: { style: { width: 'fit-content' } } }}
                                  renderOption={(props, option) => (
                                    <li {...props} key={option.masterId}>
                                      {option.masterName}
                                    </li>
                                  )}
                                />
                              </Box>
                            </InputAdornment>
                          ),
                        }}
                      />
                      <RHFTextField
                        name="weight"
                        type="number"
                        label="Weight"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <Box component="span" sx={{ color: 'text.disabled' }}>
                                <RHFAutocomplete
                                  name="unitOfWeight"
                                  disableClearable
                                  placeholder="kg."
                                  sx={{
                                    '& fieldset': { border: 'none' },
                                  }}
                                  options={unitOfMsrArr}
                                  getOptionLabel={(option) => option.masterName}
                                  componentsProps={{ popper: { style: { width: 'fit-content' } } }}
                                  renderOption={(props, option) => (
                                    <li {...props} key={option.masterId}>
                                      {option.masterName}
                                    </li>
                                  )}
                                />
                              </Box>
                            </InputAdornment>
                          ),
                        }}
                      />
                      <Tooltip
                        title={!isBasicDetailsFilled ? 'Please fill Basic Details first.' : ''}
                        arrow
                      >
                        <span>
                          <RHFTextField
                            name="email"
                            label={
                              <div>
                                Personal Email
                                <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                              </div>
                            }
                          // disabled={!currentEmp && Boolean(watch('email'))}
                          />
                        </span>
                      </Tooltip>
                      {currentEmp ? (
                        <>
                          <RHFTextField name="ofclEmail" label={<div>Official Email</div>} />
                        </>
                      ) : (
                        <></>
                      )}
                      <Tooltip
                        title={!isBasicDetailsFilled ? 'Please fill Basic Details first.' : ''}
                        arrow
                      >
                        <span>
                          <RHFTextField
                            name="mobno"
                            label={
                              <div>
                                Mobile Number
                                <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                              </div>
                            }
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <Box component="span" sx={{ color: 'text.disabled' }}>
                                    <RHFAutocomplete
                                      name="phncode"
                                      disableClearable
                                      filterOptions={filterPhoneCode}
                                      sx={{
                                        '& fieldset': { border: 'none' },
                                        '& .MuiOutlinedInput-root .MuiAutocomplete-input': {
                                          padding: '9.5px 20px 10.5px 4px !important', // Add specific PADDING for the Autocomplete input
                                        },
                                        minWidth: 40,
                                      }}
                                      disabled={!currentEmp && Boolean(watch('phncode'))}
                                      options={countryArr}
                                      onChange={(event, value) => {
                                        setValue('phncode', value, { shouldValidate: true });
                                        trigger('mobno');
                                      }}
                                      getOptionLabel={(option) => option?.phoneCode || ''}
                                      componentsProps={{
                                        popper: { style: { width: 'fit-content' } },
                                      }}
                                      renderOption={(props, option) => (
                                        <li {...props} key={option.shortName}>
                                          {option.countryName}({option.phoneCode})
                                        </li>
                                      )}
                                    />
                                  </Box>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </span>
                      </Tooltip>
                      <Controller
                        name="panno"
                        control={methods.control}
                        rules={{
                          required: 'PAN is required',
                        }}
                        render={({ field, fieldState }) => (
                          <UniqueTextField
                            field={field}
                            error={fieldState.error}
                            isDuplicate={Boolean(duplicateFields.panno)}
                            maskType="PAN"
                            label={
                              <div>
                                PAN Number{' '}
                                <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                              </div>
                            }
                            fieldName="pan"
                            apiEndpoint="/rest/employee/check-duplicate-emp-fields"
                            entityId={currentEmp?.employeeId || null}
                            onDuplicateStatusChange={handleDuplicateStatusChange('panno')}
                            duplicateMessage="This PAN already exists"
                            sx={{ width: '40%' }}
                          />
                        )}
                      />

                      <Controller
                        name="aadharno"
                        control={methods.control}
                        rules={{
                          required: 'Aadhaar is required',
                        }}
                        render={({ field, fieldState }) => (
                          <UniqueTextField
                            field={field}
                            error={fieldState.error}
                            isDuplicate={Boolean(duplicateFields.aadharno)}
                            maskType="AADHAAR"
                            label={
                              <div>
                                Aadhaar Number{' '}
                                <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                              </div>
                            }
                            fieldName="aadharNumber"
                            apiEndpoint="/rest/employee/check-duplicate-emp-fields"
                            entityId={currentEmp?.employeeId || null}
                            onDuplicateStatusChange={handleDuplicateStatusChange('aadharno')}
                            duplicateMessage="This Aadhaar Number already exists"
                            sx={{ width: '35%' }}
                          />
                        )}
                      />
                      <Controller
                        name="pfno"
                        control={methods.control}
                        render={({ field, fieldState }) => (
                          <UniqueTextField
                            field={field}
                            error={fieldState.error}
                            isDuplicate={Boolean(duplicateFields.pfno)}
                            label="PF Number(UAN)"
                            fieldName="uan"
                            validationRegex={/^\d{12}$|^[A-Z]{5}\d{6}[A-Z]$/}
                            apiEndpoint="/rest/employee/check-duplicate-emp-fields"
                            entityId={currentEmp?.employeeId || null}
                            onDuplicateStatusChange={handleDuplicateStatusChange('pfno')}
                            duplicateMessage="This PF Number already exists"
                            fullWidth
                          />
                        )}
                      />
                      <Controller
                        name="pranno"
                        control={methods.control}
                        render={({ field, fieldState }) => (
                          <UniqueTextField
                            field={field}
                            error={fieldState.error}
                            isDuplicate={Boolean(duplicateFields.pranno)}
                            label="NPS Number(PRAN)"
                            fieldName="pran"
                            validationRegex={/^[0-9]{12}$/}
                            apiEndpoint="/rest/employee/check-duplicate-emp-fields"
                            entityId={currentEmp?.employeeId || null}
                            onDuplicateStatusChange={handleDuplicateStatusChange('pranno')}
                            duplicateMessage="This PRAN already exists"
                            fullWidth
                          />
                        )}
                      />
                      <Stack spacing={1}>
                        <RHFTextField name="linkedinLink" label="LinkedIn Profile Url" />
                      </Stack>
                      <Stack spacing={1}>
                        <Box
                          rowGap={3}
                          columnGap={2}
                          display="grid"
                          gridTemplateColumns={{
                            xs: 'repeat(1, 1fr)',
                            sm: 'repeat(2, 1fr)',
                          }}
                        >
                          <Typography variant="subtitle2" mt={1}>
                            Is International Worker:
                          </Typography>
                          <RHFRadioGroup
                            row
                            spacing={4}
                            name="isInternationalWrkr"
                            options={yesNoArr}
                          />
                        </Box>
                      </Stack>
                      <Stack spacing={1}>
                        <Box
                          rowGap={2}
                          columnGap={1}
                          display="grid"
                          gridTemplateColumns={{
                            xs: 'repeat(1, 1fr)',
                            sm: '1fr 2fr',
                          }}
                        >
                          <Typography variant="subtitle2" mt={1}>
                            Is Director:
                          </Typography>
                          <RHFRadioGroup row spacing={4} name="isdirector" options={yesNoArr} />
                        </Box>
                      </Stack>
                    </Box>
                  </>
                )}
              </>
              {/* ----------------------------------------------- Professional Details ------------------------------------------------------  */}
              <>
                {activeStep === 2 && (
                  <>
                    <Box>
                      <Typography variant="h6" sx={{ color: 'text.disabled', mb: 3 }}>
                        Address Details:
                      </Typography>
                    </Box>
                    <>
                      <Typography variant="subtitle2" sx={{ mb: '10px' }}>
                        Current Address :
                      </Typography>
                      <Box
                        rowGap={3}
                        columnGap={2}
                        display="grid"
                        gridTemplateColumns={{
                          xs: 'repeat(1, 1fr)',
                          sm: 'repeat(2, 1fr)',
                        }}
                        sx={{ mb: 3 }}
                      >
                        <RHFTextField
                          name="curAddLn1"
                          label={
                            <div>
                              Address Line 1
                              <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                            </div>
                          }
                        />
                        <RHFTextField name="curAddLn2" label="Address Line 2" />
                        <Stack spacing={1.5}>
                          <RHFAutocomplete
                            name="curAddCntr"
                            placeholder="Country"
                            disableClearable
                            label={
                              <div>
                                Country
                                <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                              </div>
                            }
                            options={countryArr}
                            getOptionLabel={(option) => option.countryName}
                            onChange={(event, value) => {
                              setValue('curAddCntr', value, { shouldValidate: true });
                              setValue('curAddState', null, { shouldValidate: true });
                              setValue('curAddCity', null, { shouldValidate: true });
                              setCurStateArr([]);
                              setCurCityArr([]);
                              if (value) {
                                handleCountryChange(value.countriesId);
                              }
                            }}
                            renderOption={(props, option) => (
                              <li {...props} key={option.shortName}>
                                {option.countryName}
                              </li>
                            )}
                          />
                        </Stack>
                        <Stack spacing={1.5}>
                          <RHFAutocomplete
                            name="curAddState"
                            placeholder="State"
                            disableClearable
                            label={
                              <div>
                                State
                                {curStateArr.length > 0 && (
                                  <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                                )}
                              </div>
                            }
                            options={[...curStateArr].sort((a, b) => {
                              const stateNameA = a.stateName?.toLowerCase() || ''; // Ensure stateName is a string
                              const stateNameB = b.stateName?.toLowerCase() || ''; // Ensure stateName is a string

                              return stateNameA.localeCompare(stateNameB); // Sort states alphabetically
                            })}
                            getOptionLabel={(option) => option.stateName}
                            onChange={(event, value) => {
                              setValue('curAddState', value, { shouldValidate: true });
                              setValue('curAddCity', null, { shouldValidate: true });
                              setCurCityArr([]);
                              if (value) {
                                handleStateChange(value.statesId);
                              }
                            }}
                            renderOption={(props, option) => (
                              <li {...props} key={option.statesId}>
                                {option.stateName}
                              </li>
                            )}
                          />
                        </Stack>
                        <Stack spacing={1.5}>
                          <RHFAutocomplete
                            name="curAddCity"
                            placeholder="City"
                            disableClearable
                            label={
                              <div>
                                City
                                {curCityArr.length > 0 && (
                                  <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                                )}
                              </div>
                            }
                            options={curCityArr}
                            getOptionLabel={(option) => option.cityName}
                            renderOption={(props, option) => (
                              <li {...props} key={option.cityId}>
                                {option.cityName}
                              </li>
                            )}
                          />
                        </Stack>
                        <RHFTextField name="curAddLandMrk" label="Landmark" />
                        <RHFTextField
                          name="curAddZip"
                          label="Zip Code"
                          inputProps={{
                            inputMode: 'numeric', // Mobile keyboard shows numbers
                            pattern: '[0-9]*', // HTML pattern to accept only digits
                            maxLength: 6, //  limit to 6 digits max
                          }}
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/[^0-9]/g, ''); // Removes non-numeric chars
                          }}
                        />
                        <RHFTextField name="curAddLandLn" label="Landline Number" />
                      </Box>
                      <Typography variant="subtitle2" sx={{ mb: '10px' }}>
                        Permanent Address :
                      </Typography>
                      <FormControlLabel
                        control={
                          <Checkbox
                            id="isSameAsCurrent"
                            checked={isCurrentAndPermanentAddressSame()}
                            onChange={handleCheckboxChange}
                          />
                        }
                        label="Same as current address"
                        sx={{ mb: '10px' }}
                      />
                      <Box
                        rowGap={3}
                        columnGap={2}
                        display="grid"
                        gridTemplateColumns={{
                          xs: 'repeat(1, 1fr)',
                          sm: 'repeat(2, 1fr)',
                        }}
                      >
                        <RHFTextField
                          name="permAddLn1"
                          label={
                            <div>
                              Address Line 1
                              <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                            </div>
                          }
                        />
                        <RHFTextField name="permAddLn2" label="Address Line 2" />
                        <Stack spacing={1.5}>
                          <RHFAutocomplete
                            name="permAddCntr"
                            placeholder="Country"
                            disableClearable
                            label={
                              <div>
                                Country
                                <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                              </div>
                            }
                            options={countryArr}
                            getOptionLabel={(option) => option.countryName}
                            onChange={(event, value) => {
                              setValue('permAddCntr', value, { shouldValidate: true });
                              setValue('permAddState', null, { shouldValidate: true });
                              setValue('permAddCity', null, { shouldValidate: true });
                              setPerStateArr([]);
                              setPerCityArr([]);
                              if (value) {
                                handlePerCountryChange(value.countriesId);
                              }
                            }}
                            renderOption={(props, option) => (
                              <li {...props} key={option.shortName}>
                                {option.countryName}
                              </li>
                            )}
                          />
                        </Stack>
                        <Stack spacing={1.5}>
                          <RHFAutocomplete
                            name="permAddState"
                            placeholder="State"
                            disableClearable
                            label={
                              <div>
                                State
                                {perStateArr.length > 0 && (
                                  <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                                )}
                              </div>
                            }
                            options={[...perStateArr].sort((a, b) => {
                              const stateNameA = a.stateName?.toLowerCase() || ''; // Ensure stateName is a string
                              const stateNameB = b.stateName?.toLowerCase() || ''; // Ensure stateName is a string
                              return stateNameA.localeCompare(stateNameB); // Sort states alphabetically
                            })}
                            getOptionLabel={(option) => option.stateName}
                            onChange={(event, value) => {
                              setValue('permAddState', value, { shouldValidate: true });
                              setValue('permAddCity', null, { shouldValidate: true });
                              setPerCityArr([]);
                              if (value) {
                                handlePerStateChange(value.statesId);
                              }
                            }}
                            renderOption={(props, option) => (
                              <li {...props} key={option.statesId}>
                                {option.stateName}
                              </li>
                            )}
                          />
                        </Stack>
                        <Stack spacing={1.5}>
                          <RHFAutocomplete
                            name="permAddCity"
                            placeholder="City"
                            disableClearable
                            label={
                              <div>
                                City
                                {perCityArr.length > 0 && (
                                  <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                                )}
                              </div>
                            }
                            options={perCityArr}
                            getOptionLabel={(option) => option.cityName}
                            renderOption={(props, option) => (
                              <li {...props} key={option.cityId}>
                                {option.cityName}
                              </li>
                            )}
                          />
                        </Stack>
                        <RHFTextField name="permAddLandMrk" label="Landmark" />
                        <RHFTextField
                          name="permAddZip"
                          label="Zip Code"
                          inputProps={{
                            inputMode: 'numeric', // Mobile keyboard shows numbers
                            pattern: '[0-9]*', // HTML pattern to accept only digits
                            maxLength: 6, //  limit to 6 digits max
                          }}
                          onInput={(e) => {
                            e.target.value = e.target.value.replace(/[^0-9]/g, ''); // Removes non-numeric chars
                          }}
                        />

                        <RHFTextField name="permAddLandLn" label="Landline Number" />
                      </Box>
                    </>
                  </>
                )}
              </>
              {/* ---------------------------------------- Passport Details -------------------------------------------------------------- */}
              <>
                {activeStep === 4 && (
                  <>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={switchState.passport}
                          onChange={(event) => handleSwitchChange(event, 'passport')}
                          name="passportSwitch"
                          color="primary"
                        />
                      }
                      label="Do you have a passport?"
                    />

                    {switchState.passport && (
                      <PassportNewEditForm
                        citiesData={rawCityArr}
                        switchState={switchState}
                        onEmptyPassport={handleNoPassport}
                        onDuplicateStatusChange={handleDuplicateStatusChange}
                        duplicateFields={duplicateFields}
                        currentEmp={currentEmp}
                      />
                    )}
                  </>
                )}
              </>
              {/* ---------------------------------------- Visa Details ------------------------------------------------------------------- */}
              <>
                {activeStep === 4 && (
                  <>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={switchState.visa}
                          onChange={(event) => handleSwitchChange(event, 'visa')}
                          name="visaSwitch"
                          color="primary"
                        />
                      }
                      label="Do you have a visa?"
                    />

                    {switchState.visa && (
                      <EmpVisaNewEditForm
                        visaNmArr={visaNmArr}
                        visaTypArr={visaTypArr}
                        citiesData={rawCityArr}
                        countryArr={countryArr}
                        switchState={switchState}
                        onEmptyVisa={handleNoVisa}
                        onDuplicateStatusChange={handleDuplicateStatusChange}
                        duplicateFields={duplicateFields}
                        currentEmp={currentEmp}
                      />
                    )}
                  </>
                )}
              </>
              {/* ---------------------------------- Family Details ----------------------------------------------------------------------- */}
              <>
                {activeStep === 1 && (
                  <>
                    <FamilyRelationNewEditForm relshnData={relshnshipArr} yesNoArr={yesNoArr} />
                  </>
                )}
              </>
              {/* ---------------------------------- Emergency Contact Details ------------------------------------------------------------ */}
              <>
                {activeStep === 2 && (
                  <>
                    <EmergencyContactNewEditForm
                      countryArr={countryArr}
                      relshnData={relshnshipArr}
                    />
                  </>
                )}
              </>
              {/* ---------------------------------- Education Details --------------------------------------------------------------------- */}
              <>
                {activeStep === 3 && (
                  <>
                    <EmpEduNewEditForm
                      universityData={universityArr}
                      qualData={qualArr}
                      qualTypeData={qualTypeArr}
                      streamData={streamArr}
                      currentEmpEdu={currentEmpEdu}
                    />
                  </>
                )}
              </>
              {/* ------------------------------------------------- Certification Details ---------------------------------------------- */}
              <>
                {activeStep === 3 && (
                  <>
                    <EmpCertNewEditForm certNmArr={certNmArr} certInstNmArr={certInstNmArr} />
                  </>
                )}
              </>
              {/* ------------------------------------------------- Experience Details ---------------------------------------------------- */}
              <>
                {activeStep === 5 && (
                  <>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={switchState.experience}
                          onChange={(event) => handleSwitchChange(event, 'experience')}
                          name="expSwitch"
                          color="primary"
                        />
                      }
                      label="Have an Experience ?"
                    />
                    {switchState.experience && (
                      <EmpExpNewEditForm
                        desgData={desgntnArr}
                        cntryData={countryArr}
                        filterCurrency={filterCurrency}
                        trigger={trigger}
                        switchState={switchState}
                        onEmptyExperience={handleNoExperience}
                      />
                    )}
                  </>
                )}
              </>
              {/* ------------------------------------------------- Reference Details ----------------------------------------------------- */}
              <>
                {activeStep === 5 && (
                  <>
                    <EmpRefNewEditForm
                      desgRefData={desgntnArr}
                      countryArr={countryArr}
                      filterPhoneCode={filterPhoneCode}
                    />
                  </>
                )}
              </>
              {/* ---------------------------------------------- Language Details  ---------------------------------------------------------- */}
              <>
                {activeStep === 3 && (
                  <>
                    <EmpLangNewEditForm langarr={langArr} />
                  </>
                )}
              </>
              {/* ------------------------------------------------- bank Details --------------------------------------------------- */}
              <>
                {activeStep === 6 && (
                  <>
                    <EmpBankNewEditForm
                      bankNmData={bankNmArr}
                      bankTypeData={bankTypArr}
                      duplicateFields={duplicateFields}
                      onDuplicateStatusChange={handleDuplicateStatusChange}
                      currentEmp={currentEmp}
                    />
                  </>
                )}
              </>
              {/* ------------------------------------------------- Important Questions --------------------------------------------  */}
              <>
                {activeStep === steps.length - 1 ? (
                  <>
                    <Box>
                      <Typography variant="h6" sx={{ color: 'text.disabled', mb: 3 }}>
                        Other Details:
                      </Typography>
                    </Box>
                    <Box
                      rowGap={3}
                      columnGap={2}
                      display="grid"
                      gridTemplateColumns={{
                        xs: 'repeat(1, 1fr)',
                        sm: 'repeat(2, 1fr)',
                      }}
                    >
                      <Stack spacing={1.5}>
                        <RHFAutocomplete
                          name="srcofhire"
                          placeholder="Select Source Of Hire"
                          label={
                            <div>
                              Source Of Hire
                              <span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                            </div>
                          }
                          options={srcOfHrArr}
                          showPlusIcon
                          disabled={!currentEmp && Boolean(watch('srcofhire'))}
                          getOptionLabel={(option) => option.sourceName}
                          renderOption={(props, option) => (
                            <li {...props} key={option.sourceOfHireId}>
                              {option.sourceName}
                            </li>
                          )}
                        />
                      </Stack>
                      <RHFTextField name="srcofhireNm" label="Source Name" />
                    </Box>
                    <EmpRelwrknwithusNewEditForm
                      relshnData={relshnshipArr}
                      countryArr={countryArr}
                      desgRefData={desgntnArr}
                    />
                    <EmpImpqueNewEditForm impQueArr={impQueArr} />

                    <Stack
                      justifyContent="space-between"
                      direction="row"
                      spacing={2}
                      sx={{ mt: 3 }}
                    >
                      {/* Back Button */}
                      {!disabled && (
                        <Button
                          variant="soft"
                          onClick={handleBack}
                          sx={{
                            color: '#00838f',
                            bgcolor: '#CAFDF5',
                            '&:hover': {
                              bgcolor: '#CAFDF5',
                            },
                          }}
                        >
                          Previous
                        </Button>
                      )}

                      {/* Cancel and Save Buttons */}
                      {!disabled && (
                        <Stack direction="row" spacing={2}>
                          <Button
                            variant="soft"
                            color="info"
                            startIcon={<Iconify icon="carbon:view" />}
                            onClick={() =>
                              router.push(
                                isUnderReview
                                  ? paths.dashboard.humanResources.ListOfUnderReviewedEmp
                                  : paths.dashboard.humanResources.ListEmployee
                              )
                            }
                          >
                            {isUnderReview ? 'Back To Under Review List' : 'Back To List'}
                          </Button>

                          {!disabled && (
                            <LoadingButton
                              type="button"
                              variant="soft"
                              color="success"
                              sx={{ mr: 1 }}
                              disabled={
                                isGenerating ||
                                (!currentEmp && (hasDuplicates || steps.some((_, i) => stepHasError(i))))
                              }
                              onClick={async () => {
                                setSavingAction('saveNext');
                                try {
                                  if (activeStep === steps.length - 1) {
                                    await handleFormSubmission(methods.getValues(), false);
                                  } else {
                                    await handleSaveNext();
                                  }
                                } finally {
                                  setSavingAction(null);
                                }
                              }}
                            >
                              {savingAction === 'saveNext' ? (
                                <>
                                  <CircularProgress size={20} sx={{ mr: 1, color: 'white' }} />
                                  Saving...
                                </>
                              ) : activeStep === steps.length - 1 ? (
                                !currentEmp ? (
                                  'Create Employee'
                                ) : (
                                  'Save Changes'
                                )
                              ) : (
                                'Save & Next'
                              )}
                            </LoadingButton>
                          )}
                        </Stack>
                      )}
                    </Stack>
                  </>
                ) : (
                  // Steps Before Final Step
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      mt: 3,
                    }}
                  >
                    {/* Back Button */}
                    {!disabled && activeStep > 0 && (
                      <Button
                        variant="soft"
                        onClick={handleBack}
                        sx={{
                          mr: 2,
                          color: '#00838f',
                          bgcolor: '#CAFDF5',
                          '&:hover': {
                            bgcolor: '#CAFDF5',
                          },
                        }}
                      >
                        Previous
                      </Button>
                    )}
                    {/* Spacer to push other buttons to the right */}
                    <Box sx={{ flexGrow: 1 }} />

                    {/* Save Changes Button */}
                    {!disabled && (
                      <>
                        {/* For Existing Employee: Show Save Changes button */}
                        {currentEmp && (
                          <LoadingButton
                            type="button"
                            variant="soft"
                            color="success"
                            sx={{ mr: 1 }}
                            disabled={isGenerating}
                            onClick={async () => {
                              setSavingAction('saveOnly');
                              try {
                                await handleFormSubmission(methods.getValues(), false); // Only save, don't go to next
                              } finally {
                                setSavingAction(null);
                              }
                            }}
                          >
                            {savingAction === 'saveOnly' ? (
                              <>
                                <CircularProgress size={20} sx={{ mr: 1, color: 'white' }} />
                                Saving...
                              </>
                            ) : (
                              'Save Changes'
                            )}
                          </LoadingButton>
                        )}

                        {/* Save & Next — Always shown when not disabled */}
                        <LoadingButton
                          type="button"
                          variant="soft"
                          sx={{
                            mr: 1,
                            color: '#026544',
                            bgcolor: '#77ed8b7a', // Optional, for consistent theming
                            '&:hover': {
                              bgcolor: 'success.light',
                            },
                          }}
                          disabled={isGenerating}
                          onClick={async () => {
                            setIsSavingNext(true);
                            setIsGenerating(true);
                            try {
                              await handleSaveNext();
                            } finally {
                              setIsGenerating(false);
                            }
                          }}
                        >
                          {isGenerating && isSavingNext ? (
                            <>
                              <CircularProgress size={20} sx={{ mr: 1, color: 'white' }} />
                              Saving...
                            </>
                          ) : (
                            'Save & Next'
                          )}
                        </LoadingButton>
                      </>
                    )}
                  </Box>
                )}
              </>
            </Grid>
          </FormProvider>

          <>
            {/* Only render the navigation buttons if "disabled" is true */}
            {disabled && (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end', // Align to the right
                  gap: 2,
                  mt: 4,
                }}
              >
                {/* Back Button */}
                {activeStep > 0 && (
                  <Button
                    variant="soft"
                    onClick={handleBack}
                    sx={{
                      color: '#00838f',
                      bgcolor: '#CAFDF5',
                      '&:hover': {
                        bgcolor: '#CAFDF5',
                      },
                    }}
                  >
                    Previous
                  </Button>
                )}

                {/* Next Button */}
                {activeStep !== steps.length - 1 && currentEmp && (
                  <Button
                    variant="soft"
                    onClick={handleNext}
                    sx={{
                      color: '#026544',
                      bgcolor: '#77ed8b7a',
                      '&:hover': {
                        bgcolor: 'success.light',
                      },
                    }}
                  >
                    Next
                  </Button>
                )}
              </Box>
            )}
          </>
          {activeStep === 0 && disabled && currentEmpView ? (
            <Button
              variant="soft"
              color="success"
              style={{ marginTop: '-85px' }}
              onClick={handleViewUploadedDocuments}
            >
              View Uploaded Documents
            </Button>
          ) : (
            currentEmp &&
            activeStep === 0 && (
              <Button
                variant="soft"
                color="success"
                style={{ marginTop: '-83px' }}
                onClick={() => handleUploadDocumentsEdit(currentEmp.employeeId)}
              >
                Upload Documents
              </Button>
            )
          )}
          <Dialog fullWidth maxWidth="xs" open={openDialog} onClose={() => setOpenDialog(false)}>
            <DialogTitle sx={{ pb: 2 }}>Upload Documents</DialogTitle>
            <DialogContent sx={{ typography: 'body2' }}>
              {currentEmp
                ? 'Would you like to upload new or edit existing documents?'
                : 'Would you like to upload documents for this employee now?'}
            </DialogContent>
            <DialogActions>
              <Button variant="soft" color="inherit" onClick={handleSkipUpload}>
                Skip
              </Button>
              <Button variant="soft" color="success" onClick={handleUploadDocuments}>
                Upload Documents
              </Button>
            </DialogActions>
          </Dialog>
        </Card>
      </Grid>
    </Grid>
  );
}
EmployeeNewEditForm.propTypes = {
  currentEmp: PropTypes.object,
  currentEmpFam: PropTypes.array,
  currentEmpPass: PropTypes.array,
  currentEmpBank: PropTypes.array,
  currentEmpEdu: PropTypes.array,
  currentEmpVisa: PropTypes.array,
  currentEmpCert: PropTypes.array,
  currentEmpWrk: PropTypes.array,
  currentEmpLang: PropTypes.array,
  currentEmpEmrg: PropTypes.array,
  currentEmpRef: PropTypes.array,
  currentEmpExp: PropTypes.array,
  currentEmpImpQ: PropTypes.array,
  currentEmpView: PropTypes.bool,
  disabled: PropTypes.bool,
};

// code modified on -5752 line on 17-04-2026
